import { jsxs as c, jsx as n, Fragment as $ } from "react/jsx-runtime";
import { createTheme as $0, ThemeProvider as A0, CssBaseline as F0, styled as l, Button as P, Tooltip as s2, IconButton as C2, FormControlLabel as p2, Checkbox as u2, Box as p, Typography as x, Collapse as O0, Dialog as c0, DialogTitle as G0, DialogContent as s0, Alert as g2, DialogActions as C0, ButtonBase as V0, InputBase as h2, ButtonGroup as f2, MenuItem as r0, Breadcrumbs as m2, Link as j0, Container as U0, alpha as N, Tabs as Z0, Tab as Y0, CircularProgress as b2, Popover as x2, Menu as y2, ListItemIcon as x0, ListItemText as y0, LinearProgress as k2, Avatar as v2 } from "@mui/material";
import { s as a, u as g, a as M, c as E, k as A, e as R, C as k0, b as e0, w as F, o as i0, d as a0, p as l0, f as w2, g as v0, h as Q, i as M2, P as _2, j as S2 } from "./PlaygroundNodes-B1J2GgG-.js";
import { P as Z, L as T2, a as P2 } from "./index-CkxPCnl7.js";
import E2 from "@mui/icons-material/Check";
import q0 from "@mui/icons-material/ArrowDropDownRounded";
import w from "react";
import { styled as I2 } from "@mui/material/styles";
import z2 from "@mui/material/Switch";
import B2 from "@mui/icons-material/Close";
import R2 from "@mui/icons-material/InsertDriveFileOutlined";
import L2 from "@mui/material/Button";
import { FileDrop as N2 } from "react-file-drop";
import { useTranslation as j } from "react-i18next";
import I from "clsx";
import { differenceInCalendarDays as X0, isAfter as H2, startOfDay as d0, startOfMonth as D2, subDays as w0 } from "date-fns";
import W2 from "@mui/icons-material/DeleteRounded";
import $2 from "@mui/icons-material/ChevronRight";
import { NavLink as p0, useLocation as A2, useResolvedPath as F2, useMatch as O2 } from "react-router-dom";
import { useDebounce as G2 } from "@uidotdev/usehooks";
import V2 from "@mui/icons-material/DownloadRounded";
import { ResponsiveContainer as j2, PieChart as U2, Pie as Z2, Cell as Y2, Tooltip as q2 } from "recharts";
import X2 from "@mui/icons-material/AccountCircle";
import { v4 as K2 } from "uuid";
import Q2 from "@mui/icons-material/CalendarMonthRounded";
import J2 from "@mui/icons-material/ChevronLeftRounded";
import e1 from "@mui/icons-material/ChevronRightRounded";
import o1 from "@mui/icons-material/OpenInNewRounded";
import { TRANSFORMERS as K0 } from "@lexical/markdown";
import { LexicalComposer as t1 } from "@lexical/react/LexicalComposer";
import { useLexicalComposerContext as n1 } from "@lexical/react/LexicalComposerContext";
import { ContentEditable as r1 } from "@lexical/react/LexicalContentEditable";
import i1 from "@lexical/react/LexicalErrorBoundary";
import { RichTextPlugin as a1 } from "@lexical/react/LexicalRichTextPlugin";
import M0 from "@mui/material/GlobalStyles";
import { $isParagraphNode as l1, $isTextNode as U, $getRoot as d1, $isElementNode as J, $isDecoratorNode as Q0, $isLineBreakNode as c1 } from "lexical";
import "@lexical/code";
import "@lexical/list";
import "@lexical/rich-text";
import { P as s1 } from "./Placeholder-p4UWlP66.js";
const C1 = {
  typography: {
    fontFamily: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
    h1: {
      color: a[800],
      fontWeight: 700,
      lineHeight: "40px",
      fontSize: 32
    },
    h2: {
      fontSize: "16px",
      lineHeight: "22px",
      color: a[400],
      textTransform: "uppercase",
      fontWeight: 700,
      marginTop: 32,
      marginBottom: 8
    }
  },
  palette: {
    background: {
      default: a[100]
    },
    primary: {
      light: g[300],
      main: g[500],
      dark: g[700]
    },
    secondary: {
      light: a[300],
      main: a[500],
      dark: a[800]
    },
    warning: {
      light: E[300],
      main: E[500],
      dark: E[700]
    },
    error: {
      light: M[300],
      main: M[500],
      dark: M[700]
    },
    success: {
      light: A[300],
      main: A[500],
      dark: A[700]
    }
  },
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          fontSize: 20,
          lineHeight: "32px"
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionStart: {
          marginLeft: 0,
          marginRight: 0
        },
        root: {
          color: a[400]
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          boxShadow: "none",
          color: a[800],
          backgroundColor: E[500],
          fontSize: 14,
          fontWeight: 600,
          padding: "10px 12px",
          lineHeight: "20px",
          "&:hover": {
            backgroundColor: E[600],
            boxShadow: "none"
          },
          "&:disabled": {
            color: a[800],
            backgroundColor: E[500],
            opacity: 0.2
          }
        },
        containedError: {
          color: M[100],
          backgroundColor: M[500],
          fontSize: 14,
          fontWeight: 600,
          padding: "10px 12px",
          lineHeight: "20px",
          "&:hover": {
            backgroundColor: M[600]
          },
          "&:disabled": {
            color: M[100],
            backgroundColor: M[500],
            opacity: 0.2
          }
        },
        containedPrimary: {
          color: a[100],
          backgroundColor: g[500],
          fontSize: 14,
          fontWeight: 600,
          padding: "10px 12px",
          lineHeight: "20px",
          "&:hover": {
            backgroundColor: g[600]
          },
          "&:disabled": {
            color: a[100],
            backgroundColor: g[500],
            opacity: 0.2
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontFamily: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
          textTransform: "none",
          letterSpacing: 0
        }
      },
      defaultProps: {
        style: {
          fontFamily: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
          textTransform: "none",
          letterSpacing: 0
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          "& .MuiTypography-subtitle1": {
            fontSize: 12,
            lineHeight: "16px",
            color: a[400],
            fontWeight: 600
          },
          "& .MuiFormLabel-root": {
            fontSize: 12,
            lineHeight: "16px",
            color: a[400],
            fontWeight: 600
          }
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1460,
      xl: 1736
    }
  }
}, J0 = $0(C1);
function ao(e) {
  const { children: o } = e;
  return /* @__PURE__ */ c(A0, { theme: J0, children: [
    /* @__PURE__ */ n(F0, {}),
    o
  ] });
}
function lo(e) {
  const { children: o, override: t } = e;
  return /* @__PURE__ */ c(A0, { theme: $0(J0, t), children: [
    /* @__PURE__ */ n(F0, {}),
    o
  ] });
}
const u0 = 64, p1 = l(P, {
  shouldForwardProp: (e) => e !== "tone"
})(({ tone: e }) => ({
  lineHeight: "16px",
  padding: "4px 8px",
  fontSize: 13,
  ...e === "value" && {
    backgroundColor: g[100],
    borderColor: g[300],
    color: g[600],
    fontWeight: 600
  },
  "& > .MuiTypography-root": {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontSize: "inherit",
    maxWidth: 300
  }
}));
function co(e) {
  const { tone: o = "default", ...t } = e;
  return /* @__PURE__ */ n(p1, { variant: "outlined", tone: o, ...t });
}
const g0 = l((e) => /* @__PURE__ */ n(
  Z,
  {
    ...e,
    pressingColor: M[700],
    disableElevation: !0
  }
))({
  color: a[100],
  backgroundColor: M[500],
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 12px",
  lineHeight: "20px",
  "&:hover": {
    backgroundColor: M[600]
  },
  "&:disabled": {
    color: M[100],
    backgroundColor: M[500],
    opacity: 0.2
  }
});
function so(e) {
  const {
    children: o,
    isLoading: t,
    onClick: r,
    disabled: i,
    ...d
  } = e;
  return /* @__PURE__ */ n(T2, { isLoading: t, children: /* @__PURE__ */ n(g0, { onClick: r, disabled: t || i, ...d, children: o }) });
}
const u1 = l(P, {
  shouldForwardProp: (e) => e !== "selected"
})(({ selected: e }) => ({
  textTransform: "none",
  fontSize: 14,
  width: "100%",
  justifyContent: "flex-start",
  color: e ? a[400] : a[800],
  backgroundColor: e ? "rgba(208,213,219,0.5)" : void 0
}));
function g1(e) {
  const { selected: o = !1, ...t } = e;
  return /* @__PURE__ */ n(u1, { selected: o, ...t });
}
const h1 = l(P, {
  shouldForwardProp: (e) => e !== "selected" && e !== "open"
})(({ selected: e, open: o }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  textTransform: "none",
  width: "100%",
  fontSize: 14,
  color: o ? a[400] : a[700],
  fontWeight: o ? 600 : void 0,
  ...e && !o ? {
    fontWeight: 600,
    color: g[500],
    backgroundColor: g[100],
    "&:hover": { backgroundColor: g[100] }
  } : {},
  "& svg": {
    color: a[700]
  },
  "&:disabled": {
    color: a[300],
    backgroundColor: a[100],
    "&:hover": { backgroundColor: a[100] }
  }
}));
function f1(e) {
  const { selected: o = !1, open: t = !1, ...r } = e;
  return /* @__PURE__ */ n(h1, { selected: o, open: t, ...r });
}
const e2 = l((e) => /* @__PURE__ */ n(
  Z,
  {
    ...e,
    pressingColor: a[300],
    disableElevation: !0
  }
))({
  color: a[500],
  backgroundColor: "transparent",
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 12px",
  lineHeight: "20px",
  "&:hover": {
    backgroundColor: a[100]
  }
}), m1 = l(P)({
  gap: 4,
  padding: 2,
  minWidth: 0,
  borderRadius: 4,
  "& > .MuiSvgIcon-root": {
    fontSize: 16
  }
});
function Co(e) {
  const { color: o = "primary", disableElevation: t = !0, ...r } = e;
  return /* @__PURE__ */ n(m1, { variant: "contained", color: o, disableElevation: t, ...r });
}
function po(e) {
  const { title: o, children: t, ...r } = e;
  return /* @__PURE__ */ n(s2, { title: o, children: /* @__PURE__ */ n("span", { children: /* @__PURE__ */ n(C2, { ...r, children: t }) }) });
}
function uo(e) {
  return /* @__PURE__ */ n(P, { variant: "outlined", color: "info", ...e });
}
const b1 = l(P, {
  shouldForwardProp: (e) => e !== "current"
})(({ current: e }) => ({
  backgroundColor: e ? g[100] : a[100],
  display: "flex",
  gap: 4,
  padding: "8px 16px",
  "& > img": {
    width: 24
  },
  "& > .MuiTypography-body1": {
    fontSize: 14,
    color: e ? g[500] : void 0,
    fontWeight: e ? 600 : void 0
  }
}));
function go(e) {
  const { current: o = !1, ...t } = e;
  return /* @__PURE__ */ n(b1, { current: o, ...t });
}
const x1 = l(P, {
  shouldForwardProp: (e) => e !== "tone"
})(({ tone: e }) => ({
  fontSize: 14,
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  color: e === "muted" ? a[600] : g[500],
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "underline"
  },
  "& svg": {
    fontSize: 16,
    marginRight: 4
  }
}));
function y1(e) {
  const { tone: o = "primary", ...t } = e;
  return /* @__PURE__ */ n(x1, { variant: "text", tone: o, ...t });
}
const k1 = l(P, {
  shouldForwardProp: (e) => e !== "open"
})(({ open: e }) => ({
  backgroundColor: e ? "white" : "transparent",
  color: e ? a[800] : "inherit",
  fontSize: 12,
  fontWeight: 600,
  padding: "6px 10px",
  minWidth: 0,
  minHeight: 32,
  lineHeight: "16px",
  gap: 6,
  textTransform: "none",
  "&:hover": {
    backgroundColor: e ? "white" : a[600]
  }
}));
function ho(e) {
  const { open: o = !1, ...t } = e;
  return /* @__PURE__ */ n(k1, { variant: "contained", disableElevation: !0, open: o, ...t });
}
const v1 = l(P, {
  shouldForwardProp: (e) => e !== "acknowledged"
})(({ acknowledged: e }) => ({
  padding: "12px 24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  flexGrow: 1,
  gap: 12,
  borderRadius: 0,
  width: "100%",
  backgroundColor: e ? "white" : g[100],
  "&:hover": {
    "& .newContent .MuiTypography-body1": {
      textDecoration: "underline"
    }
  }
}));
function fo(e) {
  const { acknowledged: o = !1, ...t } = e;
  return /* @__PURE__ */ n(v1, { acknowledged: o, ...t });
}
const G = l((e) => /* @__PURE__ */ n(
  Z,
  {
    ...e,
    pressingColor: a[300],
    disableElevation: !0,
    variant: "outlined"
  }
))({
  color: a[500],
  backgroundColor: "transparent",
  fontSize: 12,
  fontWeight: 600,
  padding: 8,
  lineHeight: "16px",
  borderColor: a[500],
  "&:hover": {
    backgroundColor: a[100]
  }
}), mo = l((e) => /* @__PURE__ */ n(
  Z,
  {
    ...e,
    pressingColor: E[700],
    disableElevation: !0
  }
))({
  color: a[800],
  backgroundColor: E[500],
  fontSize: 14,
  fontWeight: 600,
  padding: "10px 12px",
  lineHeight: "20px",
  "&:hover": {
    backgroundColor: E[600]
  },
  "&:disabled": {
    color: a[800],
    backgroundColor: E[500],
    opacity: 0.2
  }
}), w1 = l(P, {
  shouldForwardProp: (e) => e !== "active"
})(({ active: e }) => ({
  fontSize: 13,
  lineHeight: "16px",
  padding: "4px 8px",
  color: e ? "white" : g[500],
  backgroundColor: e ? g[500] : "white",
  "&:hover": {
    backgroundColor: e ? g[600] : g[100]
  }
}));
function M1(e) {
  const { active: o = !1, ...t } = e;
  return /* @__PURE__ */ n(w1, { variant: "outlined", active: o, ...t });
}
const _1 = l(P, {
  shouldForwardProp: (e) => e !== "selected"
})(({ theme: e, selected: o }) => ({
  justifyContent: "flex-start",
  textAlign: "left",
  textTransform: "none",
  padding: "8px 12px",
  border: `1px solid ${o ? e.palette.action.selected : e.palette.divider}`,
  backgroundColor: o ? e.palette.action.hover : e.palette.background.paper,
  color: e.palette.text.primary,
  "&:hover": {
    borderColor: e.palette.action.selected,
    backgroundColor: e.palette.action.hover
  }
}));
function bo(e) {
  const { selected: o = !1, ...t } = e;
  return /* @__PURE__ */ n(_1, { selected: o, ...t });
}
const S1 = l(P)({
  minWidth: "max-content",
  width: "max-content",
  label: {
    width: "max-content"
  }
}), _0 = {
  pending: { background: g[500], color: g[100] },
  done: { background: A[700], color: A[100] },
  inProgress: { background: E[600], color: g[100] },
  cancelled: { background: a[400], color: a[800] },
  denied: { background: M[100], color: M[600] }
}, T1 = l(P, {
  shouldForwardProp: (e) => e !== "status"
})(({ status: e }) => ({
  padding: "6px 6px 6px 12px",
  fontSize: 14,
  lineHeight: "14px",
  gap: 4,
  fontWeight: 600,
  backgroundColor: _0[e].background,
  color: _0[e].color,
  "& svg": {
    fontSize: 16
  }
}));
function xo(e) {
  const { status: o, ...t } = e;
  return /* @__PURE__ */ n(T1, { variant: "contained", disableElevation: !0, status: o, ...t });
}
const S0 = l((e) => /* @__PURE__ */ n(
  Z,
  {
    ...e,
    pressingColor: a[300],
    disableElevation: !0,
    fullWidth: !0
  }
))({
  color: a[500],
  backgroundColor: "transparent",
  fontSize: 12,
  fontWeight: 600,
  padding: 4,
  minWidth: 0,
  lineHeight: "16px",
  "&:hover": {
    backgroundColor: a[100]
  },
  "&:disabled": {
    color: a[500],
    backgroundColor: "transparent",
    opacity: 0.5
  }
}), P1 = l(P, {
  shouldForwardProp: (e) => e !== "active"
})(({ active: e }) => ({
  minWidth: 0,
  padding: 4,
  lineHeight: "16px",
  height: 20,
  width: 20,
  color: e ? g[500] : void 0,
  "& svg": {
    fontSize: 20
  },
  "&:hover": {
    backgroundColor: a[100],
    color: a[700]
  }
}));
function yo(e) {
  const { active: o = !1, ...t } = e;
  return /* @__PURE__ */ n(P1, { active: o, ...t });
}
const E1 = l(p2)({
  display: "flex",
  alignItems: "center",
  gap: 4,
  margin: 0,
  "& > .MuiButtonBase-root": {
    padding: 4,
    "& svg": {
      height: 20,
      width: 20
    }
  }
});
function ko(e) {
  const {
    value: o,
    setValue: t,
    disabled: r,
    ...i
  } = e;
  return /* @__PURE__ */ n(
    E1,
    {
      ...i,
      control: /* @__PURE__ */ n(
        u2,
        {
          checked: o,
          onChange: (d) => {
            t(d.target.checked);
          },
          disabled: r,
          color: "primary"
        }
      )
    }
  );
}
const I1 = l(p)(({ theme: e }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: e.spacing(1.5),
  "&.wide": {
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))"
  },
  "&.large": {
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))"
  },
  "& > .MuiBox-root.card": {
    borderRadius: 8,
    padding: e.spacing(1.5),
    border: `1px solid ${a[300]}`,
    cursor: "pointer",
    position: "relative",
    minHeight: 92,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "white",
    "&:hover": {
      borderColor: g[400],
      "& .card-icon": {
        backgroundColor: g[400],
        color: "white"
      }
    },
    "&.selected": {
      borderColor: g[500],
      backgroundColor: g[100],
      "& .card-icon": {
        backgroundColor: g[500],
        color: "white"
      }
    },
    "&.disabled": {
      opacity: 0.5,
      pointerEvents: "none"
    },
    "&.large": {
      borderRadius: 12,
      padding: e.spacing(2),
      minHeight: 120
    },
    "& > .MuiBox-root.card-content": {
      display: "flex",
      alignItems: "flex-start",
      gap: e.spacing(1.5),
      "& > .MuiBox-root.card": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: e.spacing(0.5),
        "& > .MuiTypography-subtitle2": {
          color: a[500],
          fontSize: 14,
          fontWeight: 600,
          lineHeight: "20px"
        },
        "&.large": {
          fontSize: 16,
          lineHeight: "24px"
        },
        "& > .MuiTypography-body2": {
          color: a[400],
          fontSize: 12,
          lineHeight: "17px",
          "&.large": {
            fontSize: 14,
            lineHeight: "20px"
          }
        }
      },
      "& > .MuiBox-root.card-icon": {
        width: 40,
        height: 40,
        minWidth: 40,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: a[100],
        color: a[500],
        "& .MuiSvgIcon-root": {
          fontSize: 20
        }
      }
    },
    "& > .MuiBox-root.card-check": {
      position: "absolute",
      top: e.spacing(1),
      right: e.spacing(1),
      width: 18,
      height: 18,
      borderRadius: "50%",
      backgroundColor: g[500],
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .MuiSvgIcon-root": {
        fontSize: 12
      },
      "&.large": {
        top: e.spacing(1.5),
        right: e.spacing(1.5),
        width: 20,
        height: 20
      }
    }
  }
}));
function vo(e) {
  const {
    options: o,
    value: t,
    onChange: r,
    className: i,
    disabled: d = !1,
    size: s = "regular"
  } = e;
  function C(u, m, h) {
    h || (u.key === "Enter" || u.key === " ") && (u.preventDefault(), r(m.value));
  }
  return /* @__PURE__ */ n(I1, { className: `${s}${i ? ` ${i}` : ""}`, role: "radiogroup", children: o.map((u) => {
    const m = u.value === t, h = d || !!u.disabled;
    return /* @__PURE__ */ c(
      p,
      {
        className: `card${m ? " selected" : ""}${h ? " disabled" : ""}`,
        role: "radio",
        tabIndex: h ? -1 : 0,
        "aria-checked": m,
        onClick: () => {
          h || r(u.value);
        },
        onKeyDown: (b) => {
          C(b, u, h);
        },
        children: [
          m && /* @__PURE__ */ n(p, { className: "card-check", children: /* @__PURE__ */ n(E2, {}) }),
          /* @__PURE__ */ c(p, { className: "card-content", children: [
            u.icon && /* @__PURE__ */ n(p, { className: "card-icon", children: u.icon }),
            /* @__PURE__ */ c(p, { className: "card", children: [
              /* @__PURE__ */ n(x, { variant: "subtitle2", children: u.label }),
              u.description && /* @__PURE__ */ n(x, { variant: "body2", children: u.description })
            ] })
          ] })
        ]
      },
      `${u.value}`
    );
  }) });
}
const z1 = l((e) => {
  const { expand: o, ...t } = e;
  return /* @__PURE__ */ n(q0, { ...t });
})(({ theme: e, expand: o }) => ({
  transform: o ? "rotate(180deg)" : "rotate(0deg)",
  marginLeft: "auto",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  })
}));
function wo(e) {
  const {
    options: o,
    select: t,
    current: r,
    label: i,
    render: d,
    disabled: s
  } = e, [C, u] = w.useState(!1), m = () => u(!C);
  function h(k) {
    t(k), u(!1);
  }
  const b = o.find((k) => k.id === (r ?? ""));
  return /* @__PURE__ */ c($, { children: [
    /* @__PURE__ */ c(
      f1,
      {
        onClick: m,
        selected: !!b && !C,
        open: C,
        disabled: o.length === 0 || s,
        children: [
          b ? d(b) : i,
          /* @__PURE__ */ n(z1, { expand: C, style: { color: a[700] } })
        ]
      }
    ),
    /* @__PURE__ */ c(O0, { in: C, timeout: "auto", unmountOnExit: !0, children: [
      /* @__PURE__ */ n("div", { style: { marginTop: 8 } }),
      o.map((k) => /* @__PURE__ */ n(
        g1,
        {
          selected: k.id === (r ?? ""),
          onClick: () => h(k),
          children: d(k)
        },
        k.id
      ))
    ] })
  ] });
}
const Mo = I2((e) => /* @__PURE__ */ n(z2, { focusVisibleClassName: ".Mui-focusVisible", disableRipple: !0, ...e }))(({ theme: e }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 3,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: g[500],
        opacity: 1,
        border: 0
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5
      }
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: a[600],
      border: "6px solid #fff"
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7
    }
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 20,
    height: 20
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: a[700],
    opacity: 1,
    transition: e.transitions.create(["background-color"], {
      duration: 300
    }),
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16
    },
    "&:before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        e.palette.getContrastText(e.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 3
    }
  },
  // sizeSmall
  "&.MuiSwitch-sizeSmall": {
    width: 32,
    height: 20,
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16
    },
    "& .MuiSwitch-track": {
      borderRadius: 20 / 2,
      "&:before, &:after": {
        width: 12,
        height: 12
      },
      "&:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          e.palette.getContrastText(e.palette.primary.main)
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 3
      }
    },
    "& .MuiSwitch-switchBase": {
      "&.Mui-checked": {
        transform: "translateX(12px)"
      },
      margin: 2
    }
  }
})), h0 = l(x)({
  color: M[500],
  fontSize: 12,
  lineHeight: "20px",
  marginTop: 4
});
function B1(e) {
  if (e < 1024) return `${e} B`;
  const o = Math.floor(Math.log(e) / Math.log(1024)), t = e / 1024 ** o, r = Math.round(t);
  return `${r < 10 ? t.toFixed(2) : r < 100 ? t.toFixed(1) : r.toFixed(0)} ${"KMGTPEZY"[o - 1]}B`;
}
const R1 = "data:image/svg+xml,%3csvg%20id='Layer_1'%20data-name='Layer%201'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20400%20300'%20width='406'%20height='306'%20class='illustration%20styles_illustrationTablet__1DWOa'%3e%3ctitle%3e%2316%20files%20and%20folders%3c/title%3e%3cpath%20d='M147.71,147.7H140.8v-2.76h6.91a3.44,3.44,0,1,0,0-6.88H140.8V135.3h6.91a6.2,6.2,0,1,1,0,12.4Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M147.71,147.7H140.8v-2.76h6.91a3.44,3.44,0,1,0,0-6.88H140.8V135.3h6.91a6.2,6.2,0,1,1,0,12.4Z'%20fill='%23fff'%20opacity='0.61'%3e%3c/path%3e%3cellipse%20cx='198.56'%20cy='256.99'%20rx='145.07'%20ry='20.18'%20fill='%23e6e6e6'%20opacity='0.45'%3e%3c/ellipse%3e%3cpath%20d='M288.75,95.62c-1.36,21.07-11.42,73.61-79.43,44.06l2.34-6.94s33.61,5.93,42.5-6.54c7.52-10.56,7.4-45.19,24-43.54A12.09,12.09,0,0,1,288.75,95.62Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M288.75,95.62c-1.36,21.07-11.42,73.61-79.43,44.06l2.34-6.94s33.61,5.93,42.5-6.54c7.52-10.56,7.4-45.19,24-43.54A12.09,12.09,0,0,1,288.75,95.62Z'%20opacity='0.08'%3e%3c/path%3e%3cpath%20d='M226.15,56.36s1.38,7.59,4,12.18a3.87,3.87,0,0,0,5.3,1.45c2.3-1.34,5-3.81,4.76-8l.45-7.11a6.91,6.91,0,0,0-4.89-6.33C230.72,46.71,225.08,51.78,226.15,56.36Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpolygon%20points='240.72%2057.22%20255.69%2072.33%20246.75%2082.04%20237.36%2063.98%20240.72%2057.22'%20fill='%23f4a28c'%3e%3c/polygon%3e%3cpath%20d='M235.8,60.58s-.73-2.88,1.48-3.25,3.29,3.79.47,5Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpath%20d='M227.27,61.1,226,64.53a1.24,1.24,0,0,0,1.25,1.67l3-.24Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpath%20d='M265.21,248.79s-2,3.65-5.53,3.41-5,3-2,4.41,11.74-1.42,11.74-1.42l.55-5.08Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M307.35,244.14s2.25,3.51.32,6.49.26,5.83,2.91,3.86,4.43-11,4.43-11l-4.19-2.93Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M238.87,66.88A15.54,15.54,0,0,0,240.18,62S246,67.38,242.1,73.1Z'%20fill='%23ce8172'%20opacity='0.31'%3e%3c/path%3e%3cpolygon%20points='263.46%20170.35%20263.03%20250.44%20273.39%20250.44%20286.65%20169.32%20263.46%20170.35'%20fill='%2324285b'%3e%3c/polygon%3e%3cpath%20d='M248.41,76.46a30.66,30.66,0,0,1,18.31-6.71c10.8-.11,40.92,1.74,38.86,38.58-1.53,27.3-2.31,57.5-2.31,57.5l-39.66,6.61S216.24,105.41,248.41,76.46Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M274.62,85.72s-8.31,10-3.17,28.28,12.36,40.33-12.4,51.41l4.56,7,39.66-6.61.52-16.88,6.37-31.26Z'%20opacity='0.08'%3e%3c/path%3e%3crect%20x='109.25'%20y='150.31'%20width='66.97'%20height='106.68'%20fill='%23a5a5a5'%20opacity='0.79'%3e%3c/rect%3e%3crect%20x='138.48'%20y='150.31'%20width='57.93'%20height='106.68'%20fill='%23e6e6e6'%3e%3c/rect%3e%3cpolygon%20points='179.8%20156.55%20178.74%20162.66%20150.3%20162.66%20150.3%20188.44%20197.6%20188.44%20197.6%20167.44%20197.6%20162.66%20197.6%20156.55%20179.8%20156.55'%20fill='%23ffd200'%3e%3c/polygon%3e%3cpolygon%20points='179.8%20156.55%20178.74%20162.66%20150.3%20162.66%20150.3%20188.44%20197.6%20188.44%20197.6%20167.44%20197.6%20162.66%20197.6%20156.55%20179.8%20156.55'%20opacity='0.08'%3e%3c/polygon%3e%3cpolygon%20points='186.71%20156.55%20185.65%20162.66%20157.21%20162.66%20157.21%20188.44%20204.51%20188.44%20204.51%20167.44%20204.51%20162.66%20204.51%20156.55%20186.71%20156.55'%20fill='%23ffd200'%3e%3c/polygon%3e%3cpolygon%20points='262.98%20121.07%20264.92%20128.28%20238.78%20139.49%20251.07%20168.14%20294.55%20149.49%20284.54%20126.16%20282.26%20120.84%20279.34%20114.05%20262.98%20121.07'%20fill='%23ffd200'%3e%3c/polygon%3e%3cpolygon%20points='262.98%20121.07%20264.92%20128.28%20238.78%20139.49%20251.07%20168.14%20294.55%20149.49%20284.54%20126.16%20282.26%20120.84%20279.34%20114.05%20262.98%20121.07'%20opacity='0.08'%3e%3c/polygon%3e%3cpolygon%20points='269.33%20118.34%20271.27%20125.56%20245.13%20136.76%20257.42%20165.41%20300.89%20146.77%20290.89%20123.43%20288.61%20118.12%20285.69%20111.33%20269.33%20118.34'%20fill='%23ffd200'%3e%3c/polygon%3e%3cpolygon%20points='192.42%20156.55%20191.36%20162.66%20162.93%20162.66%20162.93%20188.44%20210.23%20188.44%20210.23%20167.44%20210.23%20162.66%20210.23%20156.55%20192.42%20156.55'%20fill='%23ffd200'%3e%3c/polygon%3e%3cpolygon%20points='192.42%20156.55%20191.36%20162.66%20162.93%20162.66%20162.93%20188.44%20210.23%20188.44%20210.23%20167.44%20210.23%20162.66%20210.23%20156.55%20192.42%20156.55'%20opacity='0.08'%3e%3c/polygon%3e%3crect%20x='164.12'%20y='151.56'%20width='44.91'%20height='30.55'%20transform='translate(-22.09%2028.62)%20rotate(-8.28)'%20fill='%2324285b'%3e%3c/rect%3e%3crect%20x='164.12'%20y='151.56'%20width='44.91'%20height='30.55'%20transform='translate(-22.09%2028.62)%20rotate(-8.28)'%20fill='%23fff'%20opacity='0.12'%3e%3c/rect%3e%3crect%20x='166.45'%20y='147.23'%20width='44.91'%20height='30.55'%20transform='translate(-21.44%2028.91)%20rotate(-8.28)'%20fill='%2324285b'%3e%3c/rect%3e%3cpolygon%20points='199.33%20156.55%20198.27%20162.66%20169.84%20162.66%20169.84%20188.44%20217.14%20188.44%20217.14%20167.44%20217.14%20162.66%20217.14%20156.55%20199.33%20156.55'%20fill='%23ffd200'%3e%3c/polygon%3e%3crect%20x='147.65'%20y='170.37'%20width='74.54'%20height='29.1'%20fill='%23a5a5a5'%3e%3c/rect%3e%3cpath%20d='M291.13,124a212.24,212.24,0,0,1-14,16.27,63.78,63.78,0,0,1-12.67,9.92c-2.69,1.65-5.52,4.59-3.62,9.19h14.81L295,133.13Z'%20opacity='0.08'%3e%3c/path%3e%3crect%20x='171.16'%20y='170.37'%20width='51.02'%20height='29.1'%20fill='%23f2f2f2'%3e%3c/rect%3e%3crect%20x='147.65'%20y='212.92'%20width='59.02'%20height='29.1'%20fill='%23f2f2f2'%3e%3c/rect%3e%3crect%20x='128.38'%20y='132.3'%20width='16.89'%20height='18.4'%20fill='%23ffffff'%3e%3c/rect%3e%3ccircle%20cx='197.57'%20cy='183.75'%20r='4.09'%20fill='%23a5a5a5'%3e%3c/circle%3e%3ccircle%20cx='178.04'%20cy='226.31'%20r='4.09'%20fill='%23a5a5a5'%3e%3c/circle%3e%3cpath%20d='M211.23,134a22.16,22.16,0,0,0-8.26,1.25c-4.43,1.56-8.53,5.51-5.37,10.13,2.44,3.56,5.9,1.72,7.19-1.13s2.07-5.61,4.53-4.57Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpath%20d='M288.48,74.53a51.74,51.74,0,0,1,29,27.08,36.4,36.4,0,0,1-1.09,33.21c-5.87,10.26-17.9,21.77-42.57,26.75l-2.87-7.21,23.56-20.69a12.18,12.18,0,0,0,.58-17.79c-7-7-15.9-17.3-19.91-28.17A10.3,10.3,0,0,1,288.48,74.53Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpath%20d='M288.48,74.53a51.74,51.74,0,0,1,29,27.08,36.4,36.4,0,0,1-1.09,33.21c-5.87,10.26-17.9,21.77-42.57,26.75l-2.87-7.21,23.56-20.69a12.18,12.18,0,0,0,.58-17.79c-7-7-15.9-17.3-19.91-28.17A10.3,10.3,0,0,1,288.48,74.53Z'%20fill='%23fff'%20opacity='0.2'%3e%3c/path%3e%3cpath%20d='M271.45,155.7s-11-1.2-12,3-1.68,6.74-1.68,6.74a30.1,30.1,0,0,0,15.66-4.82Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpath%20d='M303.27,165.83a104.78,104.78,0,0,1,.18,15.38c-.27,6.31-1.91,16.82-3.15,24.09A23.22,23.22,0,0,0,303,220.6l10,17.79-7.26,7.24-11.91-15.48a64.88,64.88,0,0,1-12.16-27l-3.79-19.34-9.55-12.14Z'%20fill='%2324285b'%3e%3c/path%3e%3cpath%20d='M221.75,47.33s-3.09,7.14,4.29,7.49,7.29-1.15,7.29-1.15.46,9.54,6.85,8.35l2.65-2.68s3-12.17-2.2-14.84C240.63,44.5,230.25,33.83,221.75,47.33Z'%20fill='%2324285b'%3e%3c/path%3e%3cpath%20d='M235.68,61.73s.39-6.22,3.89-4.67S240.76,65.39,235.68,61.73Z'%20fill='%23f4a28c'%3e%3c/path%3e%3cpath%20d='M140.8,132.3s11.89-7.63,0-18.3-16.55,14-25.22-2.67,13.33-34.66-11-36S95.47,58.62,74.52,56.81,47.91,92.11,63.91,94.56s31.34,3.44,27,18.77,12,19.5,19.67,15.75,17.8,3.22,17.8,3.22Z'%20fill='%23e6e6e6'%20opacity='0.45'%3e%3c/path%3e%3cpath%20d='M98,242s-11.85-3.18-14.47-14.18c0,0,18.32-3.78,18.92,15.14Z'%20fill='%23ffffff'%20opacity='0.58'%3e%3c/path%3e%3cpath%20d='M99.46,240.78s-8.32-13-1.1-25.28c0,0,14,8.79,7.86,25.28Z'%20fill='%23ffffff'%20opacity='0.73'%3e%3c/path%3e%3cpath%20d='M101.59,240.78s4.31-13.82,17.5-16.49c0,0,2.52,9-8.48,16.49Z'%20fill='%23ffffff'%3e%3c/path%3e%3cpolygon%20points='93.01%20240.51%2095.48%20256.91%20110.58%20256.91%20112.74%20240.51%2093.01%20240.51'%20fill='%2324285b'%3e%3c/polygon%3e%3c/svg%3e", L1 = l(c0)({
  "& .MuiDialogContent-root": {
    "& .MuiAlert-root": {
      padding: "0px 8px",
      marginTop: 4,
      fontWeight: 600
    },
    "& .MuiTypography-subtitle1": {
      marginTop: 8,
      marginBottom: 4,
      marginLeft: 4,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "16px",
      color: a[400]
    },
    "& .hidden": {
      display: "none"
    },
    "& .file-summary": {
      display: "flex",
      gap: 12,
      "& svg": {
        display: "block",
        color: g[500],
        fontSize: 36
      },
      "& .MuiTypography-root": {
        fontSize: 12,
        "&.MuiTypography-body2": {
          fontWeight: 700
        }
      },
      "& .MuiButton-root": {
        padding: "4px 8px",
        minWidth: 0,
        fontSize: 16,
        "& svg": {
          fontSize: "inherit"
        }
      }
    },
    "& .file-drop-target": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: g[500],
      borderRadius: 4,
      "&.file-drop-dragging-over-frame": {
        opacity: 0.9,
        "&.file-drop-dragging-over-target": {
          opacity: 1,
          boxShadow: `0px 4px 8px -2px ${a[400]}, 0px 2px 4px -2px ${a[400]}`
        }
      },
      "& img": {
        width: 164,
        height: 164
      },
      "& .MuiBox-root": {
        color: "white",
        width: 368,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiTypography-h4": {
          fontWeight: 700,
          fontSize: 24,
          lineHeight: "48px"
        },
        "& .MuiButton-root": {
          fontSize: 12,
          margin: "0px 4px",
          padding: "4px 8px"
        }
      }
    }
  }
});
function _o(e) {
  const {
    onClose: o,
    open: t,
    datasetFile: r,
    setDatasetFile: i,
    validFileExtensions: d,
    url: s,
    upload: C
  } = e, [u, m] = w.useState(!1), { t: h } = j("common"), { t: b } = j("decision-tree"), k = r && !d.includes(r.name.split(".").pop()?.toLowerCase() ?? "");
  function f() {
    i(void 0), o(), m(!1);
  }
  w.useEffect(() => {
    u && setTimeout(() => {
      setTimeout(f, 1e3);
    }, 4e3);
  }, [u]);
  const y = w.useRef(null), _ = () => {
    y.current?.click();
  };
  return /* @__PURE__ */ c(
    L1,
    {
      open: !!t,
      onClose: () => {
        f();
      },
      maxWidth: "sm",
      fullWidth: !0,
      children: [
        /* @__PURE__ */ n(G0, { children: b("node.editor.document-link.upload.title") }),
        /* @__PURE__ */ n(s0, { children: /* @__PURE__ */ c($, { children: [
          /* @__PURE__ */ n(
            "input",
            {
              onChange: (S) => {
                const { files: T } = S.target;
                i(T?.[0]);
              },
              ref: y,
              type: "file",
              className: "hidden"
            }
          ),
          r ? /* @__PURE__ */ c($, { children: [
            /* @__PURE__ */ c(p, { className: "file-summary", children: [
              /* @__PURE__ */ n(R2, {}),
              /* @__PURE__ */ c(p, { children: [
                /* @__PURE__ */ n(x, { children: r.name }),
                /* @__PURE__ */ n(x, { variant: "body2", children: B1(r.size) })
              ] }),
              /* @__PURE__ */ n(P, { variant: "text", color: "primary", onClick: () => {
                i(void 0);
              }, children: /* @__PURE__ */ n(B2, {}) })
            ] }),
            k && /* @__PURE__ */ n(g2, { severity: "error", children: b("node.editor.document-link.upload.not-supported") })
          ] }) : /* @__PURE__ */ c(
            N2,
            {
              onTargetClick: _,
              onDrop: (S, T) => {
                T.preventDefault(), i(S?.[0]);
              },
              children: [
                /* @__PURE__ */ n("img", { src: R1, alt: "someone browsing files" }),
                /* @__PURE__ */ c(p, { children: [
                  /* @__PURE__ */ n(x, { variant: "h4", children: b("node.editor.document-link.upload.drag-drop") }),
                  /* @__PURE__ */ c("div", { children: [
                    b("node.editor.document-link.upload.or"),
                    /* @__PURE__ */ n(P, { variant: "outlined", color: "inherit", children: b("node.editor.document-link.upload.click") }),
                    b("node.editor.document-link.upload.select")
                  ] })
                ] })
              ]
            }
          ),
          s?.error && /* @__PURE__ */ n(h0, { children: s?.error.message })
        ] }) }),
        /* @__PURE__ */ c(C0, { children: [
          /* @__PURE__ */ n(
            L2,
            {
              color: "primary",
              variant: "contained",
              disabled: !r || !s?.value,
              loading: C.loading || s?.loading,
              onClick: () => {
                o(), C.mutate();
              },
              children: h("save")
            }
          ),
          /* @__PURE__ */ n(P, { onClick: () => f(), variant: "outlined", color: "info", children: h("cancel") })
        ] })
      ]
    }
  );
}
const N1 = l(p)({
  display: "flex",
  gap: 6,
  flexWrap: "wrap"
}), H1 = l(p)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
  // CogNeedTextField drops the outlined border and keeps its hover fill, so a
  // disabled one is otherwise indistinguishable from an editable one -- and under
  // a preset both date fields are disabled, which is the common case rather than
  // the edge one. Mute the value and the icon and stop the hover, so "these are a
  // receipt of what the preset resolved to" is legible without reading the caption.
  // A period under a preset is a receipt of what the preset resolved to, and has
  // to read as one: CogNeedTextField drops the outlined border and keeps its hover
  // fill, so left alone it looks exactly as editable as it does under 'custom'.
  //
  // The calendar button goes rather than dims -- there is no picker to open, so a
  // greyed-out affordance would just be a thing to click at. Text drops one step
  // to spaceCadet[450] instead of all the way to [400], because the dates are
  // still the answer being reported, not disabled chrome.
  "&.locked": {
    "& .MuiTextField-root": {
      backgroundColor: a[100],
      "&:hover": {
        backgroundColor: a[100]
      }
    },
    // -webkit-text-fill-color as well as color: that is what MUI sets on a truly
    // disabled input, so anything less specific loses to it there.
    "& .MuiInputBase-input": {
      color: a[450],
      WebkitTextFillColor: a[450],
      cursor: "default"
    },
    "& .MuiInputAdornment-root": {
      display: "none"
    }
  }
}), D1 = l(p)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  minHeight: 24
}), W1 = l(x)({
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 600,
  color: a[400]
}), $1 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 6
}), A1 = l(x)({
  fontSize: 12,
  lineHeight: "16px",
  color: a[400],
  "&.invalid": {
    color: R.foreground
  }
}), F1 = l(V0)({
  padding: "3px 10px",
  borderRadius: 999,
  border: `1px solid ${a[300]}`,
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 400,
  color: a[500],
  "&:hover": {
    borderColor: a[400]
  },
  // The full brand blue on the border, not a tint of it: the selected preset is
  // the one thing this row has to say, and at ultraMarine[300] it does not carry
  // across four otherwise identical capsules.
  "&.selected": {
    backgroundColor: g[100],
    borderColor: g[500],
    color: g[600],
    fontWeight: 600
  },
  "&.Mui-disabled": {
    opacity: 0.5
  }
}), o2 = {
  last7: "7 days",
  last30: "30 days",
  thisMonth: "This month",
  custom: "Custom",
  from: "From",
  to: "To",
  dayCount: (e) => `${e} days`,
  lockedHint: (e) => `${e} days · choose Custom to edit the dates`,
  reversed: "“To” is before “From”.",
  future: "The period cannot end in the future.",
  incomplete: "Pick both dates."
};
function O1(e, o = /* @__PURE__ */ new Date()) {
  const t = d0(o);
  switch (e) {
    // Inclusive of today, so "7 days" spans today and the six before it -- the
    // same count `periodDayCount` reports back for that range.
    case "last7":
      return { from: w0(t, 6), to: t };
    case "last30":
      return { from: w0(t, 29), to: t };
    case "thisMonth":
      return { from: D2(t), to: t };
    default:
      return null;
  }
}
function G1(e) {
  const { from: o, to: t } = e;
  return !o || !t ? null : X0(t, o) + 1;
}
function V1(e, o) {
  const { from: t, to: r } = e;
  return !t || !r ? "incomplete" : X0(r, t) < 0 ? "reversed" : o && H2(d0(r), d0(o)) ? "future" : "valid";
}
const j1 = ["last7", "last30", "thisMonth", "custom"];
function T0(e) {
  const {
    value: o,
    onChange: t,
    disabled: r,
    today: i,
    strings: d
  } = e, s = { ...o2, ...d };
  return /* @__PURE__ */ n(N1, { children: j1.map((C) => /* @__PURE__ */ n(
    F1,
    {
      className: I({ selected: o.preset === C }),
      disabled: r,
      onClick: () => {
        const u = O1(C, i);
        t(u ? { preset: C, ...u } : { ...o, preset: C });
      },
      children: s[C]
    },
    C
  )) });
}
function So(e) {
  const {
    value: o,
    onChange: t,
    label: r,
    presets: i = "inline",
    disabled: d,
    maxDate: s,
    minDate: C,
    today: u,
    strings: m
  } = e, h = { ...o2, ...m }, b = s ?? u ?? /* @__PURE__ */ new Date(), k = V1(o, b), f = G1(o), y = o.preset !== "custom", _ = y && !d, S = y || !!d, T = k === "reversed" || k === "future", H = () => k === "reversed" ? h.reversed : k === "future" ? h.future : f === null ? h.incomplete : S ? h.lockedHint(f) : h.dayCount(f);
  return /* @__PURE__ */ c($1, { children: [
    i === "inline" && (r ? /* @__PURE__ */ c(D1, { children: [
      /* @__PURE__ */ n(W1, { children: r }),
      /* @__PURE__ */ n(
        T0,
        {
          value: o,
          onChange: t,
          disabled: d,
          today: u,
          strings: m
        }
      )
    ] }) : /* @__PURE__ */ n(
      T0,
      {
        value: o,
        onChange: t,
        disabled: d,
        today: u,
        strings: m
      }
    )),
    /* @__PURE__ */ c(H1, { className: I({ locked: S }), children: [
      /* @__PURE__ */ n(
        k0,
        {
          label: h.from,
          value: o.from,
          disabled: !!d,
          readOnly: _,
          disableOpenPicker: _,
          maxDate: b,
          minDate: C,
          onChange: (z) => t({ ...o, from: z }),
          slotProps: { textField: { error: T, fullWidth: !0 } }
        }
      ),
      /* @__PURE__ */ n(
        k0,
        {
          label: h.to,
          value: o.to,
          disabled: !!d,
          readOnly: _,
          disableOpenPicker: _,
          maxDate: b,
          minDate: C,
          onChange: (z) => t({ ...o, to: z }),
          slotProps: { textField: { error: T, fullWidth: !0 } }
        }
      )
    ] }),
    /* @__PURE__ */ n(A1, { className: I({ invalid: T }), children: H() })
  ] });
}
const t2 = "ui-monospace, Menlo, monospace", U1 = l(p)({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${a[300]}`,
  borderRadius: 4
}), Z1 = l(p)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  padding: "8px 8px 0 12px",
  minHeight: 38
}), Y1 = l(x)({
  fontSize: 14,
  lineHeight: "20px",
  fontWeight: 600,
  color: a[500]
}), P0 = l(p)({
  flex: "none",
  display: "inline-flex"
}), q1 = l(x)({
  padding: "0 12px 8px",
  fontSize: 12,
  lineHeight: "16px",
  color: a[400]
}), X1 = l(p)({
  display: "flex",
  flexWrap: "wrap",
  gap: 6,
  padding: "0 12px 10px"
}), K1 = l(x)({
  padding: "2px 7px",
  borderRadius: 3,
  fontFamily: t2,
  fontSize: 12,
  lineHeight: "16px",
  // Stated rather than inherited: a tag is a literal string to match character for
  // character, and emphasis on all six of them at once emphasises nothing.
  fontWeight: 400,
  backgroundColor: e0.background,
  color: e0.foreground,
  border: `1px solid ${e0.border}`,
  "&.missing": {
    backgroundColor: R.background,
    color: R.foreground,
    border: `1px solid ${R.border}`
  }
}), Q1 = l(p)({
  display: "flex",
  flexDirection: "column",
  borderTop: `1px solid ${a[200]}`,
  backgroundColor: a[100]
}), J1 = l(h2)({
  padding: "10px 12px",
  "& .MuiInputBase-inputMultiline": {
    fontFamily: t2,
    fontSize: 13,
    lineHeight: 1.5,
    color: a[500],
    resize: "vertical"
  }
}), ee = l(p)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  padding: "6px 12px 10px",
  borderTop: `1px solid ${a[200]}`
}), oe = l(x)({
  fontSize: 12,
  lineHeight: "16px",
  color: a[400],
  "&.missing": {
    color: R.foreground
  }
}), te = {
  edit: "Edit",
  done: "Done",
  reset: "Reset to default",
  pristine: "Default prompt",
  edited: "Default prompt, edited",
  tagsPresent: "required tags present",
  tagsMissing: (e) => `${e} required tag${e > 1 ? "s" : ""} missing`,
  keepTagsHint: "Tags between <%= %> are replaced at run time. Keep them.",
  missingMessage: (e) => `Missing: ${e.join(", ")} — the run can't launch without ${e.length > 1 ? "them" : "it"}.`
};
function ne(e, o) {
  return o.filter((t) => !e.includes(t));
}
function To(e) {
  const {
    label: o,
    value: t,
    defaultValue: r,
    requiredTags: i,
    onChange: d,
    defaultOpen: s = !1,
    rows: C = 12,
    disabled: u,
    strings: m
  } = e, h = { ...te, ...m }, [b, k] = w.useState(s), f = ne(t, i), y = t !== r, _ = f.length ? h.tagsMissing(f.length) : h.tagsPresent;
  return /* @__PURE__ */ c(U1, { children: [
    /* @__PURE__ */ c(Z1, { children: [
      /* @__PURE__ */ n(Y1, { children: o }),
      /* @__PURE__ */ n(P0, { children: /* @__PURE__ */ n(S0, { onClick: () => k(!b), disabled: u, children: b ? h.done : h.edit }) })
    ] }),
    /* @__PURE__ */ n(q1, { children: `${y ? h.edited : h.pristine} · ${_}` }),
    i.length > 0 && (b || f.length > 0) && /* @__PURE__ */ n(X1, { children: i.map((S) => /* @__PURE__ */ n(K1, { className: I({ missing: f.includes(S) }), children: S }, S)) }),
    b && /* @__PURE__ */ c(Q1, { children: [
      /* @__PURE__ */ n(
        J1,
        {
          multiline: !0,
          rows: C,
          value: t,
          disabled: u,
          spellCheck: !1,
          onChange: (S) => d(S.target.value)
        }
      ),
      /* @__PURE__ */ c(ee, { children: [
        /* @__PURE__ */ n(oe, { className: I({ missing: f.length > 0 }), children: f.length ? h.missingMessage(f) : h.keepTagsHint }),
        /* @__PURE__ */ n(P0, { children: /* @__PURE__ */ n(
          S0,
          {
            onClick: () => d(r),
            disabled: u || !y,
            children: h.reset
          }
        ) })
      ] })
    ] })
  ] });
}
const re = l(p)({
  display: "flex",
  gap: 8,
  padding: "8px 0px",
  "& > .MuiButton-root": {
    minWidth: 0,
    padding: "4px 8px",
    fontSize: 13,
    lineHeight: "16px"
  }
}), ie = l(p)(() => ({
  borderLeft: `solid 1px ${a[300]}`,
  backgroundColor: "white",
  "& > .wrapper": {
    borderRadius: 4,
    padding: "4px 8px 4px 8px",
    gap: 4,
    display: "flex",
    flexDirection: "column",
    "& > .MuiBox-root.children": {
      backgroundColor: a[100],
      borderRadius: 4,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      padding: "8px 12px"
    },
    "& > .MuiBox-root.header": {
      display: "flex",
      flexDirection: "row",
      padding: "4px 0px",
      gap: 8,
      "& > .MuiButtonGroup-root": {
        "& > .MuiButton-root": {
          fontSize: 13,
          lineHeight: "16px",
          padding: "4px 8px",
          "& > .MuiButton-root": {
            fontSize: 13,
            lineHeight: "16px",
            padding: "4px 8px"
          }
        }
      },
      "& > .MuiBox-root.actions": {
        display: "flex",
        gap: 4,
        "& > .MuiButton-root": {
          fontSize: 13,
          lineHeight: "16px",
          padding: "4px 8px",
          "&.iconButton": {
            padding: 4,
            fontSize: 16,
            minWidth: 0,
            "& svg": {
              fontSize: "inherit"
            }
          }
        }
      },
      "& .MuiButton-root.active": {
        color: g[500],
        backgroundColor: "white",
        "&.active": {
          color: "white",
          backgroundColor: g[500]
        }
      }
    }
  },
  "& .flexGrow": {
    flexGrow: 1
  },
  "& .MuiTypography-body2": {
    fontStyle: "italic",
    fontSize: 14
  }
})), ae = ["And", "Or", "Not"];
function le(e) {
  const {
    condition: o,
    parentId: t,
    onAddRule: r,
    onAddGroup: i,
    addGroupLoadingParentId: d,
    onChangeGroupType: s,
    changingGroupType: C,
    onRemoveNode: u,
    renderLeaf: m,
    labels: h
  } = e;
  if (!o) {
    const y = d === (t ?? null);
    return /* @__PURE__ */ c(re, { children: [
      /* @__PURE__ */ n(G, { onClick: (_) => r(t, _.currentTarget), children: h.addRule }),
      /* @__PURE__ */ n(G, { loading: y, onClick: () => i(t), children: h.addGroup })
    ] });
  }
  if (o.__typename === "Leaf")
    return /* @__PURE__ */ n($, { children: m(o) });
  const { children: b } = o, k = b.length === 1 && o.__typename === "Not", f = d === o.id;
  return /* @__PURE__ */ n(ie, { title: h.groupExplanationTooltip(o.__typename), children: /* @__PURE__ */ c(p, { className: "wrapper", children: [
    /* @__PURE__ */ c(p, { className: "header", children: [
      /* @__PURE__ */ n(f2, { size: "small", "aria-label": "condition group type", color: "primary", children: ae.map((y) => /* @__PURE__ */ n(
        M1,
        {
          active: o.__typename === y,
          disabled: y === "Not" && b.length > 1,
          title: o.__typename === y ? void 0 : h.groupCtaTooltip(y),
          loading: C?.conditionId === o.id && C.type === y,
          onClick: () => s(o.id, y),
          children: h.groupName(y)
        },
        y
      )) }),
      /* @__PURE__ */ n(p, { className: "flexGrow" }),
      /* @__PURE__ */ c(p, { className: "actions", children: [
        !k && /* @__PURE__ */ c($, { children: [
          /* @__PURE__ */ n(G, { onClick: (y) => r(o.id, y.currentTarget), children: h.addRule }),
          /* @__PURE__ */ n(G, { loading: f, onClick: () => i(o.id), children: h.addGroup })
        ] }),
        /* @__PURE__ */ n(
          S1,
          {
            onClick: () => u(o.id),
            variant: "outlined",
            title: h.remove,
            className: "iconButton",
            color: "error",
            children: /* @__PURE__ */ n(W2, {})
          }
        )
      ] })
    ] }),
    b.length > 0 ? /* @__PURE__ */ n(p, { className: "children", children: b.map((y) => /* @__PURE__ */ n(
      le,
      {
        condition: y,
        parentId: o.id,
        onAddRule: r,
        onAddGroup: i,
        addGroupLoadingParentId: d,
        onChangeGroupType: s,
        changingGroupType: C,
        onRemoveNode: u,
        renderLeaf: m,
        labels: h
      },
      y.id
    )) }) : /* @__PURE__ */ n(x, { variant: "body2", children: h.groupEmpty })
  ] }) });
}
const Po = l(p)(() => ({
  display: "flex",
  flexDirection: "row",
  padding: "4px 8px",
  gap: 8,
  borderRadius: 4,
  alignItems: "center",
  // A "dans" (multi) CallStatus row: its chipsWrap can wrap onto a second line, and
  // centering the row would then float the field chip/operator/delete-icon in the middle
  // of that two-line block instead of level with its first line. Single-value rows never
  // wrap, so they keep the plain center alignment above.
  "&.multiValue": {
    alignItems: "flex-start"
  },
  "& > .MuiButton-root": {
    // Every direct-child button (fieldChip, a tone="value" chip, operatorButton,
    // iconButton...) needs to compute to the exact same height, or align-items: center
    // visibly misplaces one of them. ChipSelectButton (tone="value" included -- `tone`
    // isn't forwarded to the DOM, so it can't be targeted by class) carries its own
    // built-in padding/line-height from this package, at a specificity/insertion order
    // this rule cannot reliably out-rank; an explicit height always wins over either
    // side's intrinsic content-box sizing, so it's the only way to guarantee every
    // button in this row actually matches -- not just the ones with their own class.
    height: 26,
    boxSizing: "border-box",
    lineHeight: "16px",
    padding: "4px 8px",
    fontSize: 13,
    "& > .MuiTypography-root": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      fontSize: "inherit",
      // Typography sets its own font-weight from the theme's body variant by default,
      // which silently overrides whatever weight the enclosing button class asks for
      // (e.g. .fieldChip's 600) -- inherit so the button's own weight always wins.
      fontWeight: "inherit",
      maxWidth: 300
    },
    "&.iconButton": {
      padding: 4,
      fontSize: 16,
      minWidth: 0,
      "& svg": {
        fontSize: "inherit"
      }
    },
    // The field-name chip every row type opens its rule-type picker from (e.g. "Statut
    // d'appel", "Durée de session"). Flat and neutral per the mockup -- overrides
    // ChipSelectButton's own outlined-button border/radius/color, which reads as more
    // "generic MUI" than the design's plain bordered box.
    "&.fieldChip": {
      backgroundColor: "#fff",
      borderColor: a[300],
      borderRadius: 3,
      color: a[500],
      fontWeight: 600,
      "&:hover": {
        borderColor: g[500]
      }
    },
    // The operator ("est"/"dans") dropdown button on a CallStatus row -- a neutral pill
    // that opens the operatorMenu below. Inherits this block's own & > .MuiButton-root
    // sizing (13px, 4px 8px padding), only the fill color is its own.
    "&.operatorButton": {
      backgroundColor: "#fff",
      border: `1px solid ${a[300]}`,
      borderRadius: 3,
      color: a[500],
      fontWeight: 600,
      gap: 6,
      "&:hover": {
        borderColor: g[500]
      },
      "& .chevron": {
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 1,
        color: a[400]
      }
    }
  },
  "& .flexGrow": {
    flexGrow: 1
  },
  // CallStatus row only: the value-chips + "+ Ajouter" + meta-count group, and its two
  // pieces that aren't a Button (Menu/MenuItem are styled separately -- portalled, so this
  // block's nesting can't reach them).
  "& .chipsWrap": {
    flex: 1,
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    alignItems: "center",
    minWidth: 0,
    // The "x" remove mark on a value chip -- a bare SvgIcon with an onClick, not a
    // Button/ButtonBase, so it doesn't get MUI's usual pointer cursor for free.
    "& .MuiSvgIcon-root": {
      cursor: "pointer"
    },
    // Same explicit-height rationale as .fieldChip/.operatorButton above -- this button
    // sits in the same visual row and needs to match them exactly, not just its siblings.
    "& .addMoreButton": {
      height: 26,
      boxSizing: "border-box"
    }
  },
  // The "answer" chip -- CallStatus's status(es), MinDuration's duration, RefValue's
  // boolean/string answer: the thing actually being measured, as opposed to a chip that
  // just selects an entity (RefValue's referenced item, Context's context -- those stay
  // plain tone="value", bold included). Descendant selector so it reaches both a direct
  // child (MinDuration, RefValue) and one nested in .chipsWrap (CallStatus). fontWeight
  // overrides ChipSelectButton's own tone="value" bold; height matches every other chip
  // in the row for the same reason .fieldChip/.operatorButton need it explicitly.
  "& .valueChip": {
    height: 26,
    boxSizing: "border-box",
    fontWeight: 400
  },
  "& .addMoreButton": {
    fontWeight: 600,
    fontSize: 13,
    color: g[500],
    border: `1px dashed ${a[300]}`,
    borderRadius: 3,
    padding: "4px 10px"
  },
  "& .meta": {
    fontSize: 12,
    color: a[300]
  },
  // A "dans" (multi) value chip: only its own "x" removes it, there is nothing to open on
  // a bare click of the chip body, so it doesn't invite one.
  "& .notClickable": {
    cursor: "default"
  },
  "& > .MuiTypography": {
    display: "block"
  }
})), Eo = l(r0)({
  width: 300,
  boxSizing: "border-box",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1,
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "normal",
  // Overrides MUI's default theme-colored .Mui-selected fill with the mockup's own light
  // ultramarine tint.
  "&.Mui-selected": {
    backgroundColor: g[100],
    "&:hover": {
      backgroundColor: g[100]
    }
  },
  "& .operatorLabel": {
    fontWeight: 600,
    fontSize: 13,
    color: a[500]
  },
  "& .operatorHelp": {
    fontSize: 12,
    color: a[400]
  }
}), de = l(m2)({
  "& .link": {
    color: a[400],
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "16px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  "& .current": {
    color: a[500],
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "12px"
  },
  li: {
    lineHeight: "12px"
  }
});
function Io(e) {
  const { previous: o, to: t, current: r } = e;
  return /* @__PURE__ */ c(de, { "aria-label": "breadcrumb", separator: /* @__PURE__ */ n($2, { style: { fontSize: 12 } }), children: [
    /* @__PURE__ */ n(j0, { underline: "hover", color: "inherit", className: "link", component: p0, to: t, children: o }),
    /* @__PURE__ */ n(x, { className: "current", children: r })
  ] });
}
const ce = l(U0)(() => ({
  alignSelf: "center",
  padding: "48px 24px",
  borderRadius: 4,
  minHeight: `calc(100vh - ${u0}px)`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "stretch",
  gap: 16,
  "& > .MuiBox-root.page-content": {
    padding: "16px 24px",
    backgroundColor: "white",
    borderRadius: 4,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    overflow: "auto"
  }
}));
function zo(e) {
  return /* @__PURE__ */ n(ce, { maxWidth: "lg", ...e });
}
const se = l(U0)(() => ({
  alignSelf: "center",
  padding: "48px 24px",
  borderRadius: 4,
  // The rule. `height`, not `minHeight`.
  height: `calc(100vh - ${u0}px)`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "stretch",
  gap: 16,
  // Flex children default to min-height: auto, which refuses to shrink below their content
  // and would push the definite height straight back out.
  minHeight: 0,
  "& > .MuiBox-root.page-content": {
    padding: "16px 24px",
    backgroundColor: "white",
    borderRadius: 4,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: "auto"
  }
}));
function Bo(e) {
  return /* @__PURE__ */ n(se, { maxWidth: "lg", ...e });
}
const Ce = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1.5),
  paddingBottom: e.spacing(1.5),
  borderBottom: `1px solid ${N(a[300], 0.2)}`,
  "& .pageHeaderTitleRow": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: e.spacing(2),
    flexWrap: "wrap"
  },
  "& .pageHeaderTitleGroup": {
    display: "flex",
    alignItems: "center",
    gap: e.spacing(1),
    // StatusTag — the usual occupant of the tag slot — sets alignSelf: flex-start on
    // itself, which beats the alignItems above and pins it to the top of a row whose
    // title is several times its height. Released here rather than by each page, because
    // sitting beside the title is the whole purpose of this slot; the tag's own default
    // stays, since elsewhere it is what stops a tag stretching inside a column.
    "& > *": {
      alignSelf: "center"
    }
  },
  // Typography's default h2 margin throws off flex centering against the
  // adjacent tag (the tag has no margin, so align-items: center centers it
  // against the Typography's margin BOX, not its visible text).
  "& .pageHeaderTitle": {
    margin: 0
  },
  "& .pageHeaderInfoGrid": {
    display: "flex",
    flexWrap: "wrap",
    gap: e.spacing(3)
  }
}));
function Ro(e) {
  const {
    title: o,
    tag: t,
    action: r,
    children: i
  } = e;
  return /* @__PURE__ */ c(Ce, { children: [
    /* @__PURE__ */ c("div", { className: "pageHeaderTitleRow", children: [
      /* @__PURE__ */ c("div", { className: "pageHeaderTitleGroup", children: [
        /* @__PURE__ */ n(x, { variant: "h2", className: "pageHeaderTitle", children: o }),
        t
      ] }),
      r
    ] }),
    i && /* @__PURE__ */ n("div", { className: "pageHeaderInfoGrid", children: i })
  ] });
}
const pe = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 10,
  width: 276,
  minWidth: 276,
  // The nav owns its overflow. On a page with a definite height (BoundedPageLayout) it is
  // stretched to that height, so a nav taller than the screen scrolls here and the page
  // itself does not -- the content area keeps its own scrollport beside it. On a page that
  // grows and scrolls the window (PageLayout) this is inert: a box with no definite height
  // has nothing to overflow.
  minHeight: 0,
  overflowY: "auto",
  // Never sideways. `overflow-y: auto` promotes the other axis from `visible` to `auto`, so
  // without this a child that will not narrow past the scrollbar's width earns the nav a
  // horizontal scrollbar rather than being asked to fit.
  overflowX: "hidden",
  // A hint that there is more below, not a second piece of chrome beside the content area's
  // own bar. It stays on the right, where every other scrollport in this app puts it --
  // moving it left needs a `direction: rtl` wrapper, which this panel's date pickers and
  // autocompletes would inherit.
  scrollbarWidth: "thin",
  scrollbarColor: `${N(a[400], 0.4)} transparent`,
  // Safari understands neither standard property; Chrome from 121 prefers them and ignores
  // these, so the two describe the same bar to different engines rather than fighting.
  "&::-webkit-scrollbar": {
    width: 6
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: N(a[400], 0.4),
    borderRadius: 3
  },
  "& .panel": {
    backgroundColor: "white",
    borderRadius: 4,
    padding: 16,
    height: "min-content",
    display: "flex",
    flexDirection: "column"
  },
  "& .panel.scrollable": {
    overflowY: "auto",
    height: "calc(100vh - 160px)"
  },
  "& .defaultLink": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "8px 10px",
    textDecoration: "none",
    width: "100%",
    color: "inherit",
    borderRadius: 4,
    gap: 4,
    "& svg": {
      color: "inherit"
    },
    "& .label": {
      color: "inherit",
      marginLeft: 8,
      lineHeight: 1,
      flex: 1
    },
    "&.compact .label": {
      fontSize: 13
    }
  },
  "& .selectedLink": {
    backgroundColor: g[100],
    color: g[500],
    "&:hover": {
      color: g[600]
    }
  },
  "& .sub-links": {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    "& .subLink": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "8px 10px",
      margin: "0px 0px 0px 12px",
      textDecoration: "none",
      color: "inherit",
      borderRadius: 4,
      gap: 4,
      "& svg": {
        fontSize: 18,
        color: "inherit"
      },
      "& .label": {
        color: "inherit",
        marginLeft: 8,
        lineHeight: 1,
        fontSize: 13,
        flex: 1
      },
      "&.selectedSubLink": {
        color: g[500],
        "&:hover": {
          color: g[600]
        }
      }
    }
  }
});
function n2(e) {
  const o = A2(), t = F2(e.to), r = O2({ path: t.pathname, end: e.match === "exact" });
  return e.match === "includes" ? o.pathname.includes(e.to) : !!r;
}
function E0(e) {
  const { item: o, className: t, selectedClassName: r } = e, i = n2(o);
  return /* @__PURE__ */ c(
    p0,
    {
      to: o.to,
      end: o.match === "exact",
      className: I(t, { [r]: i, compact: o.size === "compact" }),
      children: [
        o.icon,
        /* @__PURE__ */ n("span", { className: "label", children: o.label }),
        o.badge
      ]
    }
  );
}
function ue(e) {
  const { item: o } = e, t = n2(o);
  return /* @__PURE__ */ c($, { children: [
    /* @__PURE__ */ n(E0, { item: o, className: "defaultLink", selectedClassName: "selectedLink" }),
    t && o.children && o.children.length > 0 && /* @__PURE__ */ n("div", { className: "sub-links", children: o.children.map((r) => /* @__PURE__ */ n(E0, { item: r, className: "subLink", selectedClassName: "selectedSubLink" }, r.key)) }),
    t && o.activeContent
  ] });
}
function Lo(e) {
  const {
    items: o,
    header: t,
    footer: r,
    footerInPanel: i,
    scrollable: d
  } = e;
  return /* @__PURE__ */ c(pe, { children: [
    /* @__PURE__ */ c("div", { className: I("panel", { scrollable: d }), children: [
      t,
      o.map((s) => /* @__PURE__ */ n(ue, { item: s }, s.key)),
      i && r
    ] }),
    !i && r
  ] });
}
function No(e) {
  const {
    items: o,
    value: t,
    onChange: r,
    ariaLabel: i,
    variant: d,
    scrollButtons: s
  } = e;
  return /* @__PURE__ */ n(
    Z0,
    {
      value: t,
      onChange: (C, u) => r(u),
      "aria-label": i,
      variant: d,
      scrollButtons: s,
      children: o.map((C) => /* @__PURE__ */ n(
        Y0,
        {
          value: C.value,
          label: C.label,
          id: C.id,
          "aria-controls": C.ariaControls
        },
        C.value
      ))
    }
  );
}
const ge = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1)
}));
function he(e) {
  const { children: o } = e;
  return /* @__PURE__ */ n(ge, { role: "list", children: o });
}
const fe = l(p)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: e.spacing(1),
  flexWrap: "wrap"
}));
function Ho(e) {
  const { title: o, children: t } = e;
  return /* @__PURE__ */ c(fe, { children: [
    o && /* @__PURE__ */ n(x, { variant: "subtitle1", children: o }),
    t
  ] });
}
const me = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(0.5),
  padding: e.spacing(1.5),
  borderRadius: 4,
  border: `1px solid ${N(a[300], 0.2)}`,
  backgroundColor: "white",
  "&.highlighted": {
    border: `1px solid ${E[500]}`
  },
  "&.clickable": {
    width: "100%",
    textAlign: "left",
    background: "none",
    cursor: "pointer",
    // For the <a> variant: a linked row is styled by this shell, not by the browser's
    // default link chrome. Inert on the <button> and <div> variants.
    color: "inherit",
    textDecoration: "none",
    transition: "background-color 0.15s",
    "&:hover": {
      backgroundColor: N(a[100], 0.5)
    }
  }
}));
function be(e) {
  const {
    onClick: o,
    to: t,
    highlighted: r,
    children: i
  } = e, d = !t && !!o;
  return /* @__PURE__ */ n(
    me,
    {
      component: d ? "button" : t ? p0 : "div",
      to: t,
      type: d ? "button" : void 0,
      className: I({ clickable: !!t || !!o, highlighted: r }),
      onClick: o,
      children: i
    }
  );
}
const xe = l(p)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  color: g[500]
});
function Do(e) {
  const { minHeight: o = 400 } = e;
  return /* @__PURE__ */ n(xe, { style: { minHeight: o }, children: /* @__PURE__ */ n(b2, { color: "inherit" }) });
}
const ye = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  alignItems: "flex-start"
}), ke = l(x)({
  wordBreak: "break-word"
}), ve = l(P)({
  textTransform: "none"
});
function Wo(e) {
  const {
    error: o,
    resetErrorBoundary: t,
    retryLabel: r,
    title: i,
    titlePlacement: d = "before",
    image: s
  } = e;
  return /* @__PURE__ */ c($, { children: [
    i && d === "before" && /* @__PURE__ */ n(x, { variant: "h2", children: i }),
    /* @__PURE__ */ c(ye, { children: [
      s,
      i && d === "inline" && /* @__PURE__ */ n(x, { variant: "body1", children: i }),
      /* @__PURE__ */ n(ke, { color: "error", children: o.message }),
      /* @__PURE__ */ n(ve, { onClick: t, children: r })
    ] })
  ] });
}
const we = l(p)({
  display: "flex",
  gap: 10,
  alignItems: "flex-start",
  padding: "10px 12px",
  borderRadius: 4,
  backgroundColor: F.background,
  border: `1px solid ${F.border}`
}), Me = l(x)({
  flex: "none",
  fontSize: 13,
  lineHeight: "19px",
  fontWeight: 700,
  color: F.foreground
}), _e = l(x)({
  fontSize: 13,
  lineHeight: "19px",
  color: F.foreground
});
function $o(e) {
  const { label: o, children: t } = e;
  return /* @__PURE__ */ c(we, { children: [
    o && /* @__PURE__ */ n(Me, { children: o }),
    /* @__PURE__ */ n(_e, { children: t })
  ] });
}
const Se = l(c0)({
  "& .MuiDialogContent-root": {
    maxWidth: 400,
    paddingBottom: 0
  },
  "& .MuiDialogActions-root": {
    justifyContent: "space-between",
    padding: "16px 24px"
  }
});
function Ao(e) {
  const {
    open: o,
    description: t,
    onConfirm: r,
    onCancel: i,
    loading: d,
    error: s,
    cancelLabel: C = "Cancel",
    confirmLabel: u = "Confirm"
  } = e;
  return /* @__PURE__ */ c(Se, { open: o, onClose: i, children: [
    /* @__PURE__ */ c(s0, { children: [
      /* @__PURE__ */ n(x, { variant: "body1", children: t }),
      s && /* @__PURE__ */ n(h0, { children: s })
    ] }),
    /* @__PURE__ */ c(C0, { children: [
      /* @__PURE__ */ n(e2, { onClick: i, children: C }),
      /* @__PURE__ */ n(g0, { loading: d, onClick: r, children: u })
    ] })
  ] });
}
const Te = 800, Pe = "85vh", Ee = l(c0)({
  // Two ceilings, whichever is lower. The viewport term leaves room for the fixed
  // app bar, which deliberately outranks every dialog and would otherwise paint
  // over one tall enough to reach it; the absolute term stops a big screen from
  // permitting a dialog taller than anything worth reading as one form.
  //
  // Past either, the body scrolls while the dock and the actions row stay put --
  // which is the whole point of docking the count.
  "& .MuiDialog-paper": {
    maxHeight: `min(${Te}px, calc(${Pe} - ${u0}px))`
  },
  // A rule under the title, which is what the shell lost when its consumers gave
  // up `<DialogContent dividers>`: the title block carries the run's type and what
  // it is scoped to, so it is a header rather than a first line of the form.
  "& .MuiDialogTitle-root": {
    borderBottom: `1px solid ${a[200]}`
  },
  "& .MuiDialogActions-root": {
    justifyContent: "space-between",
    padding: "16px 24px"
  },
  // Cancel and Confirm sit together at the end instead of at opposite ends. A
  // hint's auto margin already produces that layout, so a shell that only gets
  // one sometimes would otherwise move its confirm button as the hint comes and
  // goes -- under a live count, on the button being aimed at.
  "&.actions-end .MuiDialogActions-root": {
    justifyContent: "flex-end"
  }
}), Ie = l("div")({
  flex: "none",
  padding: "12px 24px 0"
}), ze = l(G)({
  fontSize: 14,
  padding: "10px 12px",
  lineHeight: "20px"
}), Be = l(x)({
  marginRight: "auto",
  fontSize: 13,
  lineHeight: "18px",
  color: R.foreground
});
function Re(e) {
  const {
    open: o,
    title: t,
    children: r,
    onCancel: i,
    onConfirm: d,
    loading: s,
    confirmDisabled: C,
    error: u,
    cancelLabel: m = "Cancel",
    confirmLabel: h = "Save",
    confirmTone: b = "primary",
    width: k = 400,
    dock: f,
    confirmHint: y,
    actionsAlign: _ = "spread",
    cancelTone: S = "ghost"
  } = e, T = b === "danger" ? g0 : P2, H = S === "outlined" ? ze : e2;
  return /* @__PURE__ */ c(
    Ee,
    {
      open: o,
      onClose: i,
      maxWidth: !1,
      className: I({ "actions-end": _ === "end" }),
      PaperProps: { sx: { width: k, maxWidth: "100%" } },
      children: [
        /* @__PURE__ */ n(G0, { children: t }),
        /* @__PURE__ */ c(
          s0,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              gap: 1,
              ...f && {
                // The dock is outside this scroll container, so without a reserved
                // gutter the scrollbar narrows the content and not the dock, and their
                // right edges stop lining up the moment the form is tall enough to
                // scroll -- which is exactly when a dock is being used. `stable` keeps
                // the gutter whether or not it scrolls, so the two always agree. Scoped
                // to docked shells: every other dialog has nothing below the scroll
                // area to disagree with.
                scrollbarGutter: "stable",
                // The dock supplies the gap above itself (12px), so this would
                // otherwise stack its own 20px on top of it.
                paddingBottom: 0
              }
            },
            children: [
              r,
              u && /* @__PURE__ */ n(h0, { children: u })
            ]
          }
        ),
        f && /* @__PURE__ */ n(Ie, { children: f }),
        /* @__PURE__ */ c(C0, { children: [
          y && /* @__PURE__ */ n(Be, { children: y }),
          /* @__PURE__ */ n(H, { onClick: i, children: m }),
          /* @__PURE__ */ n(
            T,
            {
              onClick: d,
              loading: s,
              disabled: s || C,
              children: h
            }
          )
        ] })
      ]
    }
  );
}
const Le = l(p)({
  backgroundColor: a[800],
  color: a[100],
  padding: "8px 12px",
  "& .smallText": {
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 400
  }
});
function Ne(e) {
  const {
    children: o,
    popoverId: t,
    text: r,
    disabled: i,
    component: d = "span",
    ...s
  } = e, [C, u] = w.useState(null), m = G2(C, 500);
  function h(f) {
    u(f.currentTarget);
  }
  const b = () => {
    u(null);
  }, k = !!(m && C && !i);
  return /* @__PURE__ */ c(
    d,
    {
      ...s,
      "aria-owns": k ? t : void 0,
      "aria-haspopup": "true",
      onMouseEnter: (f) => {
        h(f);
      },
      onMouseLeave: b,
      children: [
        r,
        /* @__PURE__ */ n(
          x2,
          {
            id: t,
            style: {
              pointerEvents: "none"
            },
            open: k,
            anchorEl: m,
            anchorOrigin: m ? { vertical: -12, horizontal: "center" } : void 0,
            transformOrigin: m ? { vertical: "bottom", horizontal: "center" } : void 0,
            onClose: b,
            disableRestoreFocus: !0,
            children: /* @__PURE__ */ n(Le, { children: o })
          }
        )
      ]
    }
  );
}
const He = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.0.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%20[%20%3c!ENTITY%20ns_extend%20'http://ns.adobe.com/Extensibility/1.0/'%3e%3c!ENTITY%20ns_ai%20'http://ns.adobe.com/AdobeIllustrator/10.0/'%3e%3c!ENTITY%20ns_graphs%20'http://ns.adobe.com/Graphs/1.0/'%3e%3c!ENTITY%20ns_vars%20'http://ns.adobe.com/Variables/1.0/'%3e%3c!ENTITY%20ns_imrep%20'http://ns.adobe.com/ImageReplacement/1.0/'%3e%3c!ENTITY%20ns_sfw%20'http://ns.adobe.com/SaveForWeb/1.0/'%3e%3c!ENTITY%20ns_custom%20'http://ns.adobe.com/GenericCustomNamespace/1.0/'%3e%3c!ENTITY%20ns_adobe_xpath%20'http://ns.adobe.com/XPath/1.0/'%3e%20]%3e%3csvg%20version='1.1'%20id='Livello_1'%20xmlns:x='&ns_extend;'%20xmlns:i='&ns_ai;'%20xmlns:graph='&ns_graphs;'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%202289.75%202130'%20enable-background='new%200%200%202289.75%202130'%20xml:space='preserve'%3e%3cmetadata%3e%3csfw%20xmlns='&ns_sfw;'%3e%3cslices%3e%3c/slices%3e%3csliceSourceBounds%20bottomLeftOrigin='true'%20height='2130'%20width='2289.75'%20x='-1147.5'%20y='-1041'%3e%3c/sliceSourceBounds%3e%3c/sfw%3e%3c/metadata%3e%3cpath%20fill='%23185C37'%20d='M1437.75,1011.75L532.5,852v1180.393c0,53.907,43.7,97.607,97.607,97.607l0,0h1562.036%20c53.907,0,97.607-43.7,97.607-97.607l0,0V1597.5L1437.75,1011.75z'/%3e%3cpath%20fill='%2321A366'%20d='M1437.75,0H630.107C576.2,0,532.5,43.7,532.5,97.607c0,0,0,0,0,0V532.5l905.25,532.5L1917,1224.75%20L2289.75,1065V532.5L1437.75,0z'/%3e%3cpath%20fill='%23107C41'%20d='M532.5,532.5h905.25V1065H532.5V532.5z'/%3e%3cpath%20opacity='0.1'%20enable-background='new%20'%20d='M1180.393,426H532.5v1331.25h647.893c53.834-0.175,97.432-43.773,97.607-97.607%20V523.607C1277.825,469.773,1234.227,426.175,1180.393,426z'/%3e%3cpath%20opacity='0.2'%20enable-background='new%20'%20d='M1127.143,479.25H532.5V1810.5h594.643%20c53.834-0.175,97.432-43.773,97.607-97.607V576.857C1224.575,523.023,1180.977,479.425,1127.143,479.25z'/%3e%3cpath%20opacity='0.2'%20enable-background='new%20'%20d='M1127.143,479.25H532.5V1704h594.643c53.834-0.175,97.432-43.773,97.607-97.607%20V576.857C1224.575,523.023,1180.977,479.425,1127.143,479.25z'/%3e%3cpath%20opacity='0.2'%20enable-background='new%20'%20d='M1073.893,479.25H532.5V1704h541.393c53.834-0.175,97.432-43.773,97.607-97.607%20V576.857C1171.325,523.023,1127.727,479.425,1073.893,479.25z'/%3e%3clinearGradient%20id='SVGID_1_'%20gradientUnits='userSpaceOnUse'%20x1='203.5132'%20y1='1729.0183'%20x2='967.9868'%20y2='404.9817'%20gradientTransform='matrix(1%200%200%20-1%200%202132)'%3e%3cstop%20offset='0'%20style='stop-color:%2318884F'/%3e%3cstop%20offset='0.5'%20style='stop-color:%23117E43'/%3e%3cstop%20offset='1'%20style='stop-color:%230B6631'/%3e%3c/linearGradient%3e%3cpath%20fill='url(%23SVGID_1_)'%20d='M97.607,479.25h976.285c53.907,0,97.607,43.7,97.607,97.607v976.285%20c0,53.907-43.7,97.607-97.607,97.607H97.607C43.7,1650.75,0,1607.05,0,1553.143V576.857C0,522.95,43.7,479.25,97.607,479.25z'/%3e%3cpath%20fill='%23FFFFFF'%20d='M302.3,1382.264l205.332-318.169L319.5,747.683h151.336l102.666,202.35%20c9.479,19.223,15.975,33.494,19.49,42.919h1.331c6.745-15.336,13.845-30.228,21.3-44.677L725.371,747.79h138.929l-192.925,314.548%20L869.2,1382.263H721.378L602.79,1160.158c-5.586-9.45-10.326-19.376-14.164-29.66h-1.757c-3.474,10.075-8.083,19.722-13.739,28.755%20l-122.102,223.011H302.3z'/%3e%3cpath%20fill='%2333C481'%20d='M2192.143,0H1437.75v532.5h852V97.607C2289.75,43.7,2246.05,0,2192.143,0L2192.143,0z'/%3e%3cpath%20fill='%23107C41'%20d='M1437.75,1065h852v532.5h-852V1065z'/%3e%3c/svg%3e";
function Fo(e) {
  const { anchorEl: o, onClose: t, onExport: r } = e, { t: i } = j("common"), d = w.useCallback((s) => {
    r(s), t();
  }, [t, r]);
  return /* @__PURE__ */ c(
    y2,
    {
      open: !!o,
      anchorEl: o,
      onClose: t,
      children: [
        /* @__PURE__ */ c(r0, { onClick: () => {
          d("ExcelReport");
        }, children: [
          /* @__PURE__ */ n(x0, { children: /* @__PURE__ */ n("img", { src: He, alt: "", width: 16, height: 16 }) }),
          /* @__PURE__ */ n(y0, { children: i("export-excel-report") })
        ] }),
        /* @__PURE__ */ c(r0, { onClick: () => {
          d("CsvRawData");
        }, children: [
          /* @__PURE__ */ n(x0, { children: /* @__PURE__ */ n(V2, { style: { width: 16, height: 16 } }) }),
          /* @__PURE__ */ n(y0, { children: i("export-csv-raw-data") })
        ] })
      ]
    }
  );
}
const De = l(p)({
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  gap: 4,
  "& .chart-box": {
    position: "relative",
    width: "100%",
    height: 170,
    "& .total-box": {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      // The donut hole is innerRadius 40% of a 170px box -- about 68px across. An
      // unconstrained label spills straight over the ring as soon as a translation is
      // longer than the English one (fr "correspondances" for "matches"), so the centre
      // text is capped to the hole and wraps, breaking mid-word only as a last resort.
      "& .text-center": {
        textAlign: "center",
        maxWidth: 68,
        overflowWrap: "anywhere"
      },
      "& .text-2xl": { fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.2 },
      "& .total-label": { opacity: 0.6, fontSize: 12, lineHeight: 1.2 }
    },
    "& .recharts-pie-sector": {
      "&:hover": {
        cursor: "pointer",
        opacity: 0.8
      }
    },
    "& .recharts-tooltip-wrapper": {
      zIndex: 1
    }
  },
  "& .legend": {
    width: "100%",
    alignItems: "stretch",
    "& .legend-row": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 8,
      padding: "3px 0",
      borderRadius: 6,
      cursor: "pointer",
      "&:hover": {
        "& .legend-text, & .legend-value": {
          textDecoration: "underline"
        }
      },
      "&.disabled": {
        cursor: "default",
        "&:hover": {
          "& .legend-text, & .legend-value": {
            textDecoration: "none"
          }
        }
      },
      "& .legend-label": {
        display: "flex",
        alignItems: "center",
        gap: 6,
        minWidth: 0,
        flex: 1
      },
      "& .legend-color": {
        width: 10,
        height: 10,
        borderRadius: "50%",
        flexShrink: 0
      },
      "& .legend-text": {
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: 13,
        fontWeight: 600
      },
      "& .legend-value": {
        fontSize: 13,
        fontWeight: 600,
        color: "#6d7484",
        flexShrink: 0
      }
    },
    "& .legend-toggle": {
      alignSelf: "flex-start",
      marginTop: 4,
      minWidth: "unset",
      padding: 0,
      fontSize: 12,
      fontWeight: 600,
      textTransform: "none"
    }
  }
});
function We(e, o, t, r) {
  let i = !1;
  e.length > t && (i = !0);
  const d = e.filter((C) => C.value / o < r);
  if (d.length >= 2 && (i = !0), i === !1) return /* @__PURE__ */ new Set();
  const s = /* @__PURE__ */ new Set();
  return d.forEach((C) => {
    s.add(C.key);
  }), e.slice(t - 1).forEach((C) => {
    s.add(C.key);
  }), s;
}
function $e(e, o, t, r, i) {
  if (!e)
    return;
  if (o === 0)
    return e;
  const d = We(e, o, r, i);
  let s = 0;
  const C = e.filter((m) => {
    const h = d.has(m.key);
    return h && (s += m.value), !h;
  });
  return s > 0 ? [...C, {
    key: t,
    value: s,
    isAggregated: !0
  }] : C;
}
function Ae(e, o, t, r, i) {
  return w.useMemo(
    () => $e(e, o, t, r, i),
    [e, o, t, r, i]
  );
}
const Fe = [
  g[500],
  i0[500],
  a0[500],
  l0[500],
  w2[500],
  A[500],
  E[500]
], X = -20, Oe = "__pie_chart_aggregated_other__";
function Ge(e) {
  if (e)
    return e.map((o) => ({ ...o, isAggregated: !1 }));
}
function Ve(e) {
  return e && [...e].sort((o, t) => t.value - o.value || o.key.localeCompare(t.key));
}
function Oo(e) {
  const {
    data: o,
    getLabel: t = (v) => v.key,
    isNonInteractive: r = (v) => v.isAggregated,
    colors: i = Fe,
    maxCompactCategories: d = 10,
    minAggregatedSliceRatio: s = 0.03,
    detailedLegendVisibleRows: C = 2,
    totalLabel: u = "Total",
    seeMoreLabel: m = "See more",
    seeLessLabel: h = "See less",
    onCellClick: b
  } = e, [k, f] = w.useState(!1), y = w.useMemo(() => Ge(o ?? void 0), [o]), _ = w.useMemo(() => Ve(y), [y]), S = w.useMemo(() => _?.reduce((v, L) => v + (L?.value ?? 0), 0) ?? 0, [_]), T = Ae(_, S, Oe, d, s), { i18n: H } = j(), z = new Intl.NumberFormat(H.language, { style: "percent", maximumFractionDigits: 0 }), W = Math.PI / 180, Y = w.useMemo(() => Object.fromEntries(
    (T ?? []).map((v, L) => [v.key, i[L % i.length]])
  ), [T, i]), D = (_?.length ?? 0) > C, O = w.useMemo(
    () => k ? _ : _?.slice(0, C),
    [k, _, C]
  );
  w.useEffect(() => {
    f(!1);
  }, [o]);
  function B(v) {
    const {
      cx: L,
      cy: q,
      midAngle: f0,
      outerRadius: l2
    } = v, m0 = l2 + 8, b0 = L + m0 * Math.cos(-f0 * W), d2 = q + m0 * Math.sin(-f0 * W), c2 = b0 > L ? "start" : "end";
    return /* @__PURE__ */ n("text", { x: b0, y: d2, textAnchor: c2, dominantBaseline: "central", fontSize: 14, fill: v.payload.fill, children: `${z.format((v.value ?? 0) / (S || 1))} (${v.value ?? 0})` });
  }
  return /* @__PURE__ */ c(De, { children: [
    /* @__PURE__ */ c(p, { className: "chart-box", children: [
      /* @__PURE__ */ n(j2, { width: "100%", height: "100%", children: /* @__PURE__ */ c(
        U2,
        {
          margin: {
            top: X,
            bottom: X,
            left: X,
            right: X
          },
          children: [
            /* @__PURE__ */ n(
              Z2,
              {
                data: T ?? [],
                dataKey: "value",
                nameKey: "key",
                cx: "50%",
                cy: "50%",
                innerRadius: "40%",
                outerRadius: "50%",
                paddingAngle: 2,
                label: (v) => B(v),
                labelLine: !1,
                children: T?.map((v, L) => /* @__PURE__ */ n(
                  Y2,
                  {
                    className: "recharts-pie-sector",
                    fill: i[L % i.length],
                    stroke: "#fff",
                    strokeWidth: 2,
                    onClick: () => b?.(v)
                  },
                  `cell-${v.key}`
                ))
              }
            ),
            /* @__PURE__ */ n(
              q2,
              {
                formatter: (v, L, q) => [v, q?.payload ? t(q.payload) : ""],
                contentStyle: { borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ n(p, { className: "total-box", children: /* @__PURE__ */ c(p, { className: "text-center", children: [
        /* @__PURE__ */ n(p, { className: "text-2xl", children: S }),
        /* @__PURE__ */ n(p, { className: "total-label", children: u })
      ] }) })
    ] }),
    /* @__PURE__ */ c(p, { className: "legend", children: [
      O?.map((v, L) => /* @__PURE__ */ c(
        p,
        {
          className: `legend-row ${r(v) ? "disabled" : ""}`,
          onClick: () => {
            r(v) || b?.(v);
          },
          children: [
            /* @__PURE__ */ c(p, { className: "legend-label", children: [
              /* @__PURE__ */ n(
                p,
                {
                  className: "legend-color",
                  style: {
                    backgroundColor: Y[v.key] ?? i[L % i.length]
                  }
                }
              ),
              /* @__PURE__ */ n(p, { className: "legend-text", title: t(v), children: t(v) })
            ] }),
            /* @__PURE__ */ n(p, { className: "legend-value", children: `${v.value} (${z.format((v.value ?? 0) / (S || 1))})` })
          ]
        },
        v.key
      )),
      D && /* @__PURE__ */ n(
        y1,
        {
          className: "legend-toggle",
          onClick: () => f((v) => !v),
          children: k ? h : m
        }
      )
    ] })
  ] });
}
const je = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 10,
  "& .bar-progress": {
    width: "100%",
    height: 8,
    borderRadius: 24,
    backgroundColor: a[100],
    "& .MuiLinearProgress-bar": {
      borderRadius: 24
    }
  },
  "& .bar-details": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    // Captions are a ButtonBase only when the consumer passes onSegmentClick --
    // read-only bars render bare Typography, so the caption styling has to sit
    // on the Typography itself for the two to look identical.
    "& .MuiTypography-caption": {
      fontSize: 12,
      textTransform: "uppercase",
      fontWeight: 700,
      color: g[500]
    },
    "& > .MuiButtonBase-root": {
      padding: 0,
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      gap: 4,
      justifyContent: "flex-start",
      textAlign: "left",
      borderRadius: 6,
      color: g[500],
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }
});
function Go(e) {
  const {
    ratio: o,
    trueLabel: t,
    falseLabel: r,
    onSegmentClick: i
  } = e, d = (s, C) => {
    const u = /* @__PURE__ */ n(x, { variant: "caption", children: s });
    return i ? /* @__PURE__ */ n(V0, { onClick: () => i(C), children: u }) : u;
  };
  return /* @__PURE__ */ c(je, { children: [
    /* @__PURE__ */ n(
      k2,
      {
        variant: "determinate",
        value: o * 100,
        className: "bar-progress"
      }
    ),
    /* @__PURE__ */ c(p, { className: "bar-details", children: [
      d(t, !0),
      d(r, !1)
    ] })
  ] });
}
const Ue = "data:image/svg+xml,%3csvg%20id='svg'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='400'%20height='400'%20viewBox='0,%200,%20400,400'%3e%3cg%20id='svgg'%3e%3cpath%20id='path0'%20d='M196.168%20122.095%20C%20194.640%20123.143,193.524%20124.854,192.835%20127.200%20C%20192.545%20128.190,192.169%20129.450,192.000%20130.000%20C%20191.831%20130.550,191.473%20131.810,191.205%20132.800%20C%20190.936%20133.790,190.555%20135.013,190.358%20135.519%20C%20190.161%20136.024,190.000%20136.869,190.000%20137.395%20C%20190.000%20137.922,189.820%20138.464,189.600%20138.600%20C%20189.380%20138.736,189.200%20139.366,189.200%20140.000%20C%20189.200%20140.634,189.020%20141.264,188.800%20141.400%20C%20188.580%20141.536,188.400%20142.078,188.400%20142.605%20C%20188.400%20143.131,188.239%20143.976,188.042%20144.481%20C%20187.845%20144.987,187.464%20146.210,187.195%20147.200%20C%20186.927%20148.190,186.569%20149.450,186.400%20150.000%20C%20186.231%20150.550,185.871%20151.810,185.600%20152.800%20C%20185.329%20153.790,184.969%20155.050,184.800%20155.600%20C%20184.631%20156.150,184.293%20157.320,184.049%20158.200%20C%20183.805%20159.080,182.610%20163.310,181.395%20167.600%20C%20180.179%20171.890,178.985%20176.120,178.741%20177.000%20C%20177.316%20182.132,176.700%20182.848,176.241%20179.910%20C%20175.827%20177.263,175.171%20173.206,174.800%20171.000%20C%20174.615%20169.900,174.279%20167.830,174.053%20166.400%20C%20172.924%20159.261,171.210%20157.200,166.400%20157.200%20C%20162.764%20157.200,158.800%20160.643,158.800%20163.800%20C%20158.800%20163.915,158.422%20164.862,157.960%20165.904%20C%20156.977%20168.124,156.406%20169.490,156.000%20170.600%20C%20155.839%20171.040,155.479%20171.940,155.200%20172.600%20C%20154.921%20173.260,154.555%20174.160,154.387%20174.600%20C%20154.219%20175.040,153.811%20176.030,153.481%20176.800%20C%20153.150%20177.570,150.775%20183.420,148.202%20189.800%20C%20145.629%20196.180,143.253%20202.030,142.921%20202.800%20C%20142.590%20203.570,142.157%20204.605,141.959%20205.100%20C%20140.984%20207.544,140.665%20208.279,140.178%20209.200%20C%20139.239%20210.980,139.220%20210.940,134.343%20196.800%20C%20133.470%20194.270,132.599%20191.840,132.407%20191.400%20C%20132.029%20190.537,130.320%20185.719,129.355%20182.800%20C%20129.027%20181.810,128.598%20180.640,128.399%20180.200%20C%20128.201%20179.760,127.804%20178.680,127.516%20177.800%20C%20125.573%20171.862,119.571%20169.883,115.384%20173.800%20C%20114.577%20174.555,113.820%20175.603,108.448%20183.400%20C%20107.235%20185.160,106.130%20186.690,105.991%20186.800%20C%20105.853%20186.910,104.961%20188.170,104.008%20189.600%20C%20103.056%20191.030,102.199%20192.290,102.105%20192.400%20C%20102.011%20192.510,92.904%20192.690,81.867%20192.800%20C%2060.426%20193.014,61.096%20192.949,59.022%20195.022%20C%2056.450%20197.594,56.439%20202.346,59.000%20204.978%20C%2061.009%20207.043,60.459%20207.000,84.961%20207.000%20L%20107.800%20207.000%20109.200%20206.043%20C%20110.571%20205.106,111.487%20203.967,115.592%20198.100%20C%20117.699%20195.088,118.564%20194.567,118.909%20196.100%20C%20119.105%20196.971,120.915%20202.175,121.588%20203.800%20C%20121.770%20204.240,122.136%20205.230,122.400%20206.000%20C%20122.664%20206.770,123.024%20207.760,123.200%20208.200%20C%20123.376%20208.640,123.736%20209.630,124.000%20210.400%20C%20124.264%20211.170,124.634%20212.160,124.820%20212.600%20C%20125.007%20213.040,125.427%20214.210,125.753%20215.200%20C%20126.080%20216.190,126.911%20218.530,127.599%20220.400%20C%20129.131%20224.560,131.521%20231.304,132.136%20233.200%20C%20134.498%20240.485,143.487%20239.856,146.413%20232.200%20C%20146.581%20231.760,146.989%20230.770,147.319%20230.000%20C%20147.650%20229.230,150.025%20223.380,152.598%20217.000%20C%20155.171%20210.620,157.547%20204.770,157.879%20204.000%20C%20158.210%20203.230,158.619%20202.240,158.787%20201.800%20C%20158.955%20201.360,159.297%20200.505,159.546%20199.900%20C%20159.969%20198.875,160.241%20198.201,161.159%20195.900%20C%20162.301%20193.039,162.911%20191.970,163.323%20192.108%20C%20163.857%20192.286,163.869%20192.348,165.811%20204.600%20C%20167.712%20216.598,168.205%20219.043,168.959%20220.193%20C%20171.745%20224.445,178.248%20224.456,181.028%20220.214%20C%20181.364%20219.700,183.249%20213.547,185.216%20206.540%20C%20189.887%20189.898,189.647%20190.750,190.000%20189.600%20C%20190.169%20189.050,190.529%20187.790,190.800%20186.800%20C%20191.071%20185.810,191.431%20184.550,191.600%20184.000%20C%20191.769%20183.450,192.129%20182.190,192.400%20181.200%20C%20192.671%20180.210,193.031%20178.950,193.200%20178.400%20C%20193.369%20177.850,193.729%20176.590,194.000%20175.600%20C%20194.271%20174.610,194.627%20173.350,194.791%20172.800%20C%20195.565%20170.198,195.956%20168.853,196.445%20167.100%20C%20197.409%20163.642,197.716%20164.371,198.809%20172.714%20C%20199.262%20176.171,199.818%20180.350,200.046%20182.000%20C%20200.274%20183.650,200.615%20186.170,200.805%20187.600%20C%20201.787%20195.021,202.084%20197.240,202.439%20199.800%20C%20202.653%20201.340,203.001%20203.905,203.214%20205.500%20C%20203.426%20207.095,203.780%20209.750,204.000%20211.400%20C%20204.220%20213.050,204.580%20215.750,204.800%20217.400%20C%20205.237%20220.681,205.848%20225.150,206.413%20229.200%20C%20206.750%20231.622,206.994%20233.434,207.985%20240.900%20C%20208.381%20243.885,208.957%20248.097,209.638%20253.000%20C%20210.109%20256.386,210.635%20260.345,211.163%20264.474%20C%20212.111%20271.902,213.922%20274.131,218.967%20274.086%20C%20223.005%20274.049,224.612%20272.438,226.432%20266.600%20C%20226.912%20265.060,227.440%20263.440,227.605%20263.000%20C%20227.769%20262.560,228.492%20260.310,229.211%20258.000%20C%20229.930%20255.690,231.013%20252.270,231.619%20250.400%20C%20232.224%20248.530,233.477%20244.570,234.402%20241.600%20C%20235.328%20238.630,236.494%20234.940,236.993%20233.400%20C%20237.493%20231.860,238.662%20228.170,239.593%20225.200%20C%20240.523%20222.230,241.424%20219.440,241.594%20219.000%20C%20241.765%20218.560,242.310%20216.850,242.806%20215.200%20C%20245.120%20207.499,244.902%20207.234,248.232%20221.800%20C%20249.037%20225.320,249.830%20228.761,249.994%20229.447%20C%20251.378%20235.234,259.505%20237.268,262.567%20232.594%20C%20263.652%20230.938,269.097%20220.662,274.010%20211.000%20L%20275.840%20207.400%20298.420%20207.200%20C%20322.587%20206.986,321.691%20207.064,323.778%20204.978%20C%20326.350%20202.406,326.361%20197.654,323.800%20195.022%20C%20321.778%20192.944,322.577%20193.000,295.039%20193.000%20L%20269.400%20193.000%20267.931%20193.994%20C%20266.267%20195.119,265.930%20195.622,262.600%20201.948%20C%20259.881%20207.114,259.632%20207.273,258.887%20204.324%20C%20257.861%20200.263,257.648%20199.389,257.200%20197.400%20C%20256.952%20196.300,256.592%20194.770,256.400%20194.000%20C%20256.208%20193.230,255.865%20191.790,255.637%20190.800%20C%20252.107%20175.421,251.566%20174.493,246.094%20174.429%20C%20242.682%20174.389,239.200%20176.900,239.200%20179.400%20C%20239.200%20179.736,239.039%20180.323,238.841%20180.705%20C%20238.504%20181.358,237.507%20184.438,233.566%20197.000%20C%20232.669%20199.860,230.961%20205.260,229.770%20209.000%20C%20228.579%20212.740,227.042%20217.600,226.355%20219.800%20C%20225.667%20222.000,224.965%20224.160,224.795%20224.600%20C%20224.624%20225.040,223.994%20226.978,223.393%20228.907%20C%20221.808%20233.998,221.440%20234.067,220.835%20229.390%20C%20220.609%20227.636,219.781%20221.430,218.997%20215.600%20C%20217.026%20200.950,216.821%20199.415,216.385%20196.000%20C%20216.175%20194.350,215.821%20191.740,215.600%20190.200%20C%20215.379%20188.660,215.006%20185.960,214.773%20184.200%20C%20214.187%20179.777,213.726%20176.358,213.209%20172.600%20C%20212.968%20170.840,212.597%20168.095,212.385%20166.500%20C%20212.173%20164.905,211.820%20162.250,211.600%20160.600%20C%20211.380%20158.950,211.014%20156.205,210.788%20154.500%20C%20210.561%20152.795,210.212%20150.230,210.013%20148.800%20C%20209.007%20141.583,208.200%20135.589,207.615%20131.000%20C%20206.901%20125.389,206.153%20123.653,203.775%20122.094%20C%20201.906%20120.869,197.954%20120.869,196.168%20122.095%20'%20stroke='none'%20fill='%23f9f9fa'%20fill-rule='evenodd'%3e%3c/path%3e%3cpath%20id='path1'%20d='M178.300%200.275%20C%20176.375%200.361,174.800%200.604,174.800%200.816%20C%20174.800%201.027,173.461%201.200,171.824%201.200%20C%20170.187%201.200,168.736%201.380,168.600%201.600%20C%20168.464%201.820,167.463%202.000,166.376%202.000%20C%20165.289%202.000,164.400%202.180,164.400%202.400%20C%20164.400%202.620,163.410%202.800,162.200%202.800%20C%20160.990%202.800,160.000%202.980,160.000%203.200%20C%20160.000%203.420,159.201%203.600,158.224%203.600%20C%20157.247%203.600,156.336%203.780,156.200%204.000%20C%20156.064%204.220,155.243%204.400,154.376%204.400%20C%20153.509%204.400,152.800%204.580,152.800%204.800%20C%20152.800%205.020,152.080%205.200,151.200%205.200%20C%20150.320%205.200,149.600%205.380,149.600%205.600%20C%20149.600%205.820,148.880%206.000,148.000%206.000%20C%20147.120%206.000,146.400%206.180,146.400%206.400%20C%20146.400%206.620,145.860%206.800,145.200%206.800%20C%20144.540%206.800,144.000%206.980,144.000%207.200%20C%20144.000%207.420,143.370%207.600,142.600%207.600%20C%20141.830%207.600,141.200%207.780,141.200%208.000%20C%20141.200%208.220,140.771%208.400,140.246%208.400%20C%20139.355%208.400,136.018%209.285,134.200%2010.003%20C%20133.760%2010.177,132.770%2010.536,132.000%2010.800%20C%20130.307%2011.382,128.840%2011.971,127.905%2012.447%20C%20127.523%2012.641,126.848%2012.800,126.405%2012.800%20C%20125.962%2012.800,125.600%2012.980,125.600%2013.200%20C%20125.600%2013.420,125.240%2013.600,124.800%2013.600%20C%20124.360%2013.600,124.000%2013.780,124.000%2014.000%20C%20124.000%2014.220,123.561%2014.400,123.024%2014.400%20C%20122.487%2014.400,121.936%2014.580,121.800%2014.800%20C%20121.664%2015.020,121.203%2015.200,120.776%2015.200%20C%20120.349%2015.200,120.000%2015.380,120.000%2015.600%20C%20120.000%2015.820,119.640%2016.000,119.200%2016.000%20C%20118.760%2016.000,118.400%2016.180,118.400%2016.400%20C%20118.400%2016.620,118.040%2016.800,117.600%2016.800%20C%20117.160%2016.800,116.800%2016.980,116.800%2017.200%20C%20116.800%2017.420,116.361%2017.600,115.824%2017.600%20C%20115.287%2017.600,114.736%2017.780,114.600%2018.000%20C%20114.464%2018.220,114.003%2018.400,113.576%2018.400%20C%20113.149%2018.400,112.800%2018.580,112.800%2018.800%20C%20112.800%2019.020,112.440%2019.200,112.000%2019.200%20C%20111.560%2019.200,111.200%2019.346,111.200%2019.525%20C%20111.200%2019.704,110.570%2020.098,109.800%2020.400%20C%20109.030%2020.702,108.400%2021.096,108.400%2021.275%20C%20108.400%2021.454,108.040%2021.600,107.600%2021.600%20C%20107.160%2021.600,106.800%2021.780,106.800%2022.000%20C%20106.800%2022.220,106.440%2022.400,106.000%2022.400%20C%20105.560%2022.400,105.200%2022.580,105.200%2022.800%20C%20105.200%2023.020,104.880%2023.200,104.488%2023.200%20C%20104.097%2023.200,103.517%2023.560,103.200%2024.000%20C%20102.883%2024.440,102.387%2024.800,102.098%2024.800%20C%20101.396%2024.800,97.435%2026.809,97.267%2027.251%20C%2097.193%2027.443,96.956%2027.600,96.739%2027.600%20C%2096.522%2027.600,95.559%2028.140,94.600%2028.800%20C%2093.641%2029.460,92.703%2030.000,92.516%2030.000%20C%2092.329%2030.000,91.917%2030.360,91.600%2030.800%20C%2091.283%2031.240,90.743%2031.600,90.400%2031.600%20C%2090.057%2031.600,89.517%2031.960,89.200%2032.400%20C%2088.883%2032.840,88.343%2033.200,88.000%2033.200%20C%2087.657%2033.200,87.117%2033.560,86.800%2034.000%20C%2086.483%2034.440,85.991%2034.800,85.708%2034.800%20C%2085.425%2034.800,84.628%2035.340,83.937%2036.000%20C%2083.246%2036.660,82.478%2037.200,82.229%2037.200%20C%2081.980%2037.200,81.517%2037.560,81.200%2038.000%20C%2080.883%2038.440,80.375%2038.800,80.072%2038.800%20C%2079.769%2038.800,79.017%2039.340,78.400%2040.000%20C%2077.783%2040.660,77.071%2041.200,76.816%2041.200%20C%2076.561%2041.200,76.464%2041.380,76.600%2041.600%20C%2076.736%2041.820,76.586%2042.000,76.266%2042.000%20C%2075.946%2042.000,75.107%2042.540,74.400%2043.200%20C%2073.693%2043.860,72.959%2044.400,72.768%2044.400%20C%2072.577%2044.400,71.651%2045.167,70.711%2046.105%20C%2069.770%2047.043,68.370%2048.255,67.600%2048.799%20C%2066.830%2049.342,64.439%2051.590,62.287%2053.793%20C%2057.582%2058.611,58.611%2057.582,53.793%2062.287%20C%2051.590%2064.439,49.342%2066.828,48.799%2067.595%20C%2048.255%2068.362,46.953%2069.865,45.905%2070.935%20C%2044.857%2072.005,44.000%2073.051,44.000%2073.259%20C%2044.000%2073.466,43.550%2074.086,43.000%2074.636%20C%2042.450%2075.186,42.000%2075.909,42.000%2076.242%20C%2042.000%2076.575,41.820%2076.736,41.600%2076.600%20C%2041.380%2076.464,41.200%2076.561,41.200%2076.816%20C%2041.200%2077.071,40.660%2077.783,40.000%2078.400%20C%2039.340%2079.017,38.800%2079.769,38.800%2080.072%20C%2038.800%2080.375,38.440%2080.883,38.000%2081.200%20C%2037.560%2081.517,37.200%2082.107,37.200%2082.512%20C%2037.200%2082.916,37.020%2083.136,36.800%2083.000%20C%2036.580%2082.864,36.400%2082.994,36.400%2083.288%20C%2036.400%2083.583,36.040%2084.083,35.600%2084.400%20C%2035.160%2084.717,34.800%2085.257,34.800%2085.600%20C%2034.800%2085.943,34.440%2086.483,34.000%2086.800%20C%2033.560%2087.117,33.200%2087.657,33.200%2088.000%20C%2033.200%2088.343,32.840%2088.883,32.400%2089.200%20C%2031.960%2089.517,31.600%2090.057,31.600%2090.400%20C%2031.600%2090.743,31.240%2091.283,30.800%2091.600%20C%2030.360%2091.917,30.000%2092.329,30.000%2092.516%20C%2030.000%2092.703,29.460%2093.641,28.800%2094.600%20C%2028.140%2095.559,27.600%2096.522,27.600%2096.739%20C%2027.600%2096.956,27.443%2097.193,27.251%2097.267%20C%2026.809%2097.435,24.800%20101.396,24.800%20102.098%20C%2024.800%20102.387,24.440%20102.883,24.000%20103.200%20C%2023.560%20103.517,23.200%20103.971,23.200%20104.209%20C%2023.200%20104.875,22.237%20106.793,21.900%20106.797%20C%2021.735%20106.799,21.600%20107.160,21.600%20107.600%20C%2021.600%20108.040,21.454%20108.400,21.275%20108.400%20C%2021.096%20108.400,20.702%20109.030,20.400%20109.800%20C%2020.098%20110.570,19.704%20111.200,19.525%20111.200%20C%2019.346%20111.200,19.200%20111.560,19.200%20112.000%20C%2019.200%20112.440,19.020%20112.800,18.800%20112.800%20C%2018.580%20112.800,18.400%20113.065,18.400%20113.388%20C%2018.400%20113.711,18.040%20114.617,17.600%20115.400%20C%2017.160%20116.183,16.800%20117.179,16.800%20117.612%20C%2016.800%20118.045,16.620%20118.400,16.400%20118.400%20C%2016.180%20118.400,16.000%20118.760,16.000%20119.200%20C%2016.000%20119.640,15.820%20120.000,15.600%20120.000%20C%2015.380%20120.000,15.200%20120.360,15.200%20120.800%20C%2015.200%20121.240,15.020%20121.600,14.800%20121.600%20C%2014.580%20121.600,14.400%20122.140,14.400%20122.800%20C%2014.400%20123.460,14.220%20124.000,14.000%20124.000%20C%2013.780%20124.000,13.600%20124.360,13.600%20124.800%20C%2013.600%20125.240,13.420%20125.600,13.200%20125.600%20C%2012.980%20125.600,12.800%20125.962,12.800%20126.405%20C%2012.800%20126.848,12.641%20127.523,12.447%20127.905%20C%2012.252%20128.287,11.871%20129.140,11.600%20129.800%20C%2011.329%20130.460,10.948%20131.313,10.753%20131.695%20C%2010.559%20132.077,10.400%20132.664,10.400%20133.000%20C%2010.400%20133.336,10.237%20133.923,10.037%20134.305%20C%209.440%20135.447,8.400%20139.222,8.400%20140.246%20C%208.400%20140.771,8.220%20141.200,8.000%20141.200%20C%207.780%20141.200,7.600%20141.830,7.600%20142.600%20C%207.600%20143.370,7.420%20144.000,7.200%20144.000%20C%206.980%20144.000,6.800%20144.540,6.800%20145.200%20C%206.800%20145.860,6.620%20146.400,6.400%20146.400%20C%206.180%20146.400,6.000%20147.120,6.000%20148.000%20C%206.000%20148.880,5.820%20149.600,5.600%20149.600%20C%205.380%20149.600,5.200%20150.320,5.200%20151.200%20C%205.200%20152.080,5.020%20152.800,4.800%20152.800%20C%204.580%20152.800,4.400%20153.509,4.400%20154.376%20C%204.400%20155.243,4.220%20156.064,4.000%20156.200%20C%203.780%20156.336,3.600%20157.247,3.600%20158.224%20C%203.600%20159.201,3.420%20160.000,3.200%20160.000%20C%202.980%20160.000,2.800%20161.001,2.800%20162.224%20C%202.800%20163.604,2.648%20164.353,2.400%20164.200%20C%202.149%20164.045,2.000%20164.929,2.000%20166.576%20C%202.000%20168.059,1.826%20169.200,1.600%20169.200%20C%201.376%20169.200,1.200%20170.307,1.200%20171.720%20C%201.200%20173.203,0.994%20174.446,0.700%20174.740%20C%200.311%20175.129,0.200%20180.743,0.200%20200.087%20C%200.200%20219.608,0.307%20224.969,0.700%20225.100%20C%201.036%20225.212,1.200%20226.176,1.200%20228.033%20C%201.200%20229.611,1.372%20230.800,1.600%20230.800%20C%201.826%20230.800,2.000%20231.941,2.000%20233.424%20C%202.000%20235.071,2.149%20235.955,2.400%20235.800%20C%202.648%20235.647,2.800%20236.396,2.800%20237.776%20C%202.800%20238.999,2.980%20240.000,3.200%20240.000%20C%203.420%20240.000,3.600%20240.799,3.600%20241.776%20C%203.600%20242.753,3.780%20243.664,4.000%20243.800%20C%204.220%20243.936,4.400%20244.757,4.400%20245.624%20C%204.400%20246.491,4.580%20247.200,4.800%20247.200%20C%205.020%20247.200,5.200%20247.920,5.200%20248.800%20C%205.200%20249.680,5.380%20250.400,5.600%20250.400%20C%205.820%20250.400,6.000%20251.120,6.000%20252.000%20C%206.000%20252.880,6.180%20253.600,6.400%20253.600%20C%206.620%20253.600,6.800%20254.140,6.800%20254.800%20C%206.800%20255.460,6.980%20256.000,7.200%20256.000%20C%207.420%20256.000,7.600%20256.630,7.600%20257.400%20C%207.600%20258.170,7.780%20258.800,8.000%20258.800%20C%208.220%20258.800,8.400%20259.229,8.400%20259.754%20C%208.400%20260.778,9.440%20264.553,10.037%20265.695%20C%2010.237%20266.077,10.400%20266.664,10.400%20267.000%20C%2010.400%20267.336,10.559%20267.923,10.753%20268.305%20C%2010.948%20268.687,11.329%20269.540,11.600%20270.200%20C%2011.871%20270.860,12.252%20271.713,12.447%20272.095%20C%2012.641%20272.477,12.800%20273.152,12.800%20273.595%20C%2012.800%20274.038,12.980%20274.400,13.200%20274.400%20C%2013.420%20274.400,13.600%20274.760,13.600%20275.200%20C%2013.600%20275.640,13.780%20276.000,14.000%20276.000%20C%2014.220%20276.000,14.400%20276.540,14.400%20277.200%20C%2014.400%20277.860,14.580%20278.400,14.800%20278.400%20C%2015.020%20278.400,15.200%20278.760,15.200%20279.200%20C%2015.200%20279.640,15.380%20280.000,15.600%20280.000%20C%2015.820%20280.000,16.000%20280.360,16.000%20280.800%20C%2016.000%20281.240,16.180%20281.600,16.400%20281.600%20C%2016.620%20281.600,16.800%20281.960,16.800%20282.400%20C%2016.800%20282.840,16.980%20283.200,17.200%20283.200%20C%2017.420%20283.200,17.600%20283.639,17.600%20284.176%20C%2017.600%20284.713,17.780%20285.264,18.000%20285.400%20C%2018.220%20285.536,18.400%20285.997,18.400%20286.424%20C%2018.400%20286.851,18.535%20287.201,18.700%20287.201%20C%2018.865%20287.202,19.450%20288.192,20.000%20289.400%20C%2020.550%20290.608,21.135%20291.598,21.300%20291.599%20C%2021.465%20291.599,21.600%20291.960,21.600%20292.400%20C%2021.600%20292.840,21.780%20293.200,22.000%20293.200%20C%2022.220%20293.200,22.400%20293.560,22.400%20294.000%20C%2022.400%20294.440,22.580%20294.800,22.800%20294.800%20C%2023.020%20294.800,23.200%20295.036,23.200%20295.325%20C%2023.200%20295.613,23.560%20296.236,24.000%20296.708%20C%2024.440%20297.180,24.800%20297.775,24.800%20298.029%20C%2024.800%20298.611,26.895%20302.553,27.300%20302.733%20C%2027.465%20302.807,27.600%20303.044,27.600%20303.261%20C%2027.600%20303.478,28.140%20304.441,28.800%20305.400%20C%2029.460%20306.359,30.000%20307.297,30.000%20307.484%20C%2030.000%20307.671,30.360%20308.083,30.800%20308.400%20C%2031.240%20308.717,31.600%20309.257,31.600%20309.600%20C%2031.600%20309.943,31.960%20310.483,32.400%20310.800%20C%2032.840%20311.117,33.200%20311.657,33.200%20312.000%20C%2033.200%20312.343,33.560%20312.883,34.000%20313.200%20C%2034.440%20313.517,34.800%20314.057,34.800%20314.400%20C%2034.800%20314.743,35.160%20315.283,35.600%20315.600%20C%2036.040%20315.917,36.400%20316.417,36.400%20316.712%20C%2036.400%20317.006,36.580%20317.136,36.800%20317.000%20C%2037.020%20316.864,37.200%20317.084,37.200%20317.488%20C%2037.200%20317.893,37.560%20318.483,38.000%20318.800%20C%2038.440%20319.117,38.800%20319.625,38.800%20319.928%20C%2038.800%20320.231,39.340%20320.983,40.000%20321.600%20C%2040.660%20322.217,41.200%20322.836,41.200%20322.977%20C%2041.200%20323.264,41.469%20323.610,43.199%20325.542%20C%2043.859%20326.281,44.400%20327.041,44.400%20327.232%20C%2044.400%20327.423,45.167%20328.349,46.105%20329.289%20C%2047.043%20330.230,48.255%20331.630,48.799%20332.400%20C%2049.342%20333.170,51.590%20335.561,53.793%20337.713%20C%2058.611%20342.418,57.582%20341.389,62.287%20346.207%20C%2064.439%20348.410,66.830%20350.654,67.600%20351.194%20C%2068.370%20351.733,69.654%20352.848,70.454%20353.672%20C%2071.253%20354.495,72.143%20355.221,72.432%20355.285%20C%2072.720%20355.348,73.557%20355.985,74.291%20356.700%20C%2075.026%20357.415,75.779%20358.000,75.965%20358.000%20C%2076.151%20358.000,77.045%20358.720,77.952%20359.600%20C%2078.859%20360.480,79.831%20361.200,80.112%20361.200%20C%2080.393%20361.200,80.883%20361.560,81.200%20362.000%20C%2081.517%20362.440,81.980%20362.800,82.229%20362.800%20C%2082.478%20362.800,83.246%20363.340,83.937%20364.000%20C%2084.628%20364.660,85.425%20365.200,85.708%20365.200%20C%2085.991%20365.200,86.483%20365.560,86.800%20366.000%20C%2087.117%20366.440,87.657%20366.800,88.000%20366.800%20C%2088.343%20366.800,88.883%20367.160,89.200%20367.600%20C%2089.517%20368.040,90.057%20368.400,90.400%20368.400%20C%2090.743%20368.400,91.283%20368.760,91.600%20369.200%20C%2091.917%20369.640,92.329%20370.000,92.516%20370.000%20C%2092.703%20370.000,93.641%20370.540,94.600%20371.200%20C%2095.559%20371.860,96.522%20372.400,96.739%20372.400%20C%2096.956%20372.400,97.193%20372.535,97.267%20372.700%20C%2097.447%20373.105,101.389%20375.200,101.971%20375.200%20C%20102.225%20375.200,102.820%20375.560,103.292%20376.000%20C%20103.764%20376.440,104.387%20376.800,104.675%20376.800%20C%20104.964%20376.800,105.200%20376.980,105.200%20377.200%20C%20105.200%20377.420,105.560%20377.600,106.000%20377.600%20C%20106.440%20377.600,106.800%20377.780,106.800%20378.000%20C%20106.800%20378.220,107.160%20378.400,107.600%20378.400%20C%20108.040%20378.400,108.400%20378.580,108.400%20378.800%20C%20108.400%20379.020,108.745%20379.200,109.167%20379.200%20C%20109.588%20379.200,109.993%20379.335,110.067%20379.500%20C%20110.288%20379.999,113.622%20381.600,114.438%20381.600%20C%20114.857%20381.600,115.200%20381.780,115.200%20382.000%20C%20115.200%20382.220,115.560%20382.400,116.000%20382.400%20C%20116.440%20382.400,116.800%20382.580,116.800%20382.800%20C%20116.800%20383.020,117.160%20383.200,117.600%20383.200%20C%20118.040%20383.200,118.400%20383.380,118.400%20383.600%20C%20118.400%20383.820,118.760%20384.000,119.200%20384.000%20C%20119.640%20384.000,120.000%20384.180,120.000%20384.400%20C%20120.000%20384.620,120.349%20384.800,120.776%20384.800%20C%20121.203%20384.800,121.664%20384.980,121.800%20385.200%20C%20121.936%20385.420,122.487%20385.600,123.024%20385.600%20C%20123.561%20385.600,124.000%20385.780,124.000%20386.000%20C%20124.000%20386.220,124.360%20386.400,124.800%20386.400%20C%20125.240%20386.400,125.600%20386.580,125.600%20386.800%20C%20125.600%20387.020,125.962%20387.200,126.405%20387.200%20C%20126.848%20387.200,127.523%20387.359,127.905%20387.553%20C%20128.840%20388.029,130.307%20388.618,132.000%20389.200%20C%20132.770%20389.464,133.760%20389.823,134.200%20389.997%20C%20136.018%20390.715,139.355%20391.600,140.246%20391.600%20C%20140.771%20391.600,141.200%20391.780,141.200%20392.000%20C%20141.200%20392.220,141.830%20392.400,142.600%20392.400%20C%20143.370%20392.400,144.000%20392.580,144.000%20392.800%20C%20144.000%20393.020,144.529%20393.200,145.176%20393.200%20C%20145.823%20393.200,146.464%20393.380,146.600%20393.600%20C%20146.736%20393.820,147.467%20394.000,148.224%20394.000%20C%20148.981%20394.000,149.600%20394.180,149.600%20394.400%20C%20149.600%20394.620,150.320%20394.800,151.200%20394.800%20C%20152.080%20394.800,152.800%20394.980,152.800%20395.200%20C%20152.800%20395.420,153.509%20395.600,154.376%20395.600%20C%20155.243%20395.600,156.064%20395.780,156.200%20396.000%20C%20156.336%20396.220,157.247%20396.400,158.224%20396.400%20C%20159.201%20396.400,160.000%20396.580,160.000%20396.800%20C%20160.000%20397.020,160.990%20397.200,162.200%20397.200%20C%20163.410%20397.200,164.400%20397.380,164.400%20397.600%20C%20164.400%20397.820,165.379%20398.000,166.576%20398.000%20C%20167.773%20398.000,168.864%20398.180,169.000%20398.400%20C%20169.136%20398.620,170.482%20398.800,171.990%20398.800%20C%20173.829%20398.800,174.788%20398.965,174.900%20399.300%20C%20175.144%20400.032,224.856%20400.032,225.100%20399.300%20C%20225.212%20398.965,226.171%20398.800,228.010%20398.800%20C%20229.518%20398.800,230.864%20398.620,231.000%20398.400%20C%20231.136%20398.180,232.227%20398.000,233.424%20398.000%20C%20234.621%20398.000,235.600%20397.820,235.600%20397.600%20C%20235.600%20397.380,236.590%20397.200,237.800%20397.200%20C%20239.010%20397.200,240.000%20397.020,240.000%20396.800%20C%20240.000%20396.580,240.709%20396.400,241.576%20396.400%20C%20242.443%20396.400,243.264%20396.220,243.400%20396.000%20C%20243.536%20395.780,244.447%20395.600,245.424%20395.600%20C%20246.401%20395.600,247.200%20395.420,247.200%20395.200%20C%20247.200%20394.980,247.920%20394.800,248.800%20394.800%20C%20249.680%20394.800,250.400%20394.620,250.400%20394.400%20C%20250.400%20394.180,251.019%20394.000,251.776%20394.000%20C%20252.533%20394.000,253.264%20393.820,253.400%20393.600%20C%20253.536%20393.380,254.177%20393.200,254.824%20393.200%20C%20255.471%20393.200,256.000%20393.020,256.000%20392.800%20C%20256.000%20392.580,256.630%20392.400,257.400%20392.400%20C%20258.170%20392.400,258.800%20392.220,258.800%20392.000%20C%20258.800%20391.780,259.229%20391.600,259.754%20391.600%20C%20260.778%20391.600,264.553%20390.560,265.695%20389.963%20C%20266.077%20389.763,266.664%20389.600,267.000%20389.600%20C%20267.336%20389.600,267.923%20389.441,268.305%20389.247%20C%20268.687%20389.052,269.540%20388.671,270.200%20388.400%20C%20270.860%20388.129,271.713%20387.748,272.095%20387.553%20C%20272.477%20387.359,273.152%20387.200,273.595%20387.200%20C%20274.038%20387.200,274.400%20387.020,274.400%20386.800%20C%20274.400%20386.580,274.760%20386.400,275.200%20386.400%20C%20275.640%20386.400,276.000%20386.220,276.000%20386.000%20C%20276.000%20385.780,276.540%20385.600,277.200%20385.600%20C%20277.860%20385.600,278.400%20385.420,278.400%20385.200%20C%20278.400%20384.980,278.760%20384.800,279.200%20384.800%20C%20279.640%20384.800,280.000%20384.620,280.000%20384.400%20C%20280.000%20384.180,280.360%20384.000,280.800%20384.000%20C%20281.240%20384.000,281.600%20383.820,281.600%20383.600%20C%20281.600%20383.380,281.872%20383.200,282.205%20383.200%20C%20282.793%20383.200,283.218%20383.033,285.095%20382.062%20C%20285.587%20381.808,286.262%20381.600,286.595%20381.600%20C%20286.928%20381.600,287.201%20381.465,287.201%20381.300%20C%20287.202%20381.135,288.192%20380.550,289.400%20380.000%20C%20290.608%20379.450,291.598%20378.865,291.599%20378.700%20C%20291.599%20378.535,291.945%20378.400,292.367%20378.400%20C%20292.788%20378.400,293.193%20378.265,293.267%20378.100%20C%20293.340%20377.935,294.255%20377.367,295.300%20376.837%20C%20296.345%20376.308,297.200%20375.723,297.200%20375.537%20C%20297.200%20375.352,297.491%20375.200,297.846%20375.200%20C%20298.562%20375.200,302.523%20373.174,302.733%20372.700%20C%20302.807%20372.535,303.044%20372.400,303.261%20372.400%20C%20303.478%20372.400,304.441%20371.860,305.400%20371.200%20C%20306.359%20370.540,307.297%20370.000,307.484%20370.000%20C%20307.671%20370.000,308.083%20369.640,308.400%20369.200%20C%20308.717%20368.760,309.257%20368.400,309.600%20368.400%20C%20309.943%20368.400,310.483%20368.040,310.800%20367.600%20C%20311.117%20367.160,311.657%20366.800,312.000%20366.800%20C%20312.343%20366.800,312.883%20366.440,313.200%20366.000%20C%20313.517%20365.560,314.057%20365.200,314.400%20365.200%20C%20314.743%20365.200,315.283%20364.840,315.600%20364.400%20C%20315.917%20363.960,316.417%20363.600,316.712%20363.600%20C%20317.006%20363.600,317.136%20363.420,317.000%20363.200%20C%20316.864%20362.980,317.084%20362.800,317.488%20362.800%20C%20317.893%20362.800,318.483%20362.440,318.800%20362.000%20C%20319.117%20361.560,319.625%20361.200,319.928%20361.200%20C%20320.231%20361.200,320.983%20360.660,321.600%20360.000%20C%20322.217%20359.340,322.836%20358.800,322.977%20358.800%20C%20323.264%20358.800,323.610%20358.531,325.542%20356.801%20C%20326.281%20356.141,327.041%20355.600,327.232%20355.600%20C%20327.423%20355.600,328.349%20354.833,329.289%20353.895%20C%20330.230%20352.957,331.630%20351.745,332.400%20351.201%20C%20333.170%20350.658,335.561%20348.410,337.713%20346.207%20C%20342.418%20341.389,341.389%20342.418,346.207%20337.713%20C%20348.410%20335.561,350.658%20333.170,351.201%20332.400%20C%20351.745%20331.630,352.957%20330.230,353.895%20329.289%20C%20354.833%20328.349,355.600%20327.423,355.600%20327.232%20C%20355.600%20327.041,356.140%20326.307,356.800%20325.600%20C%20357.460%20324.893,358.000%20324.054,358.000%20323.734%20C%20358.000%20323.414,358.180%20323.264,358.400%20323.400%20C%20358.620%20323.536,358.800%20323.439,358.800%20323.184%20C%20358.800%20322.929,359.340%20322.217,360.000%20321.600%20C%20360.660%20320.983,361.200%20320.231,361.200%20319.928%20C%20361.200%20319.625,361.560%20319.117,362.000%20318.800%20C%20362.440%20318.483,362.800%20317.893,362.800%20317.488%20C%20362.800%20317.084,362.980%20316.864,363.200%20317.000%20C%20363.420%20317.136,363.600%20317.006,363.600%20316.712%20C%20363.600%20316.417,363.960%20315.917,364.400%20315.600%20C%20364.840%20315.283,365.200%20314.743,365.200%20314.400%20C%20365.200%20314.057,365.560%20313.517,366.000%20313.200%20C%20366.440%20312.883,366.800%20312.343,366.800%20312.000%20C%20366.800%20311.657,367.160%20311.117,367.600%20310.800%20C%20368.040%20310.483,368.400%20309.943,368.400%20309.600%20C%20368.400%20309.257,368.760%20308.717,369.200%20308.400%20C%20369.640%20308.083,370.000%20307.671,370.000%20307.484%20C%20370.000%20307.297,370.540%20306.359,371.200%20305.400%20C%20371.860%20304.441,372.400%20303.463,372.400%20303.228%20C%20372.400%20302.993,372.580%20302.800,372.800%20302.800%20C%20373.020%20302.800,373.200%20302.440,373.200%20302.000%20C%20373.200%20301.560,373.347%20301.200,373.526%20301.200%20C%20373.874%20301.200,375.200%20298.642,375.200%20297.970%20C%20375.200%20297.748,375.560%20297.180,376.000%20296.708%20C%20376.440%20296.236,376.800%20295.613,376.800%20295.325%20C%20376.800%20295.036,376.980%20294.800,377.200%20294.800%20C%20377.420%20294.800,377.600%20294.440,377.600%20294.000%20C%20377.600%20293.560,377.780%20293.200,378.000%20293.200%20C%20378.220%20293.200,378.400%20292.840,378.400%20292.400%20C%20378.400%20291.960,378.535%20291.599,378.700%20291.599%20C%20378.865%20291.598,379.450%20290.608,380.000%20289.400%20C%20380.550%20288.192,381.135%20287.202,381.300%20287.201%20C%20381.465%20287.201,381.600%20286.851,381.600%20286.424%20C%20381.600%20285.997,381.780%20285.536,382.000%20285.400%20C%20382.220%20285.264,382.400%20284.713,382.400%20284.176%20C%20382.400%20283.639,382.580%20283.200,382.800%20283.200%20C%20383.020%20283.200,383.200%20282.840,383.200%20282.400%20C%20383.200%20281.960,383.380%20281.600,383.600%20281.600%20C%20383.820%20281.600,384.000%20281.240,384.000%20280.800%20C%20384.000%20280.360,384.180%20280.000,384.400%20280.000%20C%20384.620%20280.000,384.800%20279.651,384.800%20279.224%20C%20384.800%20278.797,384.980%20278.336,385.200%20278.200%20C%20385.420%20278.064,385.600%20277.513,385.600%20276.976%20C%20385.600%20276.439,385.780%20276.000,386.000%20276.000%20C%20386.220%20276.000,386.400%20275.640,386.400%20275.200%20C%20386.400%20274.760,386.580%20274.400,386.800%20274.400%20C%20387.020%20274.400,387.200%20274.038,387.200%20273.595%20C%20387.200%20273.152,387.359%20272.477,387.553%20272.095%20C%20387.748%20271.713,388.129%20270.860,388.400%20270.200%20C%20388.671%20269.540,389.052%20268.687,389.247%20268.305%20C%20389.441%20267.923,389.600%20267.336,389.600%20267.000%20C%20389.600%20266.664,389.763%20266.077,389.963%20265.695%20C%20390.560%20264.553,391.600%20260.778,391.600%20259.754%20C%20391.600%20259.229,391.780%20258.800,392.000%20258.800%20C%20392.220%20258.800,392.400%20258.170,392.400%20257.400%20C%20392.400%20256.630,392.580%20256.000,392.800%20256.000%20C%20393.020%20256.000,393.200%20255.471,393.200%20254.824%20C%20393.200%20254.177,393.380%20253.536,393.600%20253.400%20C%20393.820%20253.264,394.000%20252.533,394.000%20251.776%20C%20394.000%20251.019,394.180%20250.400,394.400%20250.400%20C%20394.620%20250.400,394.800%20249.680,394.800%20248.800%20C%20394.800%20247.920,394.980%20247.200,395.200%20247.200%20C%20395.420%20247.200,395.600%20246.491,395.600%20245.624%20C%20395.600%20244.757,395.780%20243.936,396.000%20243.800%20C%20396.220%20243.664,396.400%20242.753,396.400%20241.776%20C%20396.400%20240.799,396.580%20240.000,396.800%20240.000%20C%20397.020%20240.000,397.200%20239.010,397.200%20237.800%20C%20397.200%20236.590,397.380%20235.600,397.600%20235.600%20C%20397.820%20235.600,398.000%20234.621,398.000%20233.424%20C%20398.000%20232.227,398.180%20231.136,398.400%20231.000%20C%20398.620%20230.864,398.800%20229.518,398.800%20228.010%20C%20398.800%20226.171,398.965%20225.212,399.300%20225.100%20C%20399.693%20224.969,399.800%20219.591,399.800%20200.000%20C%20399.800%20180.409,399.693%20175.031,399.300%20174.900%20C%20398.965%20174.788,398.800%20173.829,398.800%20171.990%20C%20398.800%20170.482,398.620%20169.136,398.400%20169.000%20C%20398.180%20168.864,398.000%20167.773,398.000%20166.576%20C%20398.000%20165.379,397.820%20164.400,397.600%20164.400%20C%20397.380%20164.400,397.200%20163.410,397.200%20162.200%20C%20397.200%20160.990,397.020%20160.000,396.800%20160.000%20C%20396.580%20160.000,396.400%20159.201,396.400%20158.224%20C%20396.400%20157.247,396.220%20156.336,396.000%20156.200%20C%20395.780%20156.064,395.600%20155.243,395.600%20154.376%20C%20395.600%20153.509,395.420%20152.800,395.200%20152.800%20C%20394.980%20152.800,394.800%20152.080,394.800%20151.200%20C%20394.800%20150.320,394.620%20149.600,394.400%20149.600%20C%20394.180%20149.600,394.000%20148.981,394.000%20148.224%20C%20394.000%20147.467,393.820%20146.736,393.600%20146.600%20C%20393.380%20146.464,393.200%20145.823,393.200%20145.176%20C%20393.200%20144.529,393.020%20144.000,392.800%20144.000%20C%20392.580%20144.000,392.400%20143.370,392.400%20142.600%20C%20392.400%20141.830,392.220%20141.200,392.000%20141.200%20C%20391.780%20141.200,391.600%20140.771,391.600%20140.246%20C%20391.600%20139.222,390.560%20135.447,389.963%20134.305%20C%20389.763%20133.923,389.600%20133.336,389.600%20133.000%20C%20389.600%20132.664,389.441%20132.077,389.247%20131.695%20C%20389.052%20131.313,388.671%20130.460,388.400%20129.800%20C%20388.129%20129.140,387.748%20128.287,387.553%20127.905%20C%20387.359%20127.523,387.200%20126.848,387.200%20126.405%20C%20387.200%20125.962,387.020%20125.600,386.800%20125.600%20C%20386.580%20125.600,386.400%20125.240,386.400%20124.800%20C%20386.400%20124.360,386.220%20124.000,386.000%20124.000%20C%20385.780%20124.000,385.600%20123.460,385.600%20122.800%20C%20385.600%20122.140,385.420%20121.600,385.200%20121.600%20C%20384.980%20121.600,384.800%20121.240,384.800%20120.800%20C%20384.800%20120.360,384.620%20120.000,384.400%20120.000%20C%20384.180%20120.000,384.000%20119.640,384.000%20119.200%20C%20384.000%20118.760,383.820%20118.400,383.600%20118.400%20C%20383.380%20118.400,383.200%20118.040,383.200%20117.600%20C%20383.200%20117.160,383.020%20116.800,382.800%20116.800%20C%20382.580%20116.800,382.400%20116.361,382.400%20115.824%20C%20382.400%20115.287,382.220%20114.736,382.000%20114.600%20C%20381.780%20114.464,381.600%20114.003,381.600%20113.576%20C%20381.600%20113.149,381.420%20112.800,381.200%20112.800%20C%20380.980%20112.800,380.800%20112.440,380.800%20112.000%20C%20380.800%20111.560,380.654%20111.200,380.475%20111.200%20C%20380.296%20111.200,379.902%20110.570,379.600%20109.800%20C%20379.298%20109.030,378.904%20108.400,378.725%20108.400%20C%20378.546%20108.400,378.400%20108.040,378.400%20107.600%20C%20378.400%20107.160,378.220%20106.800,378.000%20106.800%20C%20377.780%20106.800,377.600%20106.440,377.600%20106.000%20C%20377.600%20105.560,377.420%20105.200,377.200%20105.200%20C%20376.980%20105.200,376.800%20104.964,376.800%20104.675%20C%20376.800%20104.387,376.440%20103.764,376.000%20103.292%20C%20375.560%20102.820,375.200%20102.240,375.200%20102.003%20C%20375.200%20101.371,373.157%2097.422,372.749%2097.267%20C%20372.557%2097.193,372.400%2096.956,372.400%2096.739%20C%20372.400%2096.522,371.860%2095.559,371.200%2094.600%20C%20370.540%2093.641,370.000%2092.703,370.000%2092.516%20C%20370.000%2092.329,369.640%2091.917,369.200%2091.600%20C%20368.760%2091.283,368.400%2090.743,368.400%2090.400%20C%20368.400%2090.057,368.040%2089.517,367.600%2089.200%20C%20367.160%2088.883,366.800%2088.343,366.800%2088.000%20C%20366.800%2087.657,366.440%2087.117,366.000%2086.800%20C%20365.560%2086.483,365.200%2085.943,365.200%2085.600%20C%20365.200%2085.257,364.840%2084.717,364.400%2084.400%20C%20363.960%2084.083,363.600%2083.620,363.600%2083.371%20C%20363.600%2083.122,363.060%2082.354,362.400%2081.663%20C%20361.740%2080.972,361.200%2080.208,361.200%2079.964%20C%20361.200%2079.720,360.660%2079.017,360.000%2078.400%20C%20359.340%2077.783,358.800%2077.071,358.800%2076.816%20C%20358.800%2076.561,358.620%2076.464,358.400%2076.600%20C%20358.180%2076.736,358.000%2076.586,358.000%2076.266%20C%20358.000%2075.946,357.460%2075.107,356.800%2074.400%20C%20356.140%2073.693,355.600%2072.959,355.600%2072.768%20C%20355.600%2072.577,354.833%2071.651,353.895%2070.711%20C%20352.957%2069.770,351.745%2068.370,351.201%2067.600%20C%20350.658%2066.830,348.410%2064.439,346.207%2062.287%20C%20344.003%2060.135,342.046%2058.218,341.859%2058.028%20C%20341.671%2057.838,339.644%2055.774,337.354%2053.441%20C%20335.064%2051.109,333.041%2049.200,332.858%2049.200%20C%20332.674%2049.200,331.502%2048.210,330.253%2047.000%20C%20329.004%2045.790,327.806%2044.800,327.591%2044.800%20C%20327.376%2044.800,327.200%2044.620,327.200%2044.400%20C%20327.200%2044.180,327.012%2044.000,326.782%2044.000%20C%20326.552%2044.000,325.930%2043.595,325.401%2043.100%20C%20323.937%2041.731,323.260%2041.200,322.977%2041.200%20C%20322.836%2041.200,322.217%2040.660,321.600%2040.000%20C%20320.983%2039.340,320.280%2038.800,320.036%2038.800%20C%20319.792%2038.800,319.028%2038.260,318.337%2037.600%20C%20317.646%2036.940,316.878%2036.400,316.629%2036.400%20C%20316.380%2036.400,315.917%2036.040,315.600%2035.600%20C%20315.283%2035.160,314.743%2034.800,314.400%2034.800%20C%20314.057%2034.800,313.517%2034.440,313.200%2034.000%20C%20312.883%2033.560,312.343%2033.200,312.000%2033.200%20C%20311.657%2033.200,311.117%2032.840,310.800%2032.400%20C%20310.483%2031.960,309.943%2031.600,309.600%2031.600%20C%20309.257%2031.600,308.717%2031.240,308.400%2030.800%20C%20308.083%2030.360,307.671%2030.000,307.484%2030.000%20C%20307.297%2030.000,306.359%2029.460,305.400%2028.800%20C%20304.441%2028.140,303.478%2027.600,303.261%2027.600%20C%20303.044%2027.600,302.807%2027.465,302.733%2027.300%20C%20302.523%2026.826,298.562%2024.800,297.846%2024.800%20C%20297.491%2024.800,297.200%2024.648,297.200%2024.463%20C%20297.200%2024.277,296.345%2023.692,295.300%2023.163%20C%20294.255%2022.633,293.340%2022.065,293.267%2021.900%20C%20293.193%2021.735,292.788%2021.600,292.367%2021.600%20C%20291.945%2021.600,291.600%2021.454,291.600%2021.275%20C%20291.600%2021.096,290.970%2020.702,290.200%2020.400%20C%20289.430%2020.098,288.800%2019.704,288.800%2019.525%20C%20288.800%2019.346,288.440%2019.200,288.000%2019.200%20C%20287.560%2019.200,287.200%2019.020,287.200%2018.800%20C%20287.200%2018.580,286.851%2018.400,286.424%2018.400%20C%20285.997%2018.400,285.536%2018.220,285.400%2018.000%20C%20285.264%2017.780,284.713%2017.600,284.176%2017.600%20C%20283.639%2017.600,283.200%2017.420,283.200%2017.200%20C%20283.200%2016.980,282.840%2016.800,282.400%2016.800%20C%20281.960%2016.800,281.600%2016.620,281.600%2016.400%20C%20281.600%2016.180,281.240%2016.000,280.800%2016.000%20C%20280.360%2016.000,280.000%2015.820,280.000%2015.600%20C%20280.000%2015.380,279.640%2015.200,279.200%2015.200%20C%20278.760%2015.200,278.400%2015.020,278.400%2014.800%20C%20278.400%2014.580,277.860%2014.400,277.200%2014.400%20C%20276.540%2014.400,276.000%2014.220,276.000%2014.000%20C%20276.000%2013.780,275.640%2013.600,275.200%2013.600%20C%20274.760%2013.600,274.400%2013.420,274.400%2013.200%20C%20274.400%2012.980,274.038%2012.800,273.595%2012.800%20C%20273.152%2012.800,272.477%2012.641,272.095%2012.447%20C%20271.713%2012.252,270.860%2011.871,270.200%2011.600%20C%20269.540%2011.329,268.687%2010.948,268.305%2010.753%20C%20267.923%2010.559,267.336%2010.400,267.000%2010.400%20C%20266.664%2010.400,266.077%2010.237,265.695%2010.037%20C%20264.553%209.440,260.778%208.400,259.754%208.400%20C%20259.229%208.400,258.800%208.220,258.800%208.000%20C%20258.800%207.780,258.170%207.600,257.400%207.600%20C%20256.630%207.600,256.000%207.420,256.000%207.200%20C%20256.000%206.980,255.460%206.800,254.800%206.800%20C%20254.140%206.800,253.600%206.620,253.600%206.400%20C%20253.600%206.180,252.880%206.000,252.000%206.000%20C%20251.120%206.000,250.400%205.820,250.400%205.600%20C%20250.400%205.380,249.680%205.200,248.800%205.200%20C%20247.920%205.200,247.200%205.020,247.200%204.800%20C%20247.200%204.580,246.491%204.400,245.624%204.400%20C%20244.757%204.400,243.936%204.220,243.800%204.000%20C%20243.664%203.780,242.753%203.600,241.776%203.600%20C%20240.799%203.600,240.000%203.420,240.000%203.200%20C%20240.000%202.980,238.999%202.800,237.776%202.800%20C%20236.396%202.800,235.647%202.648,235.800%202.400%20C%20235.955%202.149,235.071%202.000,233.424%202.000%20C%20231.941%202.000,230.800%201.826,230.800%201.600%20C%20230.800%201.372,229.611%201.200,228.033%201.200%20C%20226.198%201.200,225.211%201.034,225.103%200.708%20C%20224.941%200.222,187.291%20-0.126,178.300%200.275%20M202.526%20120.828%20C%20204.335%20121.331,207.200%20124.113,207.200%20125.368%20C%20207.200%20125.848,207.365%20126.411,207.566%20126.620%20C%20207.768%20126.829,208.031%20128.080,208.151%20129.400%20C%20208.271%20130.720,208.544%20133.060,208.758%20134.600%20C%20208.972%20136.140,209.341%20138.840,209.577%20140.600%20C%20210.094%20144.445,210.667%20148.639,211.175%20152.300%20C%20211.381%20153.785,211.741%20156.395,211.975%20158.100%20C%20212.372%20160.995,212.598%20162.678,213.586%20170.100%20C%20213.799%20171.695,214.147%20174.260,214.361%20175.800%20C%20214.574%20177.340,214.934%20180.040,215.160%20181.800%20C%20215.386%20183.560,216.034%20188.420,216.599%20192.600%20C%20217.967%20202.710,218.353%20205.594,218.847%20209.400%20C%20219.464%20214.159,219.900%20217.441,220.375%20220.900%20C%20220.609%20222.605,220.957%20225.363,221.150%20227.030%20C%20221.497%20230.036,222.400%20232.112,222.400%20229.904%20C%20222.400%20229.323,222.580%20228.736,222.800%20228.600%20C%20223.020%20228.464,223.200%20227.924,223.200%20227.400%20C%20223.200%20226.876,223.380%20226.336,223.600%20226.200%20C%20223.820%20226.064,224.000%20225.601,224.000%20225.171%20C%20224.000%20224.741,224.162%20224.077,224.361%20223.695%20C%20224.560%20223.313,224.937%20222.190,225.200%20221.200%20C%20225.463%20220.210,225.840%20219.087,226.039%20218.705%20C%20226.238%20218.323,226.400%20217.736,226.400%20217.400%20C%20226.400%20217.064,226.562%20216.477,226.759%20216.095%20C%20226.956%20215.713,227.515%20214.050,228.000%20212.400%20C%20228.485%20210.750,229.044%20209.087,229.241%20208.705%20C%20229.438%20208.323,229.600%20207.736,229.600%20207.400%20C%20229.600%20207.064,229.762%20206.477,229.961%20206.095%20C%20230.159%20205.713,230.983%20203.240,231.791%20200.600%20C%20234.595%20191.440,236.485%20185.396,236.796%20184.600%20C%20236.968%20184.160,237.344%20182.990,237.632%20182.000%20C%20238.949%20177.469,241.390%20174.000,243.259%20174.000%20C%20243.646%20174.000,244.409%20173.797,244.954%20173.548%20C%20248.190%20172.074,252.986%20175.985,254.091%20181.000%20C%20254.285%20181.880,254.622%20183.410,254.840%20184.400%20C%20255.058%20185.390,255.330%20186.740,255.445%20187.400%20C%20255.560%20188.060,255.810%20188.960,256.000%20189.400%20C%20256.190%20189.840,256.454%20190.830,256.587%20191.600%20C%20257.173%20194.986,257.273%20195.443,257.600%20196.200%20C%20257.945%20196.998,258.249%20198.456,258.665%20201.303%20C%20258.786%20202.129,259.045%20202.905,259.242%20203.026%20C%20259.439%20203.148,259.601%20203.912,259.602%20204.724%20C%20259.605%20206.186,259.610%20206.191,260.135%20205.200%20C%20260.426%20204.650,261.699%20202.220,262.964%20199.800%20C%20267.294%20191.513,265.281%20192.000,295.200%20192.000%20C%20321.988%20192.000,321.465%20191.952,324.212%20194.684%20C%20328.311%20198.762,326.473%20205.804,320.866%20207.500%20C%20319.634%20207.873,313.734%20208.003,297.706%20208.012%20L%20276.200%20208.024%20274.959%20210.512%20C%20274.277%20211.880,272.229%20215.880,270.409%20219.400%20C%20268.588%20222.920,266.308%20227.330,265.341%20229.200%20C%20262.528%20234.645,259.288%20236.724,255.286%20235.654%20C%20250.764%20234.445,250.115%20233.293,247.592%20222.000%20C%20246.947%20219.116,246.348%20216.550,245.958%20215.000%20C%20245.737%20214.120,245.428%20212.773,245.272%20212.008%20L%20244.989%20210.615%20244.455%20212.408%20C%20244.162%20213.393,243.760%20214.513,243.561%20214.895%20C%20243.362%20215.277,243.200%20215.941,243.200%20216.371%20C%20243.200%20216.801,243.020%20217.264,242.800%20217.400%20C%20242.580%20217.536,242.400%20217.999,242.400%20218.429%20C%20242.400%20218.859,242.238%20219.523,242.039%20219.905%20C%20241.840%20220.287,241.463%20221.410,241.200%20222.400%20C%20240.937%20223.390,240.560%20224.513,240.361%20224.895%20C%20240.162%20225.277,240.000%20225.941,240.000%20226.371%20C%20240.000%20226.801,239.820%20227.264,239.600%20227.400%20C%20239.380%20227.536,239.200%20227.999,239.200%20228.429%20C%20239.200%20228.859,239.038%20229.523,238.841%20229.905%20C%20238.644%20230.287,238.103%20231.860,237.641%20233.400%20C%20237.178%20234.940,236.005%20238.720,235.034%20241.800%20C%20234.063%20244.880,232.335%20250.370,231.193%20254.000%20C%20230.051%20257.630,228.977%20260.960,228.806%20261.400%20C%20228.635%20261.840,228.095%20263.550,227.607%20265.200%20C%20227.118%20266.850,226.556%20268.513,226.359%20268.895%20C%20226.162%20269.277,226.000%20269.847,226.000%20270.163%20C%20226.000%20270.479,225.219%20271.516,224.265%20272.468%20C%20218.903%20277.819,211.668%20274.526,210.713%20266.300%20C%20210.541%20264.815,210.232%20262.385,210.027%20260.900%20C%20209.821%20259.415,209.449%20256.670,209.200%20254.800%20C%20208.585%20250.185,208.057%20246.312,207.619%20243.200%20C%20207.418%20241.770,207.059%20239.160,206.823%20237.400%20C%20206.586%20235.640,206.220%20232.940,206.009%20231.400%20C%20205.798%20229.860,205.439%20227.205,205.212%20225.500%20C%20204.170%20217.665,204.004%20216.428,203.639%20213.800%20C%20203.426%20212.260,203.061%20209.560,202.828%20207.800%20C%20202.595%20206.040,202.229%20203.340,202.015%20201.800%20C%20201.536%20198.347,201.159%20195.506,199.626%20183.800%20C%20198.964%20178.740,198.237%20173.340,198.010%20171.800%20C%20197.783%20170.260,197.546%20168.460,197.483%20167.800%20C%20197.376%20166.676,197.336%20166.713,196.847%20168.400%20C%20196.560%20169.390,196.162%20170.513,195.963%20170.895%20C%20195.763%20171.277,195.600%20171.894,195.600%20172.266%20C%20195.600%20173.023,194.889%20175.429,194.351%20176.495%20C%20194.158%20176.877,194.000%20177.631,194.000%20178.171%20C%20194.000%20178.711,193.820%20179.264,193.600%20179.400%20C%20193.380%20179.536,193.200%20180.166,193.200%20180.800%20C%20193.200%20181.434,193.020%20182.064,192.800%20182.200%20C%20192.580%20182.336,192.400%20182.966,192.400%20183.600%20C%20192.400%20184.234,192.220%20184.864,192.000%20185.000%20C%20191.780%20185.136,191.600%20185.766,191.600%20186.400%20C%20191.600%20187.034,191.420%20187.664,191.200%20187.800%20C%20190.980%20187.936,190.800%20188.566,190.800%20189.200%20C%20190.800%20189.834,190.620%20190.464,190.400%20190.600%20C%20190.180%20190.736,190.000%20191.366,190.000%20192.000%20C%20190.000%20192.634,189.820%20193.264,189.600%20193.400%20C%20189.380%20193.536,189.200%20194.166,189.200%20194.800%20C%20189.200%20195.434,189.020%20196.064,188.800%20196.200%20C%20188.580%20196.336,188.400%20196.878,188.400%20197.405%20C%20188.400%20197.931,188.239%20198.776,188.042%20199.281%20C%20187.845%20199.787,187.464%20201.010,187.195%20202.000%20C%20186.927%20202.990,186.569%20204.250,186.400%20204.800%20C%20186.002%20206.096,185.510%20207.859,183.778%20214.200%20C%20182.357%20219.402,181.519%20221.100,179.630%20222.600%20C%20177.803%20224.051,173.984%20224.945,173.432%20224.052%20C%20173.314%20223.860,172.716%20223.603,172.104%20223.481%20C%20168.849%20222.830,167.673%20220.360,166.164%20211.000%20C%20164.676%20201.774,164.407%20200.080,164.003%20197.400%20C%20163.284%20192.625,163.135%20192.576,161.610%20196.600%20C%20161.443%20197.040,161.079%20197.940,160.800%20198.600%20C%20160.321%20199.735,160.066%20200.379,159.257%20202.500%20C%20159.068%20202.995,158.528%20204.182,158.057%20205.138%20C%20157.586%20206.094,157.200%20207.041,157.200%20207.242%20C%20157.200%20207.444,156.822%20208.462,156.360%20209.504%20C%20155.291%20211.918,154.421%20214.019,153.587%20216.200%20C%20153.419%20216.640,153.011%20217.630,152.681%20218.400%20C%20152.351%20219.170,151.247%20221.944,150.228%20224.565%20C%20148.378%20229.325,148.081%20230.041,146.398%20233.800%20C%20142.941%20241.519,133.903%20240.639,131.200%20232.320%20C%20130.678%20230.714,130.137%20229.220,129.998%20229.000%20C%20129.858%20228.780,129.499%20227.790,129.200%20226.800%20C%20128.901%20225.810,128.541%20224.820,128.400%20224.600%20C%20128.259%20224.380,127.900%20223.390,127.602%20222.400%20C%20127.305%20221.410,126.912%20220.429,126.730%20220.220%20C%20126.549%20220.011,126.400%20219.514,126.400%20219.115%20C%20126.400%20218.716,126.220%20218.032,126.000%20217.595%20C%20125.780%20217.158,125.420%20216.442,125.200%20216.005%20C%20124.980%20215.568,124.800%20214.936,124.800%20214.600%20C%20124.800%20214.264,124.620%20213.632,124.400%20213.195%20C%20124.180%20212.758,123.820%20212.042,123.600%20211.605%20C%20123.380%20211.168,123.200%20210.484,123.200%20210.085%20C%20123.200%20209.686,123.051%20209.189,122.870%20208.980%20C%20122.688%20208.771,122.295%20207.790,121.998%20206.800%20C%20121.700%20205.810,121.341%20204.820,121.200%20204.600%20C%20121.059%20204.380,120.699%20203.390,120.400%20202.400%20C%20120.101%20201.410,119.741%20200.420,119.600%20200.200%20C%20119.459%20199.980,119.103%20199.035,118.808%20198.100%20C%20118.279%20196.422,117.482%20195.888,117.078%20196.941%20C%20115.894%20200.027,109.807%20206.955,107.866%20207.427%20C%20105.488%20208.004,64.003%20208.080,62.035%20207.511%20C%2056.308%20205.854,54.447%20198.817,58.629%20194.634%20C%2061.052%20192.211,60.469%20192.276,82.168%20192.025%20L%20101.737%20191.800%20104.080%20188.400%20C%20105.370%20186.530,106.689%20184.683,107.012%20184.295%20C%20107.335%20183.908,107.600%20183.428,107.600%20183.229%20C%20107.600%20183.030,107.747%20182.807,107.928%20182.733%20C%20108.108%20182.660,109.039%20181.430,109.998%20180.000%20C%20110.956%20178.570,111.844%20177.310,111.971%20177.200%20C%20112.098%20177.090,112.735%20176.215,113.387%20175.255%20C%20117.403%20169.338,124.548%20169.764,127.512%20176.096%20C%20128.001%20177.138,128.400%20178.227,128.400%20178.516%20C%20128.400%20178.804,128.543%20179.211,128.718%20179.420%20C%20128.893%20179.629,129.265%20180.520,129.545%20181.400%20C%20129.824%20182.280,130.210%20183.360,130.402%20183.800%20C%20130.739%20184.571,131.879%20187.811,135.256%20197.600%20C%20136.129%20200.130,136.996%20202.560,137.181%20203.000%20C%20137.367%20203.440,137.736%20204.430,138.000%20205.200%20C%20138.264%20205.970,138.629%20206.960,138.811%20207.400%20C%20138.993%20207.840,139.205%20208.442,139.283%20208.737%20C%20139.419%20209.253,139.949%20208.371,140.746%20206.300%20C%20141.538%20204.243,143.064%20200.665,143.844%20199.039%20C%20144.150%20198.400,144.400%20197.716,144.400%20197.519%20C%20144.400%20197.322,144.760%20196.416,145.200%20195.506%20C%20145.640%20194.595,146.000%20193.702,146.000%20193.521%20C%20146.000%20193.339,146.345%20192.428,146.767%20191.496%20C%20147.189%20190.563,148.646%20187.010,150.006%20183.600%20C%20151.365%20180.190,152.749%20176.770,153.080%20176.000%20C%20153.411%20175.230,153.843%20174.195,154.041%20173.700%20C%20154.238%20173.205,154.580%20172.350,154.800%20171.800%20C%20155.020%20171.250,155.356%20170.395,155.546%20169.900%20C%20156.475%20167.487,158.070%20163.813,158.844%20162.305%20C%20159.040%20161.923,159.200%20161.353,159.200%20161.037%20C%20159.200%20160.721,159.979%20159.684,160.932%20158.732%20C%20164.275%20155.390,168.506%20155.371,171.818%20158.681%20C%20173.788%20160.651,173.721%20160.439,175.198%20169.400%20C%20176.883%20179.632,177.087%20180.708,177.147%20179.724%20C%20177.176%20179.242,177.380%20178.736,177.600%20178.600%20C%20177.820%20178.464,178.000%20177.834,178.000%20177.200%20C%20178.000%20176.566,178.160%20175.948,178.356%20175.827%20C%20178.551%20175.706,178.805%20175.021,178.919%20174.304%20C%20179.032%20173.587,179.322%20172.325,179.563%20171.500%20C%20180.530%20168.181,180.771%20167.342,181.140%20166.000%20C%20181.352%20165.230,182.082%20162.620,182.761%20160.200%20C%20183.441%20157.780,184.198%20155.080,184.445%20154.200%20C%20184.691%20153.320,185.031%20152.150,185.200%20151.600%20C%20185.369%20151.050,185.729%20149.790,186.000%20148.800%20C%20186.271%20147.810,186.631%20146.550,186.800%20146.000%20C%20186.969%20145.450,187.329%20144.190,187.600%20143.200%20C%20187.871%20142.210,188.231%20140.950,188.400%20140.400%20C%20188.569%20139.850,188.929%20138.590,189.200%20137.600%20C%20189.471%20136.610,189.831%20135.350,190.000%20134.800%20C%20190.169%20134.250,190.529%20132.990,190.800%20132.000%20C%20191.071%20131.010,191.436%20129.750,191.612%20129.200%20C%20191.787%20128.650,192.169%20127.334,192.460%20126.275%20C%20193.681%20121.837,197.913%20119.547,202.526%20120.828%20'%20stroke='none'%20fill='%230c244c'%20fill-rule='evenodd'%3e%3c/path%3e%3cpath%20id='path2'%20d='M199.100%20120.682%20C%20199.595%20120.778,200.405%20120.778,200.900%20120.682%20C%20201.395%20120.587,200.990%20120.509,200.000%20120.509%20C%20199.010%20120.509,198.605%20120.587,199.100%20120.682%20M196.000%20121.400%20C%20195.450%20121.714,195.180%20121.972,195.400%20121.972%20C%20195.620%20121.972,196.250%20121.714,196.800%20121.400%20C%20197.350%20121.086,197.620%20120.828,197.400%20120.828%20C%20197.180%20120.828,196.550%20121.086,196.000%20121.400%20M203.200%20121.400%20C%20203.750%20121.714,204.380%20121.972,204.600%20121.972%20C%20204.820%20121.972,204.550%20121.714,204.000%20121.400%20C%20203.450%20121.086,202.820%20120.828,202.600%20120.828%20C%20202.380%20120.828,202.650%20121.086,203.200%20121.400%20M193.269%20124.039%20C%20192.510%20125.254,192.966%20125.416,193.755%20124.212%20C%20194.120%20123.656,194.278%20123.200,194.105%20123.200%20C%20193.933%20123.200,193.557%20123.578,193.269%20124.039%20M206.245%20124.212%20C%20206.610%20124.769,206.986%20125.147,207.082%20125.051%20C%20207.319%20124.814,206.284%20123.200,205.895%20123.200%20C%20205.722%20123.200,205.880%20123.656,206.245%20124.212%20M207.480%20127.891%20C%20207.790%20129.900,208.000%20130.061,208.000%20128.290%20C%20208.000%20127.497,207.831%20126.743,207.624%20126.615%20C%20207.399%20126.476,207.341%20126.991,207.480%20127.891%20M208.259%20133.400%20C%20208.399%20134.500,208.577%20135.475,208.656%20135.567%20C%20208.999%20135.964,208.750%20132.541,208.397%20132.000%20C%20208.130%20131.590,208.086%20132.035,208.259%20133.400%20M189.049%20137.815%20C%20188.912%20138.173,188.815%20138.766,188.834%20139.133%20C%20188.853%20139.500,189.027%20139.269,189.221%20138.620%20C%20189.598%20137.358,189.465%20136.733,189.049%20137.815%20M209.068%20139.200%20C%20209.200%20140.410,209.374%20141.475,209.454%20141.567%20C%20209.764%20141.921,209.525%20138.557,209.186%20137.800%20C%20208.952%20137.278,208.912%20137.763,209.068%20139.200%20M188.249%20140.615%20C%20188.112%20140.973,188.015%20141.566,188.034%20141.933%20C%20188.053%20142.300,188.227%20142.069,188.421%20141.420%20C%20188.798%20140.158,188.665%20139.533,188.249%20140.615%20M187.449%20143.415%20C%20187.312%20143.773,187.215%20144.366,187.234%20144.733%20C%20187.253%20145.100,187.427%20144.869,187.621%20144.220%20C%20187.998%20142.958,187.865%20142.333,187.449%20143.415%20M209.888%20145.200%20C%20210.011%20146.410,210.177%20147.475,210.256%20147.567%20C%20210.553%20147.911,210.330%20144.567,210.004%20143.800%20C%20209.792%20143.302,209.749%20143.831,209.888%20145.200%20M186.649%20146.215%20C%20186.512%20146.573,186.415%20147.166,186.434%20147.533%20C%20186.453%20147.900,186.627%20147.669,186.821%20147.020%20C%20187.198%20145.758,187.065%20145.133,186.649%20146.215%20M185.849%20149.015%20C%20185.712%20149.373,185.615%20149.966,185.634%20150.333%20C%20185.653%20150.700,185.827%20150.469,186.021%20149.820%20C%20186.398%20148.558,186.265%20147.933,185.849%20149.015%20M210.688%20151.000%20C%20210.811%20152.320,210.976%20153.475,211.056%20153.567%20C%20211.335%20153.889,211.116%20150.588,210.793%20149.600%20C%20210.589%20148.979,210.549%20149.509,210.688%20151.000%20M185.049%20151.815%20C%20184.912%20152.173,184.815%20152.766,184.834%20153.133%20C%20184.853%20153.500,185.027%20153.269,185.221%20152.620%20C%20185.598%20151.358,185.465%20150.733,185.049%20151.815%20M184.249%20154.615%20C%20184.112%20154.973,184.015%20155.566,184.034%20155.933%20C%20184.053%20156.300,184.227%20156.069,184.421%20155.420%20C%20184.798%20154.158,184.665%20153.533,184.249%20154.615%20M211.476%20157.000%20C%20211.605%20158.320,211.776%20159.475,211.856%20159.567%20C%20212.163%20159.921,211.925%20156.157,211.592%20155.400%20C%20211.369%20154.892,211.326%20155.476,211.476%20157.000%20M165.049%20156.351%20C%20164.580%20156.536,165.086%20156.646,166.400%20156.646%20C%20167.714%20156.646,168.220%20156.536,167.751%20156.351%20C%20167.338%20156.189,166.730%20156.056,166.400%20156.056%20C%20166.070%20156.056,165.462%20156.189,165.049%20156.351%20M162.224%20157.413%20C%20161.236%20158.160,161.885%20158.152,163.200%20157.400%20C%20163.780%20157.068,163.948%20156.828,163.600%20156.827%20C%20163.270%20156.826,162.651%20157.090,162.224%20157.413%20M169.600%20157.400%20C%20170.915%20158.152,171.564%20158.160,170.576%20157.413%20C%20170.149%20157.090,169.530%20156.826,169.200%20156.827%20C%20168.852%20156.828,169.020%20157.068,169.600%20157.400%20M159.657%20160.057%20C%20159.375%20160.509,159.232%20160.966,159.340%20161.073%20C%20159.447%20161.181,159.744%20160.878,160.000%20160.400%20C%20160.256%20159.922,160.398%20159.465,160.317%20159.384%20C%20160.236%20159.303,159.939%20159.606,159.657%20160.057%20M212.294%20162.800%20C%20212.414%20164.230,212.577%20165.475,212.656%20165.567%20C%20212.935%20165.889,212.716%20162.188,212.398%20161.200%20C%20212.205%20160.600,212.163%20161.240,212.294%20162.800%20M182.446%20161.267%20C%20182.421%20161.634,182.296%20162.264,182.170%20162.667%20C%20181.952%20163.362,181.963%20163.363,182.397%20162.687%20C%20182.648%20162.296,182.773%20161.666,182.673%20161.287%20C%20182.511%20160.668,182.488%20160.666,182.446%20161.267%20M173.858%20163.200%20C%20174.175%20164.925,174.402%20165.251,174.394%20163.967%20C%20174.391%20163.435,174.211%20162.730,173.994%20162.400%20C%20173.718%20161.978,173.677%20162.215,173.858%20163.200%20M181.400%20164.800%20C%20181.250%20165.273,181.217%20165.750,181.327%20165.860%20C%20181.437%20165.970,181.650%20165.673,181.800%20165.200%20C%20181.950%20164.727,181.983%20164.250,181.873%20164.140%20C%20181.763%20164.030,181.550%20164.327,181.400%20164.800%20M174.673%20168.000%20C%20174.804%20168.990,174.976%20169.875,175.056%20169.967%20C%20175.357%20170.314,175.128%20167.764,174.790%20167.000%20C%20174.553%20166.466,174.514%20166.798,174.673%20168.000%20M213.094%20168.800%20C%20213.214%20170.230,213.377%20171.475,213.456%20171.567%20C%20213.735%20171.889,213.516%20168.188,213.198%20167.200%20C%20213.005%20166.600,212.963%20167.240,213.094%20168.800%20M180.600%20167.600%20C%20180.450%20168.073,180.417%20168.550,180.527%20168.660%20C%20180.637%20168.770,180.850%20168.473,181.000%20168.000%20C%20181.150%20167.527,181.183%20167.050,181.073%20166.940%20C%20180.963%20166.830,180.750%20167.127,180.600%20167.600%20M196.174%20169.100%20C%20196.042%20169.705,195.848%20170.470,195.743%20170.800%20C%20195.621%20171.184,195.686%20171.256,195.923%20171.000%20C%20196.322%20170.570,196.900%20168.000,196.598%20168.000%20C%20196.497%20168.000,196.307%20168.495,196.174%20169.100%20M197.687%20169.600%20C%20197.691%20170.150,197.832%20171.140,198.000%20171.800%20L%20198.305%20173.000%20198.313%20171.800%20C%20198.317%20171.140,198.176%20170.150,198.000%20169.600%20L%20197.680%20168.600%20197.687%20169.600%20M179.800%20170.400%20C%20179.650%20170.873,179.617%20171.350,179.727%20171.460%20C%20179.837%20171.570,180.050%20171.273,180.200%20170.800%20C%20180.350%20170.327,180.383%20169.850,180.273%20169.740%20C%20180.163%20169.630,179.950%20169.927,179.800%20170.400%20M119.000%20171.182%20C%20118.438%20171.410,118.790%20171.502,120.186%20171.489%20C%20121.540%20171.476,121.922%20171.373,121.386%20171.163%20C%20120.391%20170.775,119.993%20170.778,119.000%20171.182%20M175.473%20172.800%20C%20175.604%20173.790,175.776%20174.675,175.856%20174.767%20C%20176.157%20175.114,175.928%20172.564,175.590%20171.800%20C%20175.353%20171.266,175.314%20171.598,175.473%20172.800%20M115.543%20172.900%20C%20114.779%20173.615,114.524%20173.897,114.977%20173.527%20C%20115.430%20173.156,116.340%20172.572,117.000%20172.229%20C%20117.660%20171.886,117.915%20171.604,117.567%20171.602%20C%20117.218%20171.601,116.308%20172.185,115.543%20172.900%20M124.162%20172.600%20C%20124.972%20173.150,125.730%20173.600,125.846%20173.600%20C%20126.208%20173.600,125.026%20172.549,124.118%20172.063%20C%20122.608%20171.255,122.633%20171.563,124.162%20172.600%20M195.246%20172.467%20C%20195.221%20172.834,195.096%20173.464,194.970%20173.867%20C%20194.752%20174.562,194.763%20174.563,195.197%20173.887%20C%20195.448%20173.496,195.573%20172.866,195.473%20172.487%20C%20195.311%20171.868,195.288%20171.866,195.246%20172.467%20M179.000%20173.200%20C%20178.850%20173.673,178.817%20174.150,178.927%20174.260%20C%20179.037%20174.370,179.250%20174.073,179.400%20173.600%20C%20179.550%20173.127,179.583%20172.650,179.473%20172.540%20C%20179.363%20172.430,179.150%20172.727,179.000%20173.200%20M213.894%20174.800%20C%20214.014%20176.230,214.177%20177.475,214.256%20177.567%20C%20214.535%20177.889,214.316%20174.188,213.998%20173.200%20C%20213.805%20172.600,213.763%20173.240,213.894%20174.800%20M244.938%20173.506%20C%20244.685%20173.668,245.281%20173.818,246.263%20173.839%20C%20247.354%20173.863,247.845%20173.748,247.525%20173.545%20C%20246.876%20173.133,245.555%20173.114,244.938%20173.506%20M241.829%20174.609%20C%20240.663%20175.491,241.234%20175.594,242.600%20174.747%20C%20243.260%20174.339,243.530%20174.009,243.200%20174.015%20C%20242.870%20174.021,242.253%20174.288,241.829%20174.609%20M198.677%20176.600%20C%20198.800%20177.920,198.968%20179.075,199.050%20179.167%20C%20199.318%20179.464,199.115%20176.634,198.780%20175.400%20C%20198.565%20174.611,198.530%20175.022,198.677%20176.600%20M152.831%20176.500%20C%20152.639%20176.995,152.121%20178.300,151.680%20179.400%20C%20149.562%20184.686,149.170%20185.770,149.512%20185.400%20C%20149.715%20185.180,150.376%20183.740,150.982%20182.200%20C%20151.588%20180.660,152.422%20178.545,152.836%20177.500%20C%20153.250%20176.455,153.496%20175.600,153.384%20175.600%20C%20153.272%20175.600,153.023%20176.005,152.831%20176.500%20M176.273%20177.600%20C%20176.404%20178.590,176.576%20179.475,176.656%20179.567%20C%20176.957%20179.914,176.728%20177.364,176.390%20176.600%20C%20176.153%20176.066,176.114%20176.398,176.273%20177.600%20M239.249%20177.452%20C%20238.583%20178.914,238.874%20178.995,239.689%20177.574%20C%20240.060%20176.928,240.220%20176.400,240.046%20176.400%20C%20239.871%20176.400,239.513%20176.873,239.249%20177.452%20M110.868%20178.648%20C%20110.355%20179.440,110.122%20179.972,110.349%20179.831%20C%20110.982%20179.441,112.499%20177.199,112.127%20177.205%20C%20111.947%20177.208,111.381%20177.857,110.868%20178.648%20M214.914%20181.800%20C%20214.917%20182.900,214.995%20183.303,215.087%20182.695%20C%20215.179%20182.086,215.177%20181.186,215.082%20180.695%20C%20214.987%20180.203,214.911%20180.700,214.914%20181.800%20M199.477%20182.600%20C%20199.600%20183.920,199.768%20185.075,199.850%20185.167%20C%20200.118%20185.464,199.915%20182.634,199.580%20181.400%20C%20199.365%20180.611,199.330%20181.022,199.477%20182.600%20M237.449%20182.215%20C%20237.312%20182.573,237.215%20183.166,237.234%20183.533%20C%20237.253%20183.900,237.427%20183.669,237.621%20183.020%20C%20237.998%20181.758,237.865%20181.133,237.449%20182.215%20M254.034%20182.400%20C%20254.046%20182.730,254.211%20183.360,254.400%20183.800%20L%20254.744%20184.600%20254.766%20183.800%20C%20254.778%20183.360,254.613%20182.730,254.400%20182.400%20C%20254.055%20181.867,254.015%20181.867,254.034%20182.400%20M192.046%20183.467%20C%20192.021%20183.724,191.884%20184.264,191.741%20184.667%20C%20191.540%20185.236,191.594%20185.297,191.979%20184.942%20C%20192.252%20184.691,192.389%20184.151,192.284%20183.742%20C%20192.179%20183.334,192.072%20183.210,192.046%20183.467%20M130.372%20184.646%20C%20130.875%20186.319,131.546%20187.865,131.569%20187.400%20C%20131.594%20186.865,130.617%20184.083,130.286%20183.753%20C%20130.142%20183.609,130.181%20184.011,130.372%20184.646%20M105.697%20186.007%20C%20104.012%20188.585,104.308%20188.580,106.162%20186.000%20C%20106.952%20184.900,107.464%20184.003,107.299%20184.007%20C%20107.135%20184.011,106.414%20184.911,105.697%20186.007%20M200.285%20188.800%20C%20200.407%20190.230,200.572%20191.475,200.653%20191.567%20C%20200.920%20191.870,200.711%20188.622,200.385%20187.400%20C%20200.182%20186.644,200.146%20187.162,200.285%20188.800%20M215.647%20187.833%20C%20215.673%20188.695,215.839%20189.940,216.015%20190.600%20C%20216.218%20191.356,216.254%20190.838,216.115%20189.200%20C%20215.867%20186.286,215.575%20185.431,215.647%20187.833%20M234.840%20190.640%20C%20234.610%20191.473,234.494%20192.227,234.582%20192.315%20C%20234.670%20192.403,234.930%20191.793,235.160%20190.960%20C%20235.390%20190.127,235.506%20189.373,235.418%20189.285%20C%20235.330%20189.197,235.070%20189.807,234.840%20190.640%20M255.628%20189.476%20C%20255.718%20190.515,256.344%20191.396,256.372%20190.524%20C%20256.387%20190.042,256.220%20189.536,256.000%20189.400%20C%20255.780%20189.264,255.613%20189.298,255.628%20189.476%20M101.800%20191.600%20C%20101.641%20191.858,94.689%20192.002,82.276%20192.006%20C%2071.674%20192.009,62.792%20192.144,62.538%20192.306%20C%2062.283%20192.468,70.923%20192.548,81.738%20192.485%20C%2098.357%20192.389,101.491%20192.280,101.986%20191.785%20C%20102.308%20191.463,102.453%20191.200,102.309%20191.200%20C%20102.165%20191.200,101.936%20191.380,101.800%20191.600%20M132.845%20191.600%20C%20132.853%20191.930,133.206%20192.920,133.629%20193.800%20C%20134.052%20194.680,134.286%20194.962,134.149%20194.426%20C%20133.773%20192.961,132.829%20190.914,132.845%20191.600%20M270.138%20192.306%20C%20269.884%20192.468,281.162%20192.600,295.200%20192.600%20C%20309.238%20192.600,320.516%20192.468,320.262%20192.306%20C%20320.008%20192.144,308.730%20192.012,295.200%20192.012%20C%20281.670%20192.012,270.392%20192.144,270.138%20192.306%20M216.447%20193.833%20C%20216.473%20194.695,216.639%20195.940,216.815%20196.600%20C%20217.018%20197.356,217.054%20196.838,216.915%20195.200%20C%20216.667%20192.286,216.375%20191.431,216.447%20193.833%20M256.644%20193.400%20C%20256.973%20194.871,257.202%20195.190,257.194%20194.167%20C%20257.191%20193.745,257.005%20193.130,256.782%20192.800%20C%20256.485%20192.362,256.448%20192.524,256.644%20193.400%20M162.551%20193.433%20C%20162.400%20193.855,162.187%20194.363,162.077%20194.562%20C%20161.966%20194.761,162.084%20194.795,162.338%20194.638%20C%20162.592%20194.481,162.814%20194.048,162.830%20193.676%20C%20162.847%20193.304,163.119%20193.630,163.434%20194.400%20C%20163.970%20195.710,163.992%20195.723,163.775%20194.600%20C%20163.467%20193.005,162.899%20192.463,162.551%20193.433%20M266.898%20193.835%20C%20266.181%20194.400,265.400%20195.253,265.162%20195.731%20C%20264.844%20196.369,264.978%20196.304,265.664%20195.488%20C%20266.179%20194.876,267.140%20194.023,267.800%20193.591%20C%20268.460%20193.159,268.820%20192.806,268.600%20192.807%20C%20268.380%20192.808,267.614%20193.271,266.898%20193.835%20M322.176%20193.413%20C%20322.604%20193.736,323.133%20194.000,323.353%20194.000%20C%20323.573%20194.000,323.404%20193.736,322.976%20193.413%20C%20322.549%20193.090,322.020%20192.825,321.800%20192.825%20C%20321.580%20192.825,321.749%20193.090,322.176%20193.413%20M201.309%20196.000%20C%20201.309%20196.990,201.387%20197.395,201.482%20196.900%20C%20201.578%20196.405,201.578%20195.595,201.482%20195.100%20C%20201.387%20194.605,201.309%20195.010,201.309%20196.000%20M57.285%20196.013%20C%2057.018%20196.440,56.807%20197.017,56.816%20197.295%20C%2056.825%20197.573,57.109%20197.289,57.447%20196.665%20C%2058.150%20195.368,58.018%20194.838,57.285%20196.013%20M324.814%20195.424%20C%20324.839%20196.094,325.972%20197.830,325.973%20197.200%20C%20325.974%20196.870,325.710%20196.251,325.387%20195.824%20C%20325.064%20195.396,324.806%20195.216,324.814%20195.424%20M117.600%20196.001%20C%20117.075%20196.340,117.079%20196.389,117.636%20196.394%20C%20118.031%20196.398,118.474%20197.043,118.806%20198.100%20C%20119.409%20200.022,120.173%20201.184,119.643%20199.373%20C%20118.835%20196.615,118.221%20195.601,117.600%20196.001%20M257.228%20196.276%20C%20257.318%20197.315,257.944%20198.196,257.972%20197.324%20C%20257.987%20196.842,257.820%20196.336,257.600%20196.200%20C%20257.380%20196.064,257.213%20196.098,257.228%20196.276%20M164.080%20198.200%20C%20164.080%20198.640,164.224%20199.450,164.400%20200.000%20C%20164.654%20200.792,164.720%20200.833,164.720%20200.200%20C%20164.720%20199.760,164.576%20198.950,164.400%20198.400%20C%20164.146%20197.608,164.080%20197.567,164.080%20198.200%20M187.800%20198.400%20C%20187.650%20198.873,187.617%20199.350,187.727%20199.460%20C%20187.837%20199.570,188.050%20199.273,188.200%20198.800%20C%20188.350%20198.327,188.383%20197.850,188.273%20197.740%20C%20188.163%20197.630,187.950%20197.927,187.800%20198.400%20M56.172%20199.371%20C%2056.037%20199.905,56.100%20200.649,56.309%20201.024%20C%2056.600%20201.543,56.691%20201.311,56.691%20200.053%20C%2056.691%20198.176,56.526%20197.959,56.172%20199.371%20M326.114%20200.000%20C%20326.114%20201.540,326.172%20201.670,326.518%20200.900%20C%20326.790%20200.294,326.790%20199.706,326.518%20199.100%20C%20326.172%20198.330,326.114%20198.460,326.114%20200.000%20M217.293%20200.000%20C%20217.295%20201.765,217.891%20204.388,217.930%20202.800%20C%20217.943%20202.250,217.805%20201.080,217.623%20200.200%20L%20217.292%20198.600%20217.293%20200.000%20M113.047%20202.223%20C%20110.906%20205.104,110.206%20206.275,111.309%20205.129%20C%20112.056%20204.351,115.670%20199.200,115.467%20199.200%20C%20115.372%20199.200,114.283%20200.561,113.047%20202.223%20M258.244%20200.200%20C%20258.573%20201.671,258.802%20201.990,258.794%20200.967%20C%20258.791%20200.545,258.605%20199.930,258.382%20199.600%20C%20258.085%20199.162,258.048%20199.324,258.244%20200.200%20M202.109%20202.000%20C%20202.109%20202.990,202.187%20203.395,202.282%20202.900%20C%20202.378%20202.405,202.378%20201.595,202.282%20201.100%20C%20202.187%20200.605,202.109%20201.010,202.109%20202.000%20M56.827%20202.800%20C%2056.826%20203.130,57.090%20203.749,57.413%20204.176%20C%2058.160%20205.164,58.152%20204.515,57.400%20203.200%20C%2057.068%20202.620,56.828%20202.452,56.827%20202.800%20M164.887%20203.000%20C%20164.891%20203.440,165.032%20204.340,165.200%20205.000%20C%20165.474%20206.078,165.506%20206.098,165.513%20205.200%20C%20165.517%20204.650,165.376%20203.750,165.200%20203.200%20C%20164.949%20202.416,164.881%20202.373,164.887%20203.000%20M325.285%20203.373%20C%20324.615%20204.844,324.678%20205.152,325.430%20204.079%20C%20325.776%20203.584,325.995%20202.984,325.915%20202.744%20C%20325.835%20202.505,325.552%20202.788,325.285%20203.373%20M259.040%20203.866%20C%20259.408%20205.399,259.600%20205.544,259.600%20204.290%20C%20259.600%20203.717,259.413%20203.132,259.184%20202.990%20C%20258.911%20202.821,258.862%20203.123,259.040%20203.866%20M218.093%20205.800%20C%20218.094%20206.460,218.232%20207.540,218.400%20208.200%20C%20218.823%20209.863,218.842%20208.226,218.423%20206.200%20C%20218.145%20204.855,218.092%20204.791,218.093%20205.800%20M109.000%20206.453%20C%20108.340%20206.861,108.070%20207.191,108.400%20207.185%20C%20109.054%20207.174,110.648%20206.101,110.371%20205.859%20C%20110.277%20205.777,109.660%20206.044,109.000%20206.453%20M59.824%20206.587%20C%2060.251%20206.910,60.780%20207.175,61.000%20207.175%20C%2061.220%20207.175,61.051%20206.910,60.624%20206.587%20C%2060.196%20206.264,59.667%20206.000,59.447%20206.000%20C%2059.227%20206.000,59.396%20206.264,59.824%20206.587%20M202.914%20207.800%20C%20202.917%20208.900,202.995%20209.303,203.087%20208.695%20C%20203.179%20208.086,203.177%20207.186,203.082%20206.695%20C%20202.987%20206.203,202.911%20206.700,202.914%20207.800%20M322.176%20206.587%20C%20321.749%20206.910,321.580%20207.175,321.800%20207.175%20C%20322.020%20207.175,322.549%20206.910,322.976%20206.587%20C%20323.404%20206.264,323.573%20206.000,323.353%20206.000%20C%20323.133%20206.000,322.604%20206.264,322.176%20206.587%20M62.538%20207.694%20C%2062.792%20207.856,72.720%20207.988,84.600%20207.988%20C%2096.480%20207.988,106.408%20207.856,106.662%20207.694%20C%20106.916%20207.532,96.988%20207.400,84.600%20207.400%20C%2072.212%20207.400,62.284%20207.532,62.538%20207.694%20M165.872%20209.000%20C%20165.999%20210.100,166.169%20211.075,166.251%20211.167%20C%20166.532%20211.482,166.320%20208.999,165.980%20208.000%20C%20165.751%20207.326,165.716%20207.651,165.872%20209.000%20M297.800%20207.600%20L%20275.800%20207.810%20297.800%20207.899%20C%20311.483%20207.954,320.027%20207.841,320.400%20207.600%20C%20320.933%20207.255,320.933%20207.222,320.400%20207.301%20C%20320.070%20207.350,309.900%20207.484,297.800%20207.600%20M184.629%20209.829%20C%20184.481%20210.415,184.438%20210.972,184.532%20211.066%20C%20184.627%20211.160,184.824%20210.758,184.971%20210.171%20C%20185.119%20209.585,185.162%20209.028,185.068%20208.934%20C%20184.973%20208.840,184.776%20209.242,184.629%20209.829%20M244.444%20211.244%20C%20244.198%20211.951,244.066%20212.600,244.152%20212.685%20C%20244.238%20212.771,244.509%20212.262,244.756%20211.556%20C%20245.002%20210.849,245.134%20210.200,245.048%20210.115%20C%20244.962%20210.029,244.691%20210.538,244.444%20211.244%20M218.895%20212.000%20C%20218.895%20212.550,219.032%20213.540,219.200%20214.200%20C%20219.472%20215.270,219.505%20215.292,219.505%20214.400%20C%20219.505%20213.850,219.368%20212.860,219.200%20212.200%20C%20218.928%20211.130,218.895%20211.108,218.895%20212.000%20M183.829%20212.629%20C%20183.681%20213.215,183.638%20213.772,183.732%20213.866%20C%20183.827%20213.960,184.024%20213.558,184.171%20212.971%20C%20184.319%20212.385,184.362%20211.828,184.268%20211.734%20C%20184.173%20211.640,183.976%20212.042,183.829%20212.629%20M245.234%20212.200%20C%20245.222%20212.640,245.387%20213.270,245.600%20213.600%20C%20246.114%20214.395,246.114%20213.396,245.600%20212.200%20L%20245.256%20211.400%20245.234%20212.200%20M166.681%20214.000%20C%20166.806%20215.210,166.974%20216.275,167.054%20216.367%20C%20167.335%20216.687,167.117%20213.791,166.787%20212.800%20C%20166.571%20212.154,166.534%20212.580,166.681%20214.000%20M203.640%20213.633%20C%20203.662%20214.605,203.825%20215.850,204.002%20216.400%20C%20204.195%20217.000,204.237%20216.360,204.106%20214.800%20C%20203.851%20211.762,203.582%20211.089,203.640%20213.633%20M243.646%20213.467%20C%20243.621%20213.724,243.484%20214.264,243.341%20214.667%20C%20243.140%20215.236,243.194%20215.297,243.579%20214.942%20C%20243.852%20214.691,243.989%20214.151,243.884%20213.742%20C%20243.779%20213.334,243.672%20213.210,243.646%20213.467%20M182.615%20216.998%20C%20182.227%20218.433,181.570%20220.039,181.155%20220.567%20C%20180.740%20221.095,180.400%20221.668,180.400%20221.841%20C%20180.400%20222.014,180.828%20221.576,181.350%20220.868%20C%20182.250%20219.647,183.855%20214.921,183.492%20214.558%20C%20183.398%20214.465,183.004%20215.563,182.615%20216.998%20M219.675%20218.200%20C%20219.686%20218.640,219.832%20219.540,220.000%20220.200%20L%20220.305%20221.400%20220.325%20220.200%20C%20220.335%20219.540,220.189%20218.640,220.000%20218.200%20L%20219.656%20217.400%20219.675%20218.200%20M204.440%20219.633%20C%20204.462%20220.605,204.625%20221.850,204.802%20222.400%20C%20204.995%20223.000,205.037%20222.360,204.906%20220.800%20C%20204.651%20217.762,204.382%20217.089,204.440%20219.633%20M167.616%20218.822%20C%20167.607%20219.165,168.050%20220.055,168.600%20220.800%20C%20169.150%20221.545,169.600%20221.951,169.600%20221.701%20C%20169.600%20221.452,169.402%20221.125,169.160%20220.976%20C%20168.919%20220.826,168.476%20220.141,168.176%20219.452%20C%20167.876%20218.763,167.624%20218.480,167.616%20218.822%20M246.856%20218.800%20C%20246.856%20219.130,247.011%20219.760,247.200%20220.200%20C%20247.417%20220.704,247.544%20220.778,247.544%20220.400%20C%20247.544%20220.070,247.389%20219.440,247.200%20219.000%20C%20246.983%20218.496,246.856%20218.422,246.856%20218.800%20M150.831%20222.100%20C%20150.639%20222.595,150.121%20223.900,149.680%20225.000%20C%20147.562%20230.286,147.170%20231.370,147.512%20231.000%20C%20147.715%20230.780,148.376%20229.340,148.982%20227.800%20C%20149.588%20226.260,150.422%20224.145,150.836%20223.100%20C%20151.250%20222.055,151.496%20221.200,151.384%20221.200%20C%20151.272%20221.200,151.023%20221.605,150.831%20222.100%20M178.800%20222.800%20C%20178.250%20223.230,177.997%20223.586,178.238%20223.591%20C%20178.479%20223.596,179.002%20223.240,179.400%20222.800%20C%20180.312%20221.792,180.088%20221.792,178.800%20222.800%20M247.656%20222.400%20C%20247.656%20222.730,247.811%20223.360,248.000%20223.800%20C%20248.217%20224.304,248.344%20224.378,248.344%20224.000%20C%20248.344%20223.670,248.189%20223.040,248.000%20222.600%20C%20247.783%20222.096,247.656%20222.022,247.656%20222.400%20M220.487%20224.000%20C%20220.491%20224.550,220.632%20225.540,220.800%20226.200%20L%20221.105%20227.400%20221.113%20226.200%20C%20221.117%20225.540,220.976%20224.550,220.800%20224.000%20L%20220.480%20223.000%20220.487%20224.000%20M173.462%20224.100%20C%20173.708%20224.499,176.065%20224.473,176.709%20224.064%20C%20177.005%20223.877,176.393%20223.753,175.248%20223.771%20C%20174.164%20223.787,173.360%20223.935,173.462%20224.100%20M205.240%20225.633%20C%20205.262%20226.605,205.425%20227.850,205.602%20228.400%20C%20205.795%20229.000,205.837%20228.360,205.706%20226.800%20C%20205.451%20223.762,205.182%20223.089,205.240%20225.633%20M266.400%20226.400%20C%20265.734%20227.720,265.278%20228.800,265.388%20228.800%20C%20265.498%20228.800,266.134%20227.720,266.800%20226.400%20C%20267.466%20225.080,267.922%20224.000,267.812%20224.000%20C%20267.702%20224.000,267.066%20225.080,266.400%20226.400%20M248.468%20225.600%20C%20248.488%20226.639,249.118%20228.346,249.132%20227.400%20C%20249.138%20226.960,248.989%20226.240,248.800%20225.800%20C%20248.589%20225.310,248.461%20225.232,248.468%20225.600%20M222.667%20228.667%20C%20222.520%20228.813,222.411%20229.308,222.425%20229.767%20C%20222.449%20230.533,222.482%20230.523,222.834%20229.642%20C%20223.226%20228.663,223.144%20228.189,222.667%20228.667%20M249.232%20229.113%20C%20249.194%20229.726,250.274%20232.400,250.559%20232.400%20C%20250.669%20232.400,250.522%20231.815,250.232%20231.100%20C%20249.941%20230.385,249.605%20229.530,249.484%20229.200%20C%20249.341%20228.811,249.252%20228.780,249.232%20229.113%20M221.209%20229.800%20C%20221.213%20230.734,221.853%20231.880,222.185%20231.548%20C%20222.311%20231.422,222.142%20230.797,221.810%20230.160%20C%20221.326%20229.233,221.206%20229.161,221.209%20229.800%20M264.243%20230.566%20C%20263.879%20231.334,263.099%20232.555,262.510%20233.281%20C%20261.461%20234.572,261.460%20234.581,262.445%20233.700%20C%20263.457%20232.795,265.357%20229.623,265.062%20229.329%20C%20264.976%20229.242,264.607%20229.799,264.243%20230.566%20M206.028%20231.833%20C%20206.044%20232.695,206.217%20233.760,206.414%20234.200%20C%20206.648%20234.722,206.688%20234.237,206.532%20232.800%20C%20206.243%20230.158,205.989%20229.670,206.028%20231.833%20M145.665%20234.617%20C%20144.995%20236.088,145.123%20236.402,145.847%20235.065%20C%20146.186%20234.440,146.388%20233.854,146.296%20233.763%20C%20146.205%20233.671,145.921%20234.056,145.665%20234.617%20M132.009%20234.537%20C%20132.004%20234.722,132.360%20235.331,132.800%20235.891%20C%20133.240%20236.450,133.596%20236.749,133.591%20236.554%20C%20133.579%20236.087,132.020%20234.100,132.009%20234.537%20M255.115%20235.672%20C%20255.492%20235.821,256.340%20235.944,257.000%20235.944%20C%20257.660%20235.944,258.508%20235.821,258.885%20235.672%20C%20259.262%20235.522,258.414%20235.400,257.000%20235.400%20C%20255.586%20235.400,254.738%20235.522,255.115%20235.672%20M236.200%20236.800%20C%20236.050%20237.273,236.017%20237.750,236.127%20237.860%20C%20236.237%20237.970,236.450%20237.673,236.600%20237.200%20C%20236.750%20236.727,236.783%20236.250,236.673%20236.140%20C%20236.563%20236.030,236.350%20236.327,236.200%20236.800%20M206.828%20237.833%20C%20206.844%20238.695,207.017%20239.760,207.214%20240.200%20C%20207.448%20240.722,207.488%20240.237,207.332%20238.800%20C%20207.043%20236.158,206.789%20235.670,206.828%20237.833%20M134.689%20237.630%20C%20135.178%20238.139,135.678%20238.455,135.801%20238.332%20C%20135.924%20238.209,135.524%20237.792,134.912%20237.406%20L%20133.800%20236.704%20134.689%20237.630%20M137.304%20238.873%20C%20137.929%20239.270,140.051%20239.283,140.660%20238.894%20C%20140.914%20238.732,140.151%20238.591,138.965%20238.579%20C%20137.770%20238.567,137.029%20238.698,137.304%20238.873%20M207.606%20243.833%20C%20207.609%20244.695,207.788%20245.670,208.003%20246.000%20C%20208.270%20246.410,208.314%20245.965,208.141%20244.600%20C%20207.825%20242.105,207.598%20241.781,207.606%20243.833%20M233.049%20246.615%20C%20232.912%20246.973,232.815%20247.566,232.834%20247.933%20C%20232.853%20248.300,233.027%20248.069,233.221%20247.420%20C%20233.598%20246.158,233.465%20245.533,233.049%20246.615%20M208.428%20249.633%20C%20208.444%20250.385,208.620%20251.360,208.820%20251.800%20C%20209.065%20252.339,209.105%20251.946,208.941%20250.600%20C%20208.651%20248.219,208.389%20247.724,208.428%20249.633%20M230.844%20253.844%20C%20230.380%20255.324,230.070%20256.604,230.156%20256.689%20C%20230.241%20256.775,230.691%20255.635,231.156%20254.156%20C%20231.620%20252.676,231.930%20251.396,231.844%20251.311%20C%20231.759%20251.225,231.309%20252.365,230.844%20253.844%20M209.228%20255.633%20C%20209.244%20256.385,209.420%20257.360,209.620%20257.800%20C%20209.865%20258.339,209.905%20257.946,209.741%20256.600%20C%20209.451%20254.219,209.189%20253.724,209.228%20255.633%20M210.006%20261.633%20C%20210.009%20262.385,210.192%20263.270,210.412%20263.600%20C%20210.691%20264.019,210.733%20263.658,210.550%20262.400%20C%20210.225%20260.159,209.998%20259.840,210.006%20261.633%20M210.806%20267.433%20C%20210.809%20268.075,210.996%20268.870,211.221%20269.200%20C%20211.514%20269.630,211.554%20269.346,211.362%20268.200%20C%20211.030%20266.216,210.798%20265.896,210.806%20267.433%20M226.446%20267.467%20C%20226.421%20267.724,226.284%20268.264,226.141%20268.667%20C%20225.940%20269.236,225.994%20269.297,226.379%20268.942%20C%20226.652%20268.691,226.789%20268.151,226.684%20267.742%20C%20226.579%20267.334,226.472%20267.210,226.446%20267.467%20M225.285%20270.573%20C%20224.615%20272.044,224.678%20272.352,225.430%20271.279%20C%20225.776%20270.784,225.995%20270.184,225.915%20269.944%20C%20225.835%20269.705,225.552%20269.988,225.285%20270.573%20M222.176%20273.787%20C%20221.749%20274.110,221.580%20274.375,221.800%20274.375%20C%20222.020%20274.375,222.549%20274.110,222.976%20273.787%20C%20223.404%20273.464,223.573%20273.200,223.353%20273.200%20C%20223.133%20273.200,222.604%20273.464,222.176%20273.787%20M217.301%20274.871%20C%20217.575%20275.045,218.250%20275.188,218.800%20275.188%20C%20219.350%20275.188,220.025%20275.045,220.299%20274.871%20C%20220.583%20274.691,219.936%20274.554,218.800%20274.554%20C%20217.664%20274.554,217.017%20274.691,217.301%20274.871%20'%20stroke='none'%20fill='%2365758d'%20fill-rule='evenodd'%3e%3c/path%3e%3cpath%20id='path3'%20d='M72.728%20192.700%20C%2078.078%20192.763,86.718%20192.763,91.928%20192.700%20C%2097.137%20192.636,92.760%20192.585,82.200%20192.585%20C%2071.640%20192.585,67.377%20192.637,72.728%20192.700%20M282.900%20192.700%20C%20289.665%20192.761,300.735%20192.761,307.500%20192.700%20C%20314.265%20192.638,308.730%20192.588,295.200%20192.588%20C%20281.670%20192.588,276.135%20192.638,282.900%20192.700%20'%20stroke='none'%20fill='%23838ca4'%20fill-rule='evenodd'%3e%3c/path%3e%3cpath%20id='path4'%20d='M198.905%20121.087%20C%20199.514%20121.179,200.414%20121.177,200.905%20121.082%20C%20201.397%20120.987,200.900%20120.911,199.800%20120.914%20C%20198.700%20120.917,198.297%20120.995,198.905%20121.087%20M207.640%20131.633%20C%20207.662%20132.385,207.830%20133.450,208.013%20134.000%20C%20208.229%20134.646,208.266%20134.220,208.119%20132.800%20C%20207.859%20130.283,207.581%20129.607,207.640%20131.633%20M208.440%20137.633%20C%20208.462%20138.385,208.630%20139.450,208.813%20140.000%20C%20209.029%20140.646,209.066%20140.220,208.919%20138.800%20C%20208.659%20136.283,208.381%20135.607,208.440%20137.633%20M189.646%20137.067%20C%20189.621%20137.324,189.484%20137.864,189.341%20138.267%20C%20189.140%20138.836,189.194%20138.897,189.579%20138.542%20C%20189.852%20138.291,189.989%20137.751,189.884%20137.342%20C%20189.779%20136.934,189.672%20136.810,189.646%20137.067%20M209.228%20143.633%20C%20209.244%20144.385,209.412%20145.360,209.603%20145.800%20C%20209.826%20146.315,209.867%20145.887,209.718%20144.600%20C%20209.444%20142.222,209.189%20141.719,209.228%20143.633%20M187.800%20143.600%20C%20187.650%20144.073,187.617%20144.550,187.727%20144.660%20C%20187.837%20144.770,188.050%20144.473,188.200%20144.000%20C%20188.350%20143.527,188.383%20143.050,188.273%20142.940%20C%20188.163%20142.830,187.950%20143.127,187.800%20143.600%20M187.000%20146.400%20C%20186.850%20146.873,186.817%20147.350,186.927%20147.460%20C%20187.037%20147.570,187.250%20147.273,187.400%20146.800%20C%20187.550%20146.327,187.583%20145.850,187.473%20145.740%20C%20187.363%20145.630,187.150%20145.927,187.000%20146.400%20M186.200%20149.200%20C%20186.050%20149.673,186.017%20150.150,186.127%20150.260%20C%20186.237%20150.370,186.450%20150.073,186.600%20149.600%20C%20186.750%20149.127,186.783%20148.650,186.673%20148.540%20C%20186.563%20148.430,186.350%20148.727,186.200%20149.200%20M210.040%20149.433%20C%20210.062%20150.075,210.233%20151.050,210.420%20151.600%20C%20210.649%20152.274,210.684%20151.949,210.528%20150.600%20C%20210.269%20148.350,209.979%20147.659,210.040%20149.433%20M185.400%20152.000%20C%20185.250%20152.473,185.217%20152.950,185.327%20153.060%20C%20185.437%20153.170,185.650%20152.873,185.800%20152.400%20C%20185.950%20151.927,185.983%20151.450,185.873%20151.340%20C%20185.763%20151.230,185.550%20151.527,185.400%20152.000%20M210.840%20155.433%20C%20210.862%20156.075,211.033%20157.050,211.220%20157.600%20C%20211.449%20158.274,211.484%20157.949,211.328%20156.600%20C%20211.069%20154.350,210.779%20153.659,210.840%20155.433%20M165.300%20157.087%20C%20165.905%20157.178,166.895%20157.178,167.500%20157.087%20C%20168.105%20156.995,167.610%20156.920,166.400%20156.920%20C%20165.190%20156.920,164.695%20156.995,165.300%20157.087%20M183.029%20160.629%20C%20182.881%20161.215,182.838%20161.772,182.932%20161.866%20C%20183.027%20161.960,183.224%20161.558,183.371%20160.971%20C%20183.519%20160.385,183.562%20159.828,183.468%20159.734%20C%20183.373%20159.640,183.176%20160.042,183.029%20160.629%20M211.640%20161.433%20C%20211.662%20162.075,211.833%20163.050,212.020%20163.600%20C%20212.249%20164.274,212.284%20163.949,212.128%20162.600%20C%20211.869%20160.350,211.579%20159.659,211.640%20161.433%20M173.268%20162.200%20C%20173.262%20162.640,173.411%20163.360,173.600%20163.800%20C%20174.038%20164.819,174.038%20163.768,173.600%20162.400%20C%20173.343%20161.596,173.277%20161.557,173.268%20162.200%20M182.229%20163.429%20C%20182.081%20164.015,182.038%20164.572,182.132%20164.666%20C%20182.227%20164.760,182.424%20164.358,182.571%20163.771%20C%20182.719%20163.185,182.762%20162.628,182.668%20162.534%20C%20182.573%20162.440,182.376%20162.842,182.229%20163.429%20M174.028%20166.633%20C%20174.044%20167.275,174.216%20168.160,174.410%20168.600%20C%20174.647%20169.134,174.686%20168.802,174.527%20167.600%20C%20174.246%20165.480,173.988%20164.980,174.028%20166.633%20M197.695%20166.800%20C%20197.695%20167.350,197.832%20168.340,198.000%20169.000%20C%20198.272%20170.070,198.305%20170.092,198.305%20169.200%20C%20198.305%20168.650,198.168%20167.660,198.000%20167.000%20C%20197.728%20165.930,197.695%20165.908,197.695%20166.800%20M212.440%20167.433%20C%20212.462%20168.075,212.633%20169.050,212.820%20169.600%20C%20213.049%20170.274,213.084%20169.949,212.928%20168.600%20C%20212.669%20166.350,212.379%20165.659,212.440%20167.433%20M174.828%20171.433%20C%20174.844%20172.075,175.016%20172.960,175.210%20173.400%20C%20175.447%20173.934,175.486%20173.602,175.327%20172.400%20C%20175.046%20170.280,174.788%20169.780,174.828%20171.433%20M198.447%20172.433%20C%20198.473%20173.185,198.641%20174.340,198.820%20175.000%20C%20199.035%20175.789,199.070%20175.378,198.923%20173.800%20C%20198.677%20171.155,198.373%20170.281,198.447%20172.433%20M119.300%20171.887%20C%20119.905%20171.978,120.895%20171.978,121.500%20171.887%20C%20122.105%20171.795,121.610%20171.720,120.400%20171.720%20C%20119.190%20171.720,118.695%20171.795,119.300%20171.887%20M213.295%20173.200%20C%20213.295%20173.750,213.432%20174.740,213.600%20175.400%20C%20213.872%20176.470,213.905%20176.492,213.905%20175.600%20C%20213.905%20175.050,213.768%20174.060,213.600%20173.400%20C%20213.328%20172.330,213.295%20172.308,213.295%20173.200%20M245.107%20174.290%20C%20245.826%20174.379,246.906%20174.377,247.507%20174.286%20C%20248.108%20174.195,247.520%20174.122,246.200%20174.124%20C%20244.880%20174.126,244.388%20174.201,245.107%20174.290%20M112.400%20177.200%20C%20111.504%20178.520,110.860%20179.600,110.970%20179.600%20C%20111.080%20179.600,111.904%20178.520,112.800%20177.200%20C%20113.696%20175.880,114.340%20174.800,114.230%20174.800%20C%20114.120%20174.800,113.296%20175.880,112.400%20177.200%20M178.846%20175.267%20C%20178.821%20175.634,178.696%20176.264,178.570%20176.667%20C%20178.352%20177.362,178.363%20177.363,178.797%20176.687%20C%20179.048%20176.296,179.173%20175.666,179.073%20175.287%20C%20178.911%20174.668,178.888%20174.666,178.846%20175.267%20M251.234%20176.247%20C%20251.765%20176.933,252.280%20177.423,252.379%20177.335%20C%20252.477%20177.247,252.043%20176.686,251.413%20176.088%20L%20250.269%20175.000%20251.234%20176.247%20M175.687%20176.400%20C%20175.683%20176.950,175.824%20177.850,176.000%20178.400%20C%20176.431%20179.744,176.431%20178.292,176.000%20176.600%20C%20175.726%20175.522,175.694%20175.502,175.687%20176.400%20M178.046%20178.067%20C%20178.021%20178.434,177.896%20179.064,177.770%20179.467%20C%20177.552%20180.162,177.563%20180.163,177.997%20179.487%20C%20178.248%20179.096,178.373%20178.466,178.273%20178.087%20C%20178.111%20177.468,178.088%20177.466,178.046%20178.067%20M214.095%20179.200%20C%20214.095%20179.750,214.232%20180.740,214.400%20181.400%20C%20214.672%20182.470,214.705%20182.492,214.705%20181.600%20C%20214.705%20181.050,214.568%20180.060,214.400%20179.400%20C%20214.128%20178.330,214.095%20178.308,214.095%20179.200%20M253.462%20181.400%20C%20253.596%20182.280,253.772%20183.075,253.853%20183.167%20C%20254.156%20183.510,253.929%20181.368,253.581%20180.600%20C%20253.329%20180.042,253.293%20180.285,253.462%20181.400%20M176.406%20180.876%20C%20176.398%20181.815,177.062%20182.136,177.368%20181.340%20C%20177.506%20180.980,177.525%20180.591,177.409%20180.476%20C%20177.294%20180.361,177.197%20180.522,177.194%20180.833%20C%20177.189%20181.300,177.119%20181.294,176.800%20180.800%20C%20176.466%20180.283,176.411%20180.293,176.406%20180.876%20M107.181%20184.628%20C%20106.489%20185.634,105.986%20186.519,106.062%20186.596%20C%20106.139%20186.673,106.788%20185.850,107.504%20184.768%20C%20109.146%20182.287,108.873%20182.169,107.181%20184.628%20M200.095%20184.400%20C%20200.095%20184.950,200.232%20185.940,200.400%20186.600%20C%20200.672%20187.670,200.705%20187.692,200.705%20186.800%20C%20200.705%20186.250,200.568%20185.260,200.400%20184.600%20C%20200.128%20183.530,200.095%20183.508,200.095%20184.400%20M214.895%20185.200%20C%20214.895%20185.750,215.032%20186.740,215.200%20187.400%20C%20215.472%20188.470,215.505%20188.492,215.505%20187.600%20C%20215.505%20187.050,215.368%20186.060,215.200%20185.400%20C%20214.928%20184.330,214.895%20184.308,214.895%20185.200%20M190.649%20187.015%20C%20190.512%20187.373,190.415%20187.966,190.434%20188.333%20C%20190.453%20188.700,190.627%20188.469,190.821%20187.820%20C%20191.198%20186.558,191.065%20185.933,190.649%20187.015%20M189.849%20189.815%20C%20189.712%20190.173,189.615%20190.766,189.634%20191.133%20C%20189.653%20191.500,189.827%20191.269,190.021%20190.620%20C%20190.398%20189.358,190.265%20188.733,189.849%20189.815%20M200.895%20190.400%20C%20200.895%20190.950,201.032%20191.940,201.200%20192.600%20C%20201.472%20193.670,201.505%20193.692,201.505%20192.800%20C%20201.505%20192.250,201.368%20191.260,201.200%20190.600%20C%20200.928%20189.530,200.895%20189.508,200.895%20190.400%20M215.695%20190.800%20C%20215.695%20191.350,215.832%20192.340,216.000%20193.000%20C%20216.272%20194.070,216.305%20194.092,216.305%20193.200%20C%20216.305%20192.650,216.168%20191.660,216.000%20191.000%20C%20215.728%20189.930,215.695%20189.908,215.695%20190.800%20M256.006%20192.433%20C%20256.009%20192.965,256.189%20193.670,256.406%20194.000%20C%20256.682%20194.422,256.723%20194.185,256.542%20193.200%20C%20256.225%20191.475,255.998%20191.149,256.006%20192.433%20M162.597%20192.405%20C%20162.444%20192.652,162.428%20192.961,162.560%20193.093%20C%20162.692%20193.225,162.806%20193.078,162.813%20192.767%20C%20162.822%20192.373,163.015%20192.444,163.449%20193.000%20C%20164.045%20193.766,164.066%20193.767,163.936%20193.033%20C%20163.776%20192.132,162.993%20191.765,162.597%20192.405%20M189.049%20192.615%20C%20188.912%20192.973,188.815%20193.566,188.834%20193.933%20C%20188.853%20194.300,189.027%20194.069,189.221%20193.420%20C%20189.598%20192.158,189.465%20191.533,189.049%20192.615%20M267.400%20194.000%20C%20266.740%20194.437,266.380%20194.792,266.600%20194.788%20C%20267.001%20194.782,269.176%20193.223,268.800%20193.212%20C%20268.690%20193.208,268.060%20193.563,267.400%20194.000%20M164.093%20195.600%20C%20164.093%20196.370,164.175%20196.685,164.276%20196.300%20C%20164.376%20195.915,164.376%20195.285,164.276%20194.900%20C%20164.175%20194.515,164.093%20194.830,164.093%20195.600%20M116.619%20196.700%20L%20115.542%20198.200%20116.737%20196.856%20C%20117.395%20196.116,118.128%20195.632,118.366%20195.779%20C%20118.605%20195.927,118.800%20195.857,118.800%20195.624%20C%20118.800%20194.705,117.639%20195.278,116.619%20196.700%20M201.695%20196.400%20C%20201.695%20196.950,201.832%20197.940,202.000%20198.600%20C%20202.272%20199.670,202.305%20199.692,202.305%20198.800%20C%20202.305%20198.250,202.168%20197.260,202.000%20196.600%20C%20201.728%20195.530,201.695%20195.508,201.695%20196.400%20M216.470%20196.600%20C%20216.457%20197.040,216.595%20198.120,216.777%20199.000%20C%20217.055%20200.345,217.108%20200.409,217.107%20199.400%20C%20217.105%20197.999,216.508%20195.370,216.470%20196.600%20M56.920%20200.000%20C%2056.920%20201.210,56.995%20201.705,57.087%20201.100%20C%2057.178%20200.495,57.178%20199.505,57.087%20198.900%20C%2056.995%20198.295,56.920%20198.790,56.920%20200.000%20M325.720%20200.000%20C%20325.720%20201.210,325.795%20201.705,325.887%20201.100%20C%20325.978%20200.495,325.978%20199.505,325.887%20198.900%20C%20325.795%20198.295,325.720%20198.790,325.720%20200.000%20M257.606%20199.433%20C%20257.609%20199.855,257.795%20200.470,258.018%20200.800%20C%20258.315%20201.238,258.352%20201.076,258.156%20200.200%20C%20257.827%20198.729,257.598%20198.410,257.606%20199.433%20M135.451%20199.974%20C%20135.827%20201.439,136.771%20203.486,136.755%20202.800%20C%20136.747%20202.470,136.394%20201.480,135.971%20200.600%20C%20135.548%20199.720,135.314%20199.438,135.451%20199.974%20M262.000%20202.400%20C%20261.551%20203.280,261.274%20204.000,261.384%20204.000%20C%20261.494%20204.000,261.951%20203.280,262.400%20202.400%20C%20262.849%20201.520,263.126%20200.800,263.016%20200.800%20C%20262.906%20200.800,262.449%20201.520,262.000%20202.400%20M202.487%20202.400%20C%20202.491%20202.950,202.632%20203.940,202.800%20204.600%20L%20203.105%20205.800%20203.113%20204.600%20C%20203.117%20203.940,202.976%20202.950,202.800%20202.400%20L%20202.480%20201.400%20202.487%20202.400%20M112.344%20202.700%20C%20111.193%20204.089,110.706%20204.800,110.904%20204.800%20C%20111.014%20204.800,111.586%20204.170,112.173%20203.400%20C%20113.263%20201.971,113.395%20201.432,112.344%20202.700%20M217.270%20202.600%20C%20217.257%20203.040,217.395%20204.120,217.577%20205.000%20C%20217.855%20206.345,217.908%20206.409,217.907%20205.400%20C%20217.905%20203.999,217.308%20201.370,217.270%20202.600%20M137.029%20204.400%20C%20137.176%20204.950,137.464%20205.670,137.667%20206.000%20C%20137.925%20206.417,137.957%20206.295,137.771%20205.600%20C%20137.624%20205.050,137.336%20204.330,137.133%20204.000%20C%20136.875%20203.583,136.843%20203.705,137.029%20204.400%20M260.396%20205.408%20C%20260.004%20206.140,259.769%20206.277,259.534%20205.908%20C%20259.302%20205.542,259.211%20205.533,259.206%20205.876%20C%20259.194%20206.829,259.929%20206.769,260.588%20205.762%20C%20260.960%20205.195,261.190%20204.656,261.099%20204.566%20C%20261.009%20204.475,260.692%20204.854,260.396%20205.408%20M165.687%20205.600%20C%20165.683%20206.150,165.824%20207.050,166.000%20207.600%20C%20166.431%20208.944,166.431%20207.492,166.000%20205.800%20C%20165.726%20204.722,165.694%20204.702,165.687%20205.600%20M138.022%20207.051%20C%20137.978%20207.946,139.233%20210.427,139.612%20210.193%20C%20139.825%20210.061,140.000%20209.843,140.000%20209.710%20C%20140.000%20209.576,139.873%20209.593,139.719%20209.748%20C%20139.564%20209.903,139.124%20209.258,138.741%20208.315%20C%20138.358%20207.372,138.035%20206.803,138.022%20207.051%20M229.640%20208.240%20C%20229.410%20209.073,229.294%20209.827,229.382%20209.915%20C%20229.470%20210.003,229.730%20209.393,229.960%20208.560%20C%20230.190%20207.727,230.306%20206.973,230.218%20206.885%20C%20230.130%20206.797,229.870%20207.407,229.640%20208.240%20M74.300%20207.500%20C%2080.075%20207.562,89.525%20207.562,95.300%20207.500%20C%20101.075%20207.437,96.350%20207.386,84.800%20207.386%20C%2073.250%20207.386,68.525%20207.437,74.300%20207.500%20M184.846%20207.667%20C%20184.821%20208.034,184.696%20208.664,184.570%20209.067%20C%20184.352%20209.762,184.363%20209.763,184.797%20209.087%20C%20185.048%20208.696,185.173%20208.066,185.073%20207.687%20C%20184.911%20207.068,184.888%20207.066,184.846%20207.667%20M275.862%20207.500%20C%20275.693%20207.772,291.873%20207.768,311.400%20207.490%20C%20315.580%20207.430,309.336%20207.341,297.524%20207.291%20C%20285.712%20207.241,275.964%20207.335,275.862%20207.500%20M203.472%20209.400%20C%20203.599%20210.500,203.769%20211.475,203.851%20211.567%20C%20204.132%20211.882,203.920%20209.399,203.580%20208.400%20C%20203.351%20207.726,203.316%20208.051,203.472%20209.400%20M166.487%20210.400%20C%20166.483%20210.950,166.624%20211.850,166.800%20212.400%20C%20167.231%20213.744,167.231%20212.292,166.800%20210.600%20C%20166.526%20209.522,166.494%20209.502,166.487%20210.400%20M218.501%20211.400%20C%20218.505%20212.280,218.587%20212.593,218.683%20212.095%20C%20218.779%20211.598,218.775%20210.878,218.675%20210.495%20C%20218.575%20210.113,218.496%20210.520,218.501%20211.400%20M246.028%20213.633%20C%20246.044%20214.165,246.219%20214.960,246.419%20215.400%20C%20246.671%20215.958,246.707%20215.715,246.538%20214.600%20C%20246.255%20212.743,245.987%20212.236,246.028%20213.633%20M204.272%20215.400%20C%20204.399%20216.500,204.569%20217.475,204.651%20217.567%20C%20204.932%20217.882,204.720%20215.399,204.380%20214.400%20C%20204.151%20213.726,204.116%20214.051,204.272%20215.400%20M167.280%20215.400%20C%20167.280%20215.840,167.424%20216.650,167.600%20217.200%20C%20167.854%20217.992,167.920%20218.033,167.920%20217.400%20C%20167.920%20216.960,167.776%20216.150,167.600%20215.600%20C%20167.346%20214.808,167.280%20214.767,167.280%20215.400%20M227.246%20215.667%20C%20227.221%20216.034,227.096%20216.664,226.970%20217.067%20C%20226.752%20217.762,226.763%20217.763,227.197%20217.087%20C%20227.448%20216.696,227.573%20216.066,227.473%20215.687%20C%20227.311%20215.068,227.288%20215.066,227.246%20215.667%20M219.301%20217.400%20C%20219.305%20218.280,219.387%20218.593,219.483%20218.095%20C%20219.579%20217.598,219.575%20216.878,219.475%20216.495%20C%20219.375%20216.113,219.296%20216.520,219.301%20217.400%20M204.887%20220.200%20C%20204.891%20220.640,205.032%20221.540,205.200%20222.200%20C%20205.474%20223.278,205.506%20223.298,205.513%20222.400%20C%20205.517%20221.850,205.376%20220.950,205.200%20220.400%20C%20204.949%20219.616,204.881%20219.573,204.887%20220.200%20M247.668%20220.600%20C%20247.662%20221.040,247.811%20221.760,248.000%20222.200%20C%20248.438%20223.219,248.438%20222.168,248.000%20220.800%20C%20247.743%20219.996,247.677%20219.957,247.668%20220.600%20M169.601%20221.337%20C%20170.151%20221.962,170.960%20222.659,171.400%20222.886%20C%20172.242%20223.320,172.218%20223.293,170.001%20221.397%20L%20168.603%20220.200%20169.601%20221.337%20M179.400%20221.868%20C%20178.520%20222.657,178.160%20223.116,178.600%20222.888%20C%20179.341%20222.504,181.551%20220.379,181.170%20220.417%20C%20181.076%20220.426,180.280%20221.079,179.400%20221.868%20M267.400%20223.600%20C%20266.843%20224.700,266.477%20225.600,266.587%20225.600%20C%20266.697%20225.600,267.243%20224.700,267.800%20223.600%20C%20268.357%20222.500,268.723%20221.600,268.613%20221.600%20C%20268.503%20221.600,267.957%20222.500,267.400%20223.600%20M128.016%20222.254%20C%20128.007%20222.504,128.263%20223.314,128.584%20224.054%20C%20128.906%20224.794,129.176%20225.196,129.184%20224.946%20C%20129.193%20224.696,128.937%20223.886,128.616%20223.146%20C%20128.294%20222.406,128.024%20222.004,128.016%20222.254%20M220.101%20223.400%20C%20220.105%20224.280,220.187%20224.593,220.283%20224.095%20C%20220.379%20223.598,220.375%20222.878,220.275%20222.495%20C%20220.175%20222.113,220.096%20222.520,220.101%20223.400%20M205.882%20227.400%20C%20206.009%20228.500,206.177%20229.475,206.256%20229.567%20C%20206.555%20229.914,206.328%20226.964,205.997%20226.200%20C%20205.774%20225.685,205.733%20226.113,205.882%20227.400%20M249.256%20227.600%20C%20249.256%20227.930,249.411%20228.560,249.600%20229.000%20C%20249.817%20229.504,249.944%20229.578,249.944%20229.200%20C%20249.944%20228.870,249.789%20228.240,249.600%20227.800%20C%20249.383%20227.296,249.256%20227.222,249.256%20227.600%20M220.901%20229.400%20C%20220.905%20230.280,220.987%20230.593,221.083%20230.095%20C%20221.179%20229.598,221.175%20228.878,221.075%20228.495%20C%20220.975%20228.113,220.896%20228.520,220.901%20229.400%20M222.400%20231.133%20C%20222.400%20231.390,222.130%20231.600,221.800%20231.600%20C%20221.470%20231.600,221.200%20231.870,221.200%20232.200%20C%20221.200%20232.530,221.374%20232.800,221.586%20232.800%20C%20222.071%20232.800,222.946%20231.212,222.632%20230.899%20C%20222.505%20230.771,222.400%20230.877,222.400%20231.133%20M206.681%20233.200%20C%20206.806%20234.410,206.974%20235.475,207.054%20235.567%20C%20207.335%20235.887,207.117%20232.991,206.787%20232.000%20C%20206.571%20231.354,206.534%20231.780,206.681%20233.200%20M236.440%20235.040%20C%20236.210%20235.873,236.094%20236.627,236.182%20236.715%20C%20236.270%20236.803,236.530%20236.193,236.760%20235.360%20C%20236.990%20234.527,237.106%20233.773,237.018%20233.685%20C%20236.930%20233.597,236.670%20234.207,236.440%20235.040%20M132.728%20235.000%20C%20133.163%20235.873,134.649%20237.309,135.600%20237.775%20C%20135.930%20237.937,135.751%20237.705,135.201%20237.259%20C%20134.652%20236.813,133.781%20235.942,133.266%20235.324%20C%20132.731%20234.683,132.500%20234.544,132.728%20235.000%20M142.800%20237.236%20C%20142.136%20237.779,142.069%20237.915,142.600%20237.640%20C%20143.905%20236.966,144.628%20236.412,144.200%20236.415%20C%20143.980%20236.417,143.350%20236.786,142.800%20237.236%20M207.481%20239.200%20C%20207.606%20240.410,207.774%20241.475,207.854%20241.567%20C%20208.135%20241.887,207.917%20238.991,207.587%20238.000%20C%20207.371%20237.354,207.334%20237.780,207.481%20239.200%20M208.501%20246.200%20C%20208.505%20247.080,208.587%20247.393,208.683%20246.895%20C%20208.779%20246.398,208.775%20245.678,208.675%20245.295%20C%20208.575%20244.913,208.496%20245.320,208.501%20246.200%20M209.301%20252.200%20C%20209.305%20253.080,209.387%20253.393,209.483%20252.895%20C%20209.579%20252.398,209.575%20251.678,209.475%20251.295%20C%20209.375%20250.913,209.296%20251.320,209.301%20252.200%20M209.888%20257.000%20C%20210.011%20258.320,210.176%20259.475,210.256%20259.567%20C%20210.535%20259.889,210.316%20256.588,209.993%20255.600%20C%20209.789%20254.979,209.749%20255.509,209.888%20257.000%20M210.909%20264.000%20C%20210.909%20264.990,210.987%20265.395,211.082%20264.900%20C%20211.178%20264.405,211.178%20263.595,211.082%20263.100%20C%20210.987%20262.605,210.909%20263.010,210.909%20264.000%20'%20stroke='none'%20fill='%238c94ac'%20fill-rule='evenodd'%3e%3c/path%3e%3c/g%3e%3c/svg%3e", Ze = {
  "&.SpaceCadet": {
    backgroundColor: a[300],
    color: a[500]
  },
  "&.Sanguine": {
    backgroundColor: M[300],
    color: M[600]
  },
  "&.UltraMarine": {
    backgroundColor: g[300],
    color: g[600]
  },
  "&.Orange": {
    backgroundColor: i0[300],
    color: i0[500]
  },
  "&.Salmon": {
    backgroundColor: a0[300],
    color: a0[500]
  },
  "&.Purple": {
    backgroundColor: l0[300],
    color: l0[600]
  },
  "&.Aqua": {
    backgroundColor: v0[300],
    color: v0[600]
  },
  "&.transparent": {
    backgroundColor: "transparent",
    color: a[400]
  }
};
function Ye(e) {
  let o = 0, t;
  for (t = 0; t < e.length; t += 1)
    o = e.charCodeAt(t) + ((o << 5) - o);
  return Math.abs(o) % 7;
}
function qe(e) {
  switch (Ye(e)) {
    case 0:
      return "UltraMarine";
    case 1:
      return "SpaceCadet";
    case 2:
      return "Sanguine";
    case 3:
      return "Aqua";
    case 4:
      return "Orange";
    case 5:
      return "Purple";
    default:
      return "Salmon";
  }
}
function Xe(e) {
  let o = "";
  const t = e.trim();
  if (t.includes(" ")) {
    const r = t.split(" ");
    o = `${r[0][0]}${r[1][0]}`;
  } else if (t.includes(".")) {
    const r = t.split(".");
    o = `${r[0][0]}${r[1][0]}`;
  } else
    o = `${t[0]}${t[1]}`;
  return o.toUpperCase();
}
function Ke(e) {
  return e.anonymized ? "CogNeed" : e.displayName;
}
const Qe = l(v2)({
  ...Ze,
  fontWeight: 700,
  fontSize: 16
}), Je = l(P)({
  padding: 0,
  minWidth: 0,
  "&:hover": {
    backgroundColor: "transparent"
  },
  borderRadius: "50%"
});
function Vo(e) {
  const {
    user: o,
    tooltip: t,
    tooltipText: r,
    onClick: i
  } = e, d = w.useMemo(() => o === void 0 ? /* @__PURE__ */ n(X2, {}) : o === null || o.anonymized ? /* @__PURE__ */ n("img", { src: Ue, alt: "CogNeed", style: { width: 28, height: 28 } }) : Xe(o.displayName), [o]), s = w.useMemo(() => {
    const h = typeof d == "string" ? qe(d) : void 0;
    return /* @__PURE__ */ n(
      Qe,
      {
        className: I("default", {
          ...h && { [h]: !0 },
          system: o === null || !!o?.anonymized,
          transparent: o === void 0
        }),
        children: d
      }
    );
  }, [o, d]), C = w.useMemo(() => {
    if (o) return Ke(o);
    if (r) return r;
  }, [o, r]), u = w.useMemo(() => !t || !C ? s : /* @__PURE__ */ n(
    Ne,
    {
      popoverId: `avatar-${K2()}`,
      text: s,
      component: "div",
      style: { width: "min-content" },
      children: C
    }
  ), [s, t, C]);
  return w.useMemo(() => i ? /* @__PURE__ */ n(Je, { onClick: i, children: u }) : u, [i, u]);
}
const e3 = l(p)({
  display: "flex",
  gap: 8,
  alignItems: "center",
  alignSelf: "center",
  padding: "9px 12px",
  fontSize: "1rem",
  lineHeight: "1.125rem",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: 4,
  color: a[400],
  "& svg": {
    fontSize: 20,
    display: "block"
  },
  "& > .MuiButton-root": {
    minWidth: 0,
    padding: 4
  }
});
function jo(e) {
  const { i18n: o } = j(), t = w.useMemo(() => new Intl.DateTimeFormat(o.language, { dateStyle: "short" }), [o.language]), {
    startDate: r,
    endDate: i,
    setPeriodAgo: d,
    periodAgo: s
  } = e;
  return /* @__PURE__ */ c(e3, { children: [
    /* @__PURE__ */ n(
      P,
      {
        onClick: () => {
          d((C) => C + 1);
        },
        children: /* @__PURE__ */ n(J2, {})
      }
    ),
    /* @__PURE__ */ n(Q2, {}),
    /* @__PURE__ */ n(x, { children: `${t.format(r)} - ${t.format(i)}` }),
    /* @__PURE__ */ n(
      P,
      {
        disabled: s === 0,
        onClick: () => {
          d((C) => C - 1);
        },
        children: /* @__PURE__ */ n(e1, {})
      }
    )
  ] });
}
const o3 = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: 8,
  border: `1px solid ${a[300]}`,
  backgroundColor: "white",
  boxShadow: `0 1px 2px ${N(a[500], 0.05)}`,
  gap: e.spacing(1.25),
  "&.panel": {
    padding: e.spacing(1.5, 1.75)
  },
  "&.page": {
    padding: e.spacing(2.25, 2.5)
  },
  "& .complianceItemCardHeader": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: e.spacing(1)
  },
  "& .complianceItemCardTitle": {
    fontWeight: 700,
    color: a[500],
    lineHeight: 1.3
  },
  "&.panel .complianceItemCardTitle": {
    fontSize: 14
  },
  "&.page .complianceItemCardTitle": {
    fontSize: 17
  },
  "& .complianceItemCardBody": {
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(0.75)
  }
}));
function Uo(e) {
  const {
    title: o,
    status: t,
    density: r = "panel",
    children: i
  } = e;
  return /* @__PURE__ */ c(o3, { className: I(r), children: [
    /* @__PURE__ */ c("div", { className: "complianceItemCardHeader", children: [
      /* @__PURE__ */ n("span", { className: "complianceItemCardTitle", children: o }),
      t
    ] }),
    i && /* @__PURE__ */ n("div", { className: "complianceItemCardBody", children: i })
  ] });
}
const t3 = l(p)(({ theme: e }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: e.spacing(1),
  borderRadius: 8,
  border: `1px solid ${a[300]}`,
  backgroundColor: "white",
  boxShadow: `0 1px 2px ${N(a[500], 0.05)}`,
  overflow: "hidden",
  "&.panel": {
    padding: e.spacing(1.5, 1.75)
  },
  "&.page": {
    padding: e.spacing(2, 2.5)
  },
  // Left accent bar -- e.g. a decision-tree run that's currently in progress.
  "&.accent::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 3,
    backgroundColor: g[500]
  },
  "&.clickable": {
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    transition: "border-color 0.15s",
    "&:hover": {
      borderColor: g[400]
    }
  },
  "& .eventCardHeader": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: e.spacing(1),
    width: "100%"
  },
  "& .eventCardTitle": {
    display: "flex",
    alignItems: "flex-start",
    gap: e.spacing(1),
    fontWeight: 600,
    color: a[500],
    width: "100%"
  },
  "&.panel .eventCardTitle": {
    fontSize: 12
  },
  "&.page .eventCardTitle": {
    fontSize: 17
  },
  // The badge (a StatusTag) doesn't otherwise vary in size -- bump it a
  // little on the page, where there's room and the smaller panel size reads
  // as undersized next to the larger title/meta.
  "&.page .eventCardBadge .MuiTypography-root": {
    fontSize: 13,
    padding: "4px 9px"
  },
  // Indented like a quoted excerpt -- shared by the detection body (quoted
  // commands) and the run body (state-change history lines). Same single
  // stacked column at both densities -- only the gap grows on the page.
  "& .eventCardBody": {
    display: "flex",
    flexDirection: "column",
    paddingLeft: e.spacing(2),
    marginLeft: 3,
    borderLeft: `1px solid ${a[300]}`
  },
  "&.panel .eventCardBody": {
    gap: e.spacing(0.5)
  },
  "&.page .eventCardBody": {
    gap: e.spacing(0.75)
  }
}));
function Zo(e) {
  const {
    badge: o,
    meta: t,
    title: r,
    accent: i,
    density: d = "panel",
    onClick: s,
    children: C
  } = e;
  return /* @__PURE__ */ c(
    t3,
    {
      component: s ? "button" : "div",
      type: s ? "button" : void 0,
      className: I(d, { clickable: !!s, accent: i }),
      onClick: s,
      children: [
        (o || t) && /* @__PURE__ */ c("div", { className: "eventCardHeader", children: [
          o && /* @__PURE__ */ n("div", { className: "eventCardBadge", children: o }),
          t
        ] }),
        /* @__PURE__ */ n("div", { className: "eventCardTitle", children: r }),
        C && /* @__PURE__ */ n("div", { className: "eventCardBody", children: C })
      ]
    }
  );
}
const n3 = l(j0)({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  fontSize: 13,
  // Stated rather than left to MUI's default resolution of color="primary", and given the
  // darker step on hover that the default does not provide. The underline on hover comes
  // from the component's own underline="hover".
  color: g[500],
  "&:hover": {
    color: g[600]
  }
});
function Yo(e) {
  const { href: o, children: t } = e;
  return /* @__PURE__ */ c(n3, { href: o, target: "_blank", rel: "noopener noreferrer", underline: "hover", children: [
    t,
    /* @__PURE__ */ n(o1, { fontSize: "inherit" })
  ] });
}
const r3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 2
});
function qo(e) {
  const { label: o, value: t } = e;
  return /* @__PURE__ */ c(r3, { children: [
    /* @__PURE__ */ n(x, { variant: "subtitle2", color: "text.secondary", children: o }),
    /* @__PURE__ */ n(x, { variant: "body2", component: "div", children: t })
  ] });
}
const i3 = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  "& .label": {
    fontWeight: 700,
    fontSize: 11,
    color: e.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.05em"
  },
  "& .value": {
    fontSize: 13,
    color: e.palette.text.primary,
    whiteSpace: "pre-wrap"
  }
}));
function Xo(e) {
  const { label: o, value: t } = e;
  return /* @__PURE__ */ c(i3, { children: [
    /* @__PURE__ */ n("span", { className: "label", children: o }),
    /* @__PURE__ */ n("span", { className: "value", children: t })
  ] });
}
const a3 = l(x)({
  display: "inline-flex",
  alignSelf: "flex-start",
  width: "max-content",
  padding: "2px 6px",
  borderRadius: 2,
  textTransform: "uppercase",
  fontWeight: 700,
  fontSize: 10,
  lineHeight: "12px",
  // A border, unlike the other variants: spaceCadet[100] is also this app's
  // page background color (see MainThemeProvider's palette.background.default),
  // so a borderless default tag disappears entirely against the page itself —
  // it only worked in CardStatus's original context because that pill sits on
  // a white popup, not the page background.
  "&.default": {
    color: a[400],
    backgroundColor: a[100],
    border: `1px solid ${a[300]}`,
    padding: "1px 5px"
  },
  "&.primary": {
    color: g[600],
    backgroundColor: g[100]
  },
  "&.success": {
    color: A[600],
    backgroundColor: A[100]
  },
  "&.warning": {
    color: E[600],
    backgroundColor: E[100]
  },
  "&.error": {
    color: M[600],
    backgroundColor: M[100]
  }
}), l3 = l(p)({
  flex: "none",
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: g[500],
  animation: "statusTagPulse 1.4s ease-in-out infinite",
  "@keyframes statusTagPulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.35 },
    "100%": { opacity: 1 }
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none"
  }
}), d3 = l(p)({
  display: "inline-flex",
  alignItems: "center",
  gap: 6
});
function r2(e) {
  const { color: o, label: t, pulse: r } = e, i = /* @__PURE__ */ n(a3, { className: o, children: t });
  return r ? /* @__PURE__ */ c(d3, { children: [
    /* @__PURE__ */ n(l3, {}),
    i
  ] }) : i;
}
const c3 = l(p)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  "& .label": {
    fontWeight: 700,
    fontSize: 11,
    color: e.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.05em"
  },
  "& .chips": {
    display: "flex",
    flexWrap: "wrap",
    gap: 4
  }
}));
function Ko(e) {
  const { label: o, values: t, color: r } = e;
  return /* @__PURE__ */ c(c3, { children: [
    /* @__PURE__ */ n("span", { className: "label", children: o }),
    /* @__PURE__ */ n("span", { className: "chips", children: t.map((i) => /* @__PURE__ */ n(r2, { color: r, label: i }, i)) })
  ] });
}
const s3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 4
}), C3 = l(x)({
  fontSize: 13,
  lineHeight: "18px",
  fontWeight: 400,
  color: a[400]
}), p3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 22,
  paddingTop: 4
});
function Qo(e) {
  const {
    open: o,
    title: t,
    subtitle: r,
    children: i,
    dock: d,
    onCancel: s,
    onLaunch: C,
    launchDisabled: u,
    launchHint: m,
    loading: h,
    error: b,
    cancelLabel: k = "Cancel",
    launchLabel: f = "Launch",
    width: y = 640
  } = e;
  return /* @__PURE__ */ n(
    Re,
    {
      open: o,
      width: y,
      title: /* @__PURE__ */ c(s3, { children: [
        t,
        r && /* @__PURE__ */ n(C3, { children: r })
      ] }),
      dock: d,
      confirmHint: m,
      actionsAlign: "end",
      cancelTone: "outlined",
      onCancel: s,
      onConfirm: C,
      confirmDisabled: u,
      loading: h,
      error: b,
      cancelLabel: k,
      confirmLabel: f,
      children: /* @__PURE__ */ n(p3, { children: i })
    }
  );
}
const u3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 10
}), g3 = l(p)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  minHeight: 24
}), h3 = l(x)({
  fontSize: 12,
  lineHeight: "16px",
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  color: a[400]
}), f3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 12
});
function Jo(e) {
  const { label: o, action: t, children: r } = e;
  return /* @__PURE__ */ c(u3, { children: [
    /* @__PURE__ */ c(g3, { children: [
      /* @__PURE__ */ n(h3, { children: o }),
      t
    ] }),
    /* @__PURE__ */ n(f3, { children: r })
  ] });
}
const m3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  padding: "12px 14px",
  borderRadius: 6,
  minHeight: 64,
  boxSizing: "border-box",
  // spaceCadet, not ultraMarine: the neutral preview is a quiet surface reporting a
  // number, and on the blue ramp it reads as an informational callout competing
  // with the primary button below it. Blue is reserved here for the two things
  // that are actually active -- the loading shimmer and the selected preset.
  backgroundColor: a[100],
  border: `1px solid ${a[300]}`,
  "&.over-cap": {
    backgroundColor: F.background,
    border: `1px solid ${F.border}`
  },
  "&.blocked": {
    backgroundColor: R.background,
    border: `1px solid ${R.border}`
  }
}), b3 = l(p)({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
  gap: 10
}), x3 = l(x)({
  minWidth: 0,
  fontSize: 15,
  lineHeight: "22px",
  color: a[500],
  "& > b": {
    fontSize: 18,
    fontWeight: 700,
    marginRight: 6,
    // Tabular figures: the count is re-fetched on every scope and option change,
    // and proportional digits make it jump sideways each time it does.
    fontVariantNumeric: "tabular-nums"
  },
  // Only the number turns red, not the noun beside it: the count is the thing
  // that is over the limit.
  "&.blocked > b": {
    color: R.foreground
  },
  // No count to report and nothing wrong: the line is an instruction, so it sits
  // back at label weight rather than presenting itself as an answer.
  "&.incomplete": {
    color: a[400]
  }
}), y3 = l(p)({
  // The sweep below is absolutely positioned, so this has to be its containing
  // block. Without it the sweep resolves `inset: 0` against the nearest positioned
  // ancestor -- the dialog -- and paints a full-height bar across the form.
  position: "relative",
  display: "inline-block",
  // An inline-block sits its *bottom edge* on the text baseline, so an 18px block
  // standing in for an 18px numeral rides about a descender's worth too high.
  // `middle` centres it on the text instead, which is what the numeral it replaces
  // looks like -- and it holds if either font size changes.
  verticalAlign: "middle",
  marginRight: 6,
  width: 56,
  height: 18,
  borderRadius: 3,
  overflow: "hidden",
  backgroundColor: g[300],
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    width: "30%",
    borderRadius: 3,
    backgroundColor: g[500],
    animation: "runPreviewSweep 1.6s ease-in-out infinite"
  },
  "@keyframes runPreviewSweep": {
    "0%": { transform: "translateX(-100%)" },
    "100%": { transform: "translateX(400%)" }
  },
  "@media (prefers-reduced-motion: reduce)": {
    "&::after": { animation: "none" }
  }
}), k3 = l(x)({
  flex: "none",
  fontSize: 12,
  lineHeight: "16px",
  color: a[400],
  whiteSpace: "nowrap",
  "&.over-cap": {
    color: F.foreground,
    fontWeight: 700
  },
  "&.blocked": {
    color: R.foreground,
    fontWeight: 700
  }
}), v3 = l(x)({
  fontSize: 13,
  lineHeight: "19px",
  color: a[450],
  "&.over-cap": {
    color: F.foreground
  },
  "&.blocked": {
    color: R.foreground
  }
}), w3 = l(p)({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: 16
}), M3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  minWidth: 0
}), _3 = l(x)({
  fontSize: 11,
  lineHeight: "15px",
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  color: a[400]
}), S3 = l(p)({
  display: "flex",
  justifyContent: "space-between",
  gap: 8,
  padding: "4px 0",
  borderTop: `1px solid ${a[200]}`,
  fontSize: 13,
  lineHeight: "18px",
  "& > .label": {
    color: a[500],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  "& > .count": {
    flex: "none",
    color: a[450],
    fontVariantNumeric: "tabular-nums"
  }
}), T3 = {
  counting: "Counting…",
  refreshHint: "Refreshes with scope and options",
  capped: (e) => `Capped at ${e} per run`,
  limit: (e) => `Limit ${e} per run`,
  overCap: (e, o) => `The first ${e} by date will run; ${o} will be left for a later run.`,
  overLimit: "Over the limit — shorten the period or add a filter.",
  invalidPeriod: "Fix the period to get a count.",
  noCountYet: "No count yet — complete the scope first",
  noCount: "No count — fix the period first",
  groupLabel: (e) => `By ${e}`,
  formatNumber: (e) => e.toLocaleString("en-US")
};
function e8(e) {
  const {
    state: o = "ready",
    total: t,
    limit: r,
    limitRule: i = "cap"
  } = e;
  return o !== "ready" || t === void 0 || t === 0 ? !0 : i === "block" && r !== void 0 && t > r;
}
function P3(e) {
  const {
    state: o = "ready",
    total: t,
    limit: r,
    limitRule: i = "cap"
  } = e;
  return o !== "ready" || t === void 0 || r === void 0 ? !1 : i === "cap" && t > r;
}
function o8(e) {
  const {
    state: o = "ready",
    total: t,
    noun: r,
    groups: i,
    limit: d,
    limitRule: s = "cap",
    zeroMessage: C,
    blockedMessage: u,
    invalidMessage: m,
    incompleteMessage: h,
    meta: b,
    strings: k
  } = e, f = { ...T3, ...k }, y = {
    state: o,
    total: t,
    limit: d,
    limitRule: s
  }, _ = o === "ready" && s === "block" && d !== void 0 && t !== void 0 && t > d, S = o === "invalid" || _, T = o === "incomplete", H = P3(y), z = I({ blocked: S, "over-cap": H, incomplete: T }), W = () => {
    if (b !== void 0) return b;
    if (o === "loading") return f.counting;
    if (o === "invalid") return null;
    if (d === void 0) return T ? null : f.refreshHint;
    const B = f.formatNumber(d);
    return s === "block" ? f.limit(B) : f.capped(B);
  }, D = o === "invalid" ? m ?? f.invalidPeriod : o === "loading" || T ? null : t === 0 ? C ?? null : _ ? u ?? f.overLimit : H && d !== void 0 && t !== void 0 ? f.overCap(f.formatNumber(d), f.formatNumber(t - d)) : null, O = o === "ready" && !S && !!i?.length && t !== 0;
  return /* @__PURE__ */ c(m3, { className: z, children: [
    /* @__PURE__ */ c(b3, { children: [
      /* @__PURE__ */ c(x3, { className: z, children: [
        o === "loading" && /* @__PURE__ */ n(y3, {}),
        o === "ready" && t !== void 0 && /* @__PURE__ */ n("b", { children: f.formatNumber(t) }),
        /* @__PURE__ */ n("span", { children: o === "invalid" ? f.noCount : T ? h ?? f.noCountYet : r })
      ] }),
      W() && /* @__PURE__ */ n(k3, { className: z, children: W() })
    ] }),
    D && /* @__PURE__ */ n(v3, { className: z, children: D }),
    O && /* @__PURE__ */ n(w3, { children: i.map((B) => /* @__PURE__ */ c(M3, { children: [
      /* @__PURE__ */ n(_3, { children: f.groupLabel(B.name) }),
      B.rows.map((v) => /* @__PURE__ */ c(S3, { children: [
        /* @__PURE__ */ n("span", { className: "label", children: v.label }),
        /* @__PURE__ */ n("span", { className: "count", children: f.formatNumber(v.count) })
      ] }, v.label))
    ] }, B.name)) })
  ] });
}
const o0 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 5,
  minWidth: 0
}), E3 = l(p)({
  display: "flex",
  justifyContent: "space-between",
  gap: 8,
  fontSize: 13,
  lineHeight: "18px",
  color: a[500],
  fontVariantNumeric: "tabular-nums",
  "& > .meta": {
    flex: "none",
    color: a[450]
  }
}), I3 = l(x)({
  fontSize: 13,
  lineHeight: "18px",
  color: a[500],
  "&.error": {
    color: R.foreground
  }
}), z3 = l(p)({
  display: "flex",
  height: 6,
  borderRadius: 3,
  overflow: "hidden",
  backgroundColor: Q.track,
  "& > .processed": {
    backgroundColor: Q.positive
  },
  "& > .errored": {
    backgroundColor: Q.negative
  }
}), B3 = l(p)({
  position: "relative",
  height: 6,
  borderRadius: 3,
  overflow: "hidden",
  backgroundColor: Q.track,
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    width: "30%",
    borderRadius: 3,
    backgroundColor: g[500],
    animation: "runProgressSweep 1.6s ease-in-out infinite"
  },
  "@keyframes runProgressSweep": {
    "0%": { transform: "translateX(-100%)" },
    "100%": { transform: "translateX(400%)" }
  },
  // Without the sweep there is no signal left at all, so the track fills to a
  // static third rather than going blank.
  "@media (prefers-reduced-motion: reduce)": {
    "&::after": { animation: "none" }
  }
});
function t8(e) {
  if (e.variant === "message") {
    const { message: m, tone: h = "default" } = e;
    return /* @__PURE__ */ n(o0, { children: /* @__PURE__ */ n(I3, { className: I({ error: h === "error" }), children: m }) });
  }
  const { label: o, meta: t } = e, r = /* @__PURE__ */ c(E3, { children: [
    /* @__PURE__ */ n("span", { children: o }),
    t && /* @__PURE__ */ n("span", { className: "meta", children: t })
  ] });
  if (e.variant === "indeterminate")
    return /* @__PURE__ */ c(o0, { children: [
      r,
      /* @__PURE__ */ n(B3, {})
    ] });
  const { counters: i } = e, d = Math.max(i.total, 0), s = Math.min(i.errored ?? 0, d), C = Math.min(Math.max(i.processed, 0), d - s), u = (m) => d === 0 ? "0%" : `${m / d * 100}%`;
  return /* @__PURE__ */ c(o0, { children: [
    r,
    /* @__PURE__ */ c(z3, { children: [
      /* @__PURE__ */ n("span", { className: "processed", style: { width: u(C) } }),
      /* @__PURE__ */ n("span", { className: "errored", style: { width: u(s) } })
    ] })
  ] });
}
const R3 = {
  queued: { color: "default", pulse: !0 },
  running: { color: "primary", pulse: !0 },
  succeeded: { color: "success", pulse: !1 },
  // Finished, and some items errored -- a warning rather than an error, because
  // the rest of the run is real output someone can use.
  partial: { color: "warning", pulse: !1 },
  failed: { color: "error", pulse: !1 },
  // Stopped by a person, so it reads as neutral: nothing went wrong.
  cancelled: { color: "default", pulse: !1 }
}, L3 = {
  queued: "Queued",
  running: "Running",
  succeeded: "Succeeded",
  partial: "Partial",
  failed: "Failed",
  cancelled: "Cancelled"
};
function n8(e) {
  const { status: o, labels: t } = e, { color: r, pulse: i } = R3[o];
  return /* @__PURE__ */ n(
    r2,
    {
      color: r,
      pulse: i,
      label: t?.[o] ?? L3[o]
    }
  );
}
const i2 = "130px 170px minmax(200px, 1fr) 200px 190px 150px", N3 = 13, H3 = 1040, D3 = l(p)({
  overflowX: "auto"
}), W3 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  minWidth: H3
}), $3 = l(p)({
  display: "grid",
  gridTemplateColumns: i2,
  gap: 14,
  alignItems: "center",
  padding: `0 ${N3}px 6px`,
  fontSize: 11,
  lineHeight: "15px",
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  color: a[400]
}), A3 = {
  status: "Status",
  period: "Period",
  progress: "Progress",
  launched: "Launched",
  options: "Options"
};
function r8(e) {
  const { columnLabels: o, children: t } = e, r = o === !1 ? null : { ...A3, ...o };
  return /* @__PURE__ */ n(D3, { children: /* @__PURE__ */ c(W3, { children: [
    r && /* @__PURE__ */ c($3, { children: [
      /* @__PURE__ */ n("span", { children: r.status }),
      /* @__PURE__ */ n("span", { children: r.period }),
      /* @__PURE__ */ n("span", { children: r.progress }),
      /* @__PURE__ */ n("span", { children: r.launched }),
      /* @__PURE__ */ n("span", { children: r.options }),
      /* @__PURE__ */ n("span", {})
    ] }),
    /* @__PURE__ */ n(he, { children: t })
  ] }) });
}
const F3 = l(p)({
  display: "grid",
  gridTemplateColumns: i2,
  gap: 14,
  alignItems: "center",
  width: "100%",
  minHeight: 44
}), t0 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 1,
  minWidth: 0
}), I0 = l(x)({
  fontSize: 13,
  lineHeight: "18px",
  color: a[500],
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  // The period is a date range, and proportional digits make a column of them
  // look uneven.
  "&.numeric": {
    fontSize: 14,
    fontVariantNumeric: "tabular-nums"
  }
}), z0 = l(x)({
  fontSize: 12,
  lineHeight: "16px",
  color: a[450],
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}), O3 = l(p)({
  display: "flex",
  flexWrap: "wrap",
  gap: 4
}), G3 = l(x)({
  padding: "2px 7px",
  borderRadius: 3,
  backgroundColor: a[100],
  color: a[450],
  fontSize: 11,
  lineHeight: "15px",
  whiteSpace: "nowrap"
}), V3 = l(p)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 4
});
function i8(e) {
  const {
    status: o,
    period: t,
    progress: r,
    launched: i,
    options: d,
    actions: s,
    onClick: C,
    to: u
  } = e;
  return /* @__PURE__ */ n(be, { onClick: C, to: u, children: /* @__PURE__ */ c(F3, { children: [
    /* @__PURE__ */ n(t0, { children: o }),
    /* @__PURE__ */ c(t0, { children: [
      /* @__PURE__ */ n(I0, { className: "numeric", children: t.label }),
      t.caption && /* @__PURE__ */ n(z0, { children: t.caption })
    ] }),
    r,
    /* @__PURE__ */ c(t0, { children: [
      /* @__PURE__ */ n(I0, { children: i.label }),
      i.caption && /* @__PURE__ */ n(z0, { children: i.caption })
    ] }),
    /* @__PURE__ */ n(O3, { children: d?.map((m) => /* @__PURE__ */ n(G3, { children: m }, m)) }),
    /* @__PURE__ */ n(V3, { children: s })
  ] }) });
}
function j3(e, o) {
  const t = {};
  return e.forEach((r) => {
    const i = o(r);
    t[i] ? t[i].push(r) : t[i] = [r];
  }), t;
}
function U3(e) {
  const o = j3(e, (t) => t.type);
  return {
    element: o.element || [],
    textFormat: o["text-format"] || [],
    textMatch: o["text-match"] || []
  };
}
const Z3 = /^\s{0,3}$/;
function B0(e) {
  if (!l1(e))
    return !1;
  const o = e.getFirstChild();
  return o == null || e.getChildrenSize() === 1 && U(o) && Z3.test(o.getTextContent());
}
function Y3(e, o = !1) {
  const t = U3(e), r = !o, i = t.textFormat.filter(
    (d) => d.format.length === 1
  );
  return (d) => {
    const s = [], C = (d || d1()).getChildren();
    for (let u = 0; u < C.length; u++) {
      const m = C[u], h = q3(
        m,
        t.element,
        i,
        t.textMatch
      );
      h != null && s.push(
        // seperate consecutive group of texts with a line break: eg. ["hello", "world"] -> ["hello", "/nworld"]
        r && u > 0 && !B0(m) && !B0(C[u - 1]) ? `
`.concat(h) : h
      );
    }
    return s.join(`
`);
  };
}
function q3(e, o, t, r) {
  for (const i of o) {
    const d = i.export(e, (s) => V(s, o, t, r));
    if (d != null)
      return d;
  }
  return J(e) ? V(e, o, t, r) : Q0(e) ? e.getTextContent() : null;
}
function V(e, o, t, r) {
  const i = [[]], d = e.getChildren();
  e: for (const s of d) {
    for (const C of r) {
      const u = C.export(
        s,
        (m) => V(
          m,
          o,
          t,
          r
        ),
        (m, h) => R0(m, h, t)
      );
      if (u != null) {
        i.slice(-1)[0].push(u);
        continue e;
      }
    }
    if (c1(s))
      i.push([]);
    else if (U(s))
      i.slice(-1)[0].push(
        R0(s, s.getTextContent(), t)
      );
    else if (J(s)) {
      for (const C of o) {
        const u = C.export(
          s,
          (m) => V(
            m,
            o,
            t,
            r
          )
        );
        if (u != null) {
          i.slice(-1)[0].length > 0 ? i.push([u], []) : (i.slice(-1)[0].push(u), i.push([]));
          continue e;
        }
      }
      i.slice(-1)[0].push(
        V(s, o, t, r)
      );
    } else Q0(s) && i.slice(-1)[0].push(s.getTextContent());
  }
  return i.map((s) => s.join("")).join(`
`);
}
function R0(e, o, t) {
  const r = o.trim();
  let i = r;
  const d = /* @__PURE__ */ new Set();
  for (const s of t) {
    const C = s.format[0], { tag: u } = s;
    if (n0(e, C) && !d.has(C)) {
      d.add(C);
      const m = L0(e, !0);
      n0(m, C) || (i = u + i);
      const h = L0(e, !1);
      n0(h, C) || (i += u);
    }
  }
  return o.replace(r, () => i);
}
function L0(e, o) {
  let t = o ? e.getPreviousSibling() : e.getNextSibling();
  if (!t) {
    const r = e.getParentOrThrow();
    r.isInline() && (t = o ? r.getPreviousSibling() : r.getNextSibling());
  }
  for (; t; ) {
    if (J(t)) {
      if (!t.isInline())
        break;
      const r = o ? t.getLastDescendant() : t.getFirstDescendant();
      if (U(r))
        return r;
      t = o ? t.getPreviousSibling() : t.getNextSibling();
    }
    if (U(t))
      return t;
    if (!J(t))
      return null;
  }
  return null;
}
function n0(e, o) {
  return U(e) && e.hasFormat(o);
}
function X3(e = K0, o, t = !1) {
  return Y3(
    e,
    t
  )(o);
}
const K3 = l("div")({
  "& .PlaygroundEditorTheme__ul": {
    "& .PlaygroundEditorTheme__listItem": {
      "&.PlaygroundEditorTheme__listItemUnchecked": {
        "&:before": {
          border: `1px solid ${a[500]}`,
          borderRadius: 2
        }
      },
      "&.PlaygroundEditorTheme__listItemChecked": {
        textDecoration: "none",
        "&:before": {
          borderRadius: 2,
          backgroundColor: g[500],
          display: "block",
          width: 16,
          height: 16,
          backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E")`,
          content: '""'
        }
      }
    }
  },
  "& .Block": {
    backgroundColor: a[100],
    borderRadius: 4,
    marginBottom: 8,
    padding: "8px 12px",
    "&.hidden": {
      display: "none"
    }
  }
}), a8 = l(p)({
  padding: "6px 10px",
  "& .MuiButton-root": {
    fontSize: "14px",
    padding: "4px 8px",
    gap: 4,
    "& svg": {
      fontSize: "16px"
    }
  }
}), Q3 = {
  blockCursor: "PlaygroundEditorTheme__blockCursor",
  characterLimit: "PlaygroundEditorTheme__characterLimit",
  code: "PlaygroundEditorTheme__code",
  codeHighlight: {
    atrule: "PlaygroundEditorTheme__tokenAttr",
    attr: "PlaygroundEditorTheme__tokenAttr",
    boolean: "PlaygroundEditorTheme__tokenProperty",
    builtin: "PlaygroundEditorTheme__tokenSelector",
    cdata: "PlaygroundEditorTheme__tokenComment",
    char: "PlaygroundEditorTheme__tokenSelector",
    class: "PlaygroundEditorTheme__tokenFunction",
    "class-name": "PlaygroundEditorTheme__tokenFunction",
    comment: "PlaygroundEditorTheme__tokenComment",
    constant: "PlaygroundEditorTheme__tokenProperty",
    deleted: "PlaygroundEditorTheme__tokenProperty",
    doctype: "PlaygroundEditorTheme__tokenComment",
    entity: "PlaygroundEditorTheme__tokenOperator",
    function: "PlaygroundEditorTheme__tokenFunction",
    important: "PlaygroundEditorTheme__tokenVariable",
    inserted: "PlaygroundEditorTheme__tokenSelector",
    keyword: "PlaygroundEditorTheme__tokenAttr",
    namespace: "PlaygroundEditorTheme__tokenVariable",
    number: "PlaygroundEditorTheme__tokenProperty",
    operator: "PlaygroundEditorTheme__tokenOperator",
    prolog: "PlaygroundEditorTheme__tokenComment",
    property: "PlaygroundEditorTheme__tokenProperty",
    punctuation: "PlaygroundEditorTheme__tokenPunctuation",
    regex: "PlaygroundEditorTheme__tokenVariable",
    selector: "PlaygroundEditorTheme__tokenSelector",
    string: "PlaygroundEditorTheme__tokenSelector",
    symbol: "PlaygroundEditorTheme__tokenProperty",
    tag: "PlaygroundEditorTheme__tokenProperty",
    url: "PlaygroundEditorTheme__tokenOperator",
    variable: "PlaygroundEditorTheme__tokenVariable"
  },
  embedBlock: {
    base: "PlaygroundEditorTheme__embedBlock",
    focus: "PlaygroundEditorTheme__embedBlockFocus"
  },
  hashtag: "PlaygroundEditorTheme__hashtag",
  heading: {
    h1: "PlaygroundEditorTheme__h1",
    h2: "PlaygroundEditorTheme__h2",
    h3: "PlaygroundEditorTheme__h3",
    h4: "PlaygroundEditorTheme__h4",
    h5: "PlaygroundEditorTheme__h5",
    h6: "PlaygroundEditorTheme__h6"
  },
  image: "editor-image",
  indent: "PlaygroundEditorTheme__indent",
  link: "PlaygroundEditorTheme__link",
  list: {
    listitem: "PlaygroundEditorTheme__listItem",
    listitemChecked: "PlaygroundEditorTheme__listItemChecked",
    listitemUnchecked: "PlaygroundEditorTheme__listItemUnchecked",
    nested: {
      listitem: "PlaygroundEditorTheme__nestedListItem"
    },
    olDepth: [
      "PlaygroundEditorTheme__ol1",
      "PlaygroundEditorTheme__ol2",
      "PlaygroundEditorTheme__ol3",
      "PlaygroundEditorTheme__ol4",
      "PlaygroundEditorTheme__ol5"
    ],
    ul: "PlaygroundEditorTheme__ul"
  },
  ltr: "PlaygroundEditorTheme__ltr",
  mark: "PlaygroundEditorTheme__mark",
  markOverlap: "PlaygroundEditorTheme__markOverlap",
  paragraph: "PlaygroundEditorTheme__paragraph",
  quote: "PlaygroundEditorTheme__quote",
  rtl: "PlaygroundEditorTheme__rtl",
  table: "PlaygroundEditorTheme__table",
  tableAddColumns: "PlaygroundEditorTheme__tableAddColumns",
  tableAddRows: "PlaygroundEditorTheme__tableAddRows",
  tableCell: "PlaygroundEditorTheme__tableCell",
  tableCellActionButton: "PlaygroundEditorTheme__tableCellActionButton",
  tableCellActionButtonContainer: "PlaygroundEditorTheme__tableCellActionButtonContainer",
  tableCellEditing: "PlaygroundEditorTheme__tableCellEditing",
  tableCellHeader: "PlaygroundEditorTheme__tableCellHeader",
  tableCellPrimarySelected: "PlaygroundEditorTheme__tableCellPrimarySelected",
  tableCellResizer: "PlaygroundEditorTheme__tableCellResizer",
  tableCellSelected: "PlaygroundEditorTheme__tableCellSelected",
  tableCellSortedIndicator: "PlaygroundEditorTheme__tableCellSortedIndicator",
  tableResizeRuler: "PlaygroundEditorTheme__tableCellResizeRuler",
  tableSelected: "PlaygroundEditorTheme__tableSelected",
  text: {
    bold: "PlaygroundEditorTheme__textBold",
    code: "PlaygroundEditorTheme__textCode",
    italic: "PlaygroundEditorTheme__textItalic",
    strikethrough: "PlaygroundEditorTheme__textStrikethrough",
    subscript: "PlaygroundEditorTheme__textSubscript",
    superscript: "PlaygroundEditorTheme__textSuperscript",
    underline: "PlaygroundEditorTheme__textUnderline",
    underlineStrikethrough: "PlaygroundEditorTheme__textUnderlineStrikethrough"
  }
};
function J3(e, o) {
  console.error("Rich text editor error", e), o?.(e);
}
const e6 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20data-name='Layer%201'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20stroke='currentColor'%20d='M8.5%2010a2%202%200%201%200%202%202%202%202%200%200%200-2-2Zm0%207a2%202%200%201%200%202%202%202%202%200%200%200-2-2Zm7-10a2%202%200%201%200-2-2%202%202%200%200%200%202%202Zm-7-4a2%202%200%201%200%202%202%202%202%200%200%200-2-2Zm7%2014a2%202%200%201%200%202%202%202%202%200%200%200-2-2Zm0-7a2%202%200%201%200%202%202%202%202%200%200%200-2-2Z'/%3e%3c/svg%3e", N0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20fill='currentColor'%20class='bi%20bi-plus'%3e%3cpath%20d='M8%204a.5.5%200%200%201%20.5.5v3h3a.5.5%200%200%201%200%201h-3v3a.5.5%200%200%201-1%200v-3h-3a.5.5%200%200%201%200-1h3v-3A.5.5%200%200%201%208%204z'/%3e%3c/svg%3e", H0 = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.29 15.88 13.17 12 9.29 8.12a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42"/></svg>'
)}`, D0 = (e) => `
/* themes/PlaygroundEditorTheme.css */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
.PlaygroundEditorTheme__ltr {
  text-align: left;
}

.PlaygroundEditorTheme__rtl {
  text-align: right;
}

.PlaygroundEditorTheme__paragraph {
  margin: 0;
  position: relative;
}

.PlaygroundEditorTheme__quote {
  margin: 0;
  margin-left: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  color: rgb(101, 103, 107);
  border-left-color: rgb(206, 208, 212);
  border-left-width: 4px;
  border-left-style: solid;
  padding-left: 16px;
}

.PlaygroundEditorTheme__h1 {
  font-size: 24px;
  color: rgb(5, 5, 5);
  font-weight: 400;
  margin: 0;
}

.PlaygroundEditorTheme__h2 {
  font-size: 15px;
  color: rgb(101, 103, 107);
  font-weight: 700;
  margin: 0;
  text-transform: uppercase;
}

.PlaygroundEditorTheme__h3 {
  font-size: 12px;
  margin: 0;
  text-transform: uppercase;
}

.PlaygroundEditorTheme__indent {
  --lexical-indent-base-value: 40px;
}

.PlaygroundEditorTheme__textBold {
  font-weight: bold;
}

.PlaygroundEditorTheme__textItalic {
  font-style: italic;
}

.PlaygroundEditorTheme__textUnderline {
  text-decoration: underline;
}

.PlaygroundEditorTheme__textStrikethrough {
  text-decoration: line-through;
}

.PlaygroundEditorTheme__textUnderlineStrikethrough {
  text-decoration: underline line-through;
}

.PlaygroundEditorTheme__textSubscript {
  font-size: 0.8em;
  vertical-align: sub !important;
}

.PlaygroundEditorTheme__textSuperscript {
  font-size: 0.8em;
  vertical-align: super;
}

.PlaygroundEditorTheme__textCode {
  background-color: rgb(240, 242, 245);
  padding: 1px 0.25rem;
  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 94%;
}

.PlaygroundEditorTheme__hashtag {
  background-color: rgba(88, 144, 255, 0.15);
  border-bottom: 1px solid rgba(88, 144, 255, 0.3);
}

.PlaygroundEditorTheme__link {
  color: rgb(33, 111, 219);
  text-decoration: none;
}

.PlaygroundEditorTheme__link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.PlaygroundEditorTheme__code {
  background-color: rgb(240, 242, 245);
  font-family: Menlo, Consolas, Monaco, monospace;
  display: block;
  padding: 8px 8px 8px 52px;
  line-height: 1.53;
  font-size: 13px;
  margin: 0;
  margin-top: 8px;
  margin-bottom: 8px;
  overflow-x: auto;
  position: relative;
  tab-size: 2;
}

.PlaygroundEditorTheme__code:before {
  content: attr(data-gutter);
  position: absolute;
  background-color: #eee;
  left: 0;
  top: 0;
  border-right: 1px solid #ccc;
  padding: 8px;
  color: #777;
  white-space: pre-wrap;
  text-align: right;
  min-width: 25px;
}

.PlaygroundEditorTheme__table {
  border-collapse: collapse;
  border-spacing: 0;
  max-width: 100%;
  overflow-y: scroll;
  table-layout: fixed;
  width: calc(100% - 25px);
  margin: 30px 0;
}

.PlaygroundEditorTheme__tableSelected {
  outline: 2px solid rgb(60, 132, 244);
}

.PlaygroundEditorTheme__tableCell {
  border: 1px solid #bbb;
  min-width: 75px;
  vertical-align: top;
  text-align: start;
  padding: 6px 8px;
  position: relative;
  cursor: default;
  outline: none;
}

.PlaygroundEditorTheme__tableCellSortedIndicator {
  display: block;
  opacity: 0.5;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #999;
}

.PlaygroundEditorTheme__tableCellResizer {
  position: absolute;
  right: -4px;
  height: 100%;
  width: 8px;
  cursor: ew-resize;
  z-index: 10;
  top: 0;
}

.PlaygroundEditorTheme__tableCellHeader {
  background-color: #f2f3f5;
  text-align: start;
}

.PlaygroundEditorTheme__tableCellSelected {
  background-color: #c9dbf0;
}

.PlaygroundEditorTheme__tableCellPrimarySelected {
  border: 2px solid rgb(60, 132, 244);
  display: block;
  height: calc(100% - 2px);
  position: absolute;
  width: calc(100% - 2px);
  left: -1px;
  top: -1px;
  z-index: 2;
}

.PlaygroundEditorTheme__tableCellEditing {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  border-radius: 3px;
}

.PlaygroundEditorTheme__tableAddColumns {
  position: absolute;
  top: 0;
  width: 20px;
  background-color: #eee;
  height: 100%;
  right: 0;
  animation: table-controls 0.2s ease;
  border: 0;
  cursor: pointer;
}

.PlaygroundEditorTheme__tableAddColumns:after {
  background-image: url(${N0});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.4;
}

.PlaygroundEditorTheme__tableAddColumns:hover {
  background-color: #c9dbf0;
}

.PlaygroundEditorTheme__tableAddRows {
  position: absolute;
  bottom: -25px;
  width: calc(100% - 25px);
  background-color: #eee;
  height: 20px;
  left: 0;
  animation: table-controls 0.2s ease;
  border: 0;
  cursor: pointer;
}

.PlaygroundEditorTheme__tableAddRows:after {
  background-image: url(${N0});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.4;
}

.PlaygroundEditorTheme__tableAddRows:hover {
  background-color: #c9dbf0;
}

@keyframes table-controls {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.PlaygroundEditorTheme__tableCellResizeRuler {
  display: block;
  position: absolute;
  width: 1px;
  background-color: rgb(60, 132, 244);
  height: 100%;
  top: 0;
}

.PlaygroundEditorTheme__tableCellActionButtonContainer {
  display: block;
  right: 5px;
  top: 6px;
  position: absolute;
  z-index: 4;
  width: 20px;
  height: 20px;
}

.PlaygroundEditorTheme__tableCellActionButton {
  background-color: #eee;
  display: block;
  border: 0;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  color: #222;
  cursor: pointer;
}

.PlaygroundEditorTheme__tableCellActionButton:hover {
  background-color: #ddd;
}

.PlaygroundEditorTheme__characterLimit {
  display: inline;
  background-color: #ffbbbb !important;
}

.PlaygroundEditorTheme__ol1 {
  padding: 0;
  margin: 0;
  list-style-position: inside;
}

.PlaygroundEditorTheme__ol2 {
  padding: 0;
  margin: 0;
  list-style-type: upper-alpha;
  list-style-position: inside;
}

.PlaygroundEditorTheme__ol3 {
  padding: 0;
  margin: 0;
  list-style-type: lower-alpha;
  list-style-position: inside;
}

.PlaygroundEditorTheme__ol4 {
  padding: 0;
  margin: 0;
  list-style-type: upper-roman;
  list-style-position: inside;
}

.PlaygroundEditorTheme__ol5 {
  padding: 0;
  margin: 0;
  list-style-type: lower-roman;
  list-style-position: inside;
}

.PlaygroundEditorTheme__ul {
  padding: 0;
  margin: 0;
  list-style-position: outside;
}

.PlaygroundEditorTheme__listItem {
  margin: 0 32px;
}

.PlaygroundEditorTheme__listItemChecked,
.PlaygroundEditorTheme__listItemUnchecked {
  position: relative;
  margin-left: 8px;
  margin-right: 8px;
  padding-left: 24px;
  padding-right: 24px;
  list-style-type: none;
  outline: none;
}

.PlaygroundEditorTheme__listItemUnchecked:before,
.PlaygroundEditorTheme__listItemChecked:before {
  content: '';
  width: 16px;
  height: 16px;
  top: 2px;
  left: 0;
  cursor: pointer;
  display: block;
  background-size: cover;
  position: absolute;
}

.PlaygroundEditorTheme__listItemUnchecked[dir='rtl']:before,
.PlaygroundEditorTheme__listItemChecked[dir='rtl']:before {
  left: auto;
  right: 0;
}

.PlaygroundEditorTheme__listItemUnchecked:focus:before,
.PlaygroundEditorTheme__listItemChecked:focus:before {
  box-shadow: 0 0 0 2px #a6cdfe;
  border-radius: 2px;
}

.PlaygroundEditorTheme__listItemUnchecked:before {
  border: 1px solid #999;
  border-radius: 2px;
}

.PlaygroundEditorTheme__nestedListItem {
  list-style-type: none;
}

.PlaygroundEditorTheme__nestedListItem:before,
.PlaygroundEditorTheme__nestedListItem:after {
  display: none;
}

.PlaygroundEditorTheme__tokenComment {
  color: slategray;
}

.PlaygroundEditorTheme__tokenPunctuation {
  color: #999;
}

.PlaygroundEditorTheme__tokenProperty {
  color: #905;
}

.PlaygroundEditorTheme__tokenSelector {
  color: #690;
}

.PlaygroundEditorTheme__tokenOperator {
  color: #9a6e3a;
}

.PlaygroundEditorTheme__tokenAttr {
  color: #07a;
}

.PlaygroundEditorTheme__tokenVariable {
  color: #e90;
}

.PlaygroundEditorTheme__tokenFunction {
  color: #dd4a68;
}

.PlaygroundEditorTheme__mark {
  background: rgba(255, 212, 0, 0.14);
  border-bottom: 2px solid rgba(255, 212, 0, 0.3);
  padding-bottom: 2px;
}

.PlaygroundEditorTheme__markOverlap {
  background: rgba(255, 212, 0, 0.3);
  border-bottom: 2px solid rgba(255, 212, 0, 0.7);
}

.PlaygroundEditorTheme__mark.selected {
  background: rgba(255, 212, 0, 0.5);
  border-bottom: 2px solid rgba(255, 212, 0, 1);
}

.PlaygroundEditorTheme__markOverlap.selected {
  background: rgba(255, 212, 0, 0.7);
  border-bottom: 2px solid rgba(255, 212, 0, 0.7);
}

.PlaygroundEditorTheme__embedBlock {
  user-select: none;
}

.PlaygroundEditorTheme__embedBlockFocus {
  outline: 2px solid rgb(60, 132, 244);
}

/* index.css */
.editor-shell .editor-image img.focused.draggable {
  cursor: grab;
}

.editor-shell .editor-image img.focused.draggable:active {
  cursor: grabbing;
}

.editor-shell {
  position: relative;
  /* Edit mode is a control on a page, so it needs to look like one: its own surface, its own
     edge. Read mode deliberately has neither -- rendered content belongs to whatever is around
     it. The border rounds outside the toolbar, so the toolbar is clipped to it. */
  background: #fff;
  border: 1px solid ${a[300]};
  border-radius: 8px;
  overflow: hidden;
}

/* The toolbar sits directly above the writing surface; without this they read as one block. */
.editor-shell .editor-container {
  background: #fff;
  border-top: 1px solid ${a[100]};
}

.table-cell-action-button-container {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}

/* ui/ContentEditable.css */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
.ContentEditable__root {
  border: 0;
  font-size: 15px;
  display: block;
  position: relative;
  outline: 0;
  padding: 8px 28px 8px;
  min-height: 150px;
}
@media (max-width: 1025px) {
  .ContentEditable__root {
    padding-left: 8px;
    padding-right: 8px;
  }
}

/* ui/Placeholder.css */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */

.Placeholder__root {
  font-size: 15px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
  display: inline-block;
  pointer-events: none;
}
/* Edit mode only. The editor's placeholder has to sit over the first line of the content, below
   the toolbar; read mode has neither a toolbar nor an editable line to sit on, and positioning
   it there pushed it to the bottom of the rendered content. */
.editor-shell .Placeholder__root {
  position: absolute;
  top: 42px;
  left: 28px;
  right: 28px;
}
@media (max-width: 1025px) {
  .Placeholder__root {
    left: 8px;
  }
}

/* ui/ColorPicker/ColorPicker.css */
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

.color-picker-wrapper {
  padding: 20px;
}

.color-picker-basic-color {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  padding: 0;
}

.color-picker-basic-color button {
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 16px;
  width: 16px;
  cursor: pointer;
  list-style-type: none;
}

.color-picker-basic-color button.active {
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.color-picker-saturation {
  width: 100%;
  position: relative;
  margin-top: 15px;
  height: 150px;
  background-image: linear-gradient(transparent, black),
    linear-gradient(to right, white, transparent);
  user-select: none;
}
.color-picker-saturation_cursor {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 15px #00000026;
  box-sizing: border-box;
  transform: translate(-10px, -10px);
}
.color-picker-hue {
  width: 100%;
  position: relative;
  margin-top: 15px;
  height: 12px;
  background-image: linear-gradient(
    to right,
    rgb(255, 0, 0),
    rgb(255, 255, 0),
    rgb(0, 255, 0),
    rgb(0, 255, 255),
    rgb(0, 0, 255),
    rgb(255, 0, 255),
    rgb(255, 0, 0)
  );
  user-select: none;
  border-radius: 12px;
}

.color-picker-hue_cursor {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: #0003 0 0 0 0.5px;
  box-sizing: border-box;
  transform: translate(-10px, -4px);
}

.color-picker-color {
  border: 1px solid #ccc;
  margin-top: 15px;
  width: 100%;
  height: 20px;
}

/* nodes/ImageNode.css */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */

.ImageNode__contentEditable {
  min-height: 20px;
  border: 0px;
  resize: none;
  cursor: text;
  caret-color: rgb(5, 5, 5);
  display: block;
  position: relative;
  outline: 0px;
  padding: 10px;
  user-select: text;
  font-size: 12px;
  width: calc(100% - 20px);
  white-space: pre-wrap;
  word-break: break-word;
}

.ImageNode__placeholder {
  font-size: 12px;
  color: #888;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 10px;
  left: 10px;
  user-select: none;
  white-space: nowrap;
  display: inline-block;
  pointer-events: none;
}

.image-control-wrapper--resizing {
  touch-action: none;
}

/* plugins/CollapsiblePlugin/Collapsible.css, recoloured. The only definition of a collapsible,
 * for both modes: the marker is an absolutely positioned zero-width box, so a second stylesheet
 * setting the other offset stretches it into a rule across the title. State is details[open] --
 * nothing here may key on data-lexical-is-expanded, which this node does not set. */
.Collapsible__container {
  background: ${a[100]};
  border: 1px solid ${a[300]};
  border-radius: 4px;
  margin-bottom: 8px;
}

.Collapsible__container:hover,
.Collapsible__container[open] {
  background: ${g[100]};
}

.Collapsible__title {
  cursor: pointer;
  padding: 6px 8px 6px 24px;
  position: relative;
  font-weight: bold;
  list-style: none;
  outline: none;
  user-select: none;
}

.Collapsible__title::marker,
.Collapsible__title::-webkit-details-marker {
  display: none;
}

/* KeyboardArrowRightRounded, masked rather than drawn: a marker made of borders is a sharp
 * triangle, and every icon in this design system is a rounded one. The mask paints it in the
 * palette colour instead of baking a fill into the data URI. */
.Collapsible__title:before {
  display: block;
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  width: 16px;
  height: 16px;
  background-color: ${a[500]};
  -webkit-mask: url("${H0}") no-repeat center / contain;
  mask: url("${H0}") no-repeat center / contain;
  transform: translateY(-50%) rotate(0deg);
  transition: ${e.transitions.create("transform", {
  duration: e.transitions.duration.shorter
})};
}

.Collapsible__container[open] .Collapsible__title:before {
  transform: translateY(-50%) rotate(90deg);
}

/* Declared after the rule above so it wins on order at equal specificity: while a collapsible is
 * closing it still carries [open], because the content may not be dropped until it has finished
 * shrinking, and the marker must not wait for that to turn back. */
.Collapsible__container[data-collapsing] .Collapsible__title:before {
  transform: translateY(-50%) rotate(0deg);
}

/* The height is animated, so it must be the whole of what grows: vertical padding here would
 * still be drawn at height 0 and snap at the end of the close. The gap under the content comes
 * from its last child instead, inside the box being measured. */
.Collapsible__content {
  padding: 0 8px 0 24px;
  overflow: hidden;
  transition: ${e.transitions.create("height", {
  duration: e.transitions.duration.shorter
})};
}

.Collapsible__content > *:last-child {
  margin-bottom: 8px;
}

.Collapsible__collapsed .Collapsible__content {
  display: none;
  user-select: none;
}

/* plugins/DraggableBlockPlugin/index.css */
.draggable-block-menu {
  border-radius: 4px;
  padding: 2px 1px;
  cursor: grab;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  will-change: transform;
}

.draggable-block-menu .icon {
  width: 16px;
  height: 16px;
  opacity: 0.3;
  background-image: url(${e6});
}

.draggable-block-menu:active {
  cursor: grabbing;
}

.draggable-block-menu:hover {
  background-color: #efefef;
}

.draggable-block-target-line {
  pointer-events: none;
  background: deepskyblue;
  height: 4px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  will-change: transform;
}

/* plugins/FloatingLinkEditorPlugin/index.css */
.link-editor {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  max-width: 400px;
  width: 100%;
  opacity: 0;
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 0 0 8px 8px;
  transition: opacity 0.5s;
  will-change: transform;
}

.link-editor .button {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 2px;
}

.link-editor .button.hovered {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-color: #eee;
}

.link-editor .button i,
.actions i {
  background-size: contain;
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: -0.25em;
}

/* plugins/TableCellResizer/index.css */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */

.TableCellResizer__resizer {
  position: absolute;
}
`, o6 = w.lazy(() => import("./EditWysiwyg-CE_jJPg_.js"));
function t6({ value: e, emptyText: o, onPlainText: t }) {
  const [r] = n1();
  return w.useEffect(() => {
    if (!t) return;
    const i = r.parseEditorState(e);
    t(i.read(() => X3(K0, void 0, !0)));
  }, [r, e, t]), /* @__PURE__ */ n(
    a1,
    {
      contentEditable: /* @__PURE__ */ n(r1, {}),
      ErrorBoundary: i1,
      placeholder: o ? /* @__PURE__ */ n(s1, { children: o }) : null
    }
  );
}
function n6(e) {
  const { value: o, emptyText: t, onPlainText: r } = e, { reportError: i, onUrlOpen: d } = M2(), s = (u) => {
    if (u.stopPropagation(), !d) return;
    const h = u.target.closest("a")?.getAttribute("href");
    h && (u.preventDefault(), d(h));
  }, C = {
    editorState: o,
    namespace: "CogNeed",
    nodes: [..._2],
    onError: (u) => J3(u, i),
    theme: Q3,
    editable: !1
  };
  return /* @__PURE__ */ n(K3, { children: /* @__PURE__ */ n("div", { onClick: s, children: /* @__PURE__ */ n(t1, { initialConfig: C, children: /* @__PURE__ */ n(t6, { value: o, emptyText: t, onPlainText: r }) }) }) });
}
function a2(e) {
  const { mode: o } = e;
  return o === "read" ? /* @__PURE__ */ c($, { children: [
    /* @__PURE__ */ n(M0, { styles: D0 }),
    /* @__PURE__ */ n(n6, { ...e })
  ] }) : /* @__PURE__ */ c($, { children: [
    /* @__PURE__ */ n(M0, { styles: D0 }),
    /* @__PURE__ */ n(w.Suspense, { fallback: null, children: /* @__PURE__ */ n(o6, { ...e }) })
  ] });
}
const r6 = l(p)({
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  height: "100%",
  // The ground the header and the content panel sit on, both of which are white: a card is a
  // sheet on a page, not the page.
  backgroundColor: a[100]
}), i6 = l(p)({
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  gap: 8,
  backgroundColor: "#fff",
  padding: "8px 24px 8px 24px",
  "& div.card-header-content": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "& > .MuiBox-root": {
      display: "flex",
      alignItems: "center",
      gap: 8,
      width: "100%"
    },
    "& .MuiTypography-subtitle1": {
      fontSize: 16,
      lineHeight: "24px",
      color: a[800],
      fontWeight: 600,
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: "calc(100% - 20px)"
    },
    // The application's own controls, styled here so every card header carries the same ones
    // whichever application drew them.
    "& button.MuiButton-root.action": {
      marginLeft: -8
    },
    "& .MuiButton-root.action": {
      fontSize: 16,
      lineHeight: 1,
      minWidth: 0,
      padding: 4,
      color: g[400],
      "&:hover": {
        color: g[600]
      },
      "&:visited": {
        color: g[500]
      },
      "& svg": {
        fontSize: "inherit",
        color: "inherit"
      }
    }
  },
  "& .MuiTypography-subtitle2": {
    fontStyle: "italic",
    fontSize: 14
  },
  // A banner the application supplies -- an expired or deleted card -- bled to the full width.
  "& > .MuiAlert-root": {
    padding: "4px 8px",
    backgroundColor: M[100],
    border: `1px solid ${N(M[300], 0.3)}`,
    borderRadius: 0,
    margin: "-8px -24px 8px -24px",
    "& .MuiTypography-root": {
      fontSize: 14,
      lineHeight: "20px",
      fontWeight: 500
    },
    "& .MuiAlert-icon": {
      fontSize: 20
    }
  }
}), a6 = l(
  (e) => {
    const { fontSize: o, ...t } = e;
    return /* @__PURE__ */ n(p, { ...t });
  }
)(({ fontSize: e }) => ({
  flexGrow: 1,
  flexShrink: 1,
  minHeight: 0,
  overflowY: "auto",
  fontFamily: "'Source Sans Pro', 'Open Sans'",
  fontSize: e,
  lineHeight: 1.25,
  // A sheet inset on the page, which is what live's content panel is.
  backgroundColor: "#fff",
  borderRadius: 6,
  margin: "8px 12px",
  padding: "8px 12px",
  "& .cogneed-content": {
    color: a[700],
    "& a": {
      color: E[600],
      fontWeight: 600,
      textDecoration: "none",
      overflowWrap: "anywhere",
      "&:hover": {
        color: E[700],
        textDecoration: "none"
      }
    },
    "& img": {
      maxWidth: "100%",
      cursor: "pointer"
    }
  }
})), l6 = l("div")({
  position: "relative",
  margin: "16px 0px",
  "& .PlaygroundEditorTheme__paragraph": {
    margin: "16px 0px"
  },
  "& .highlight": {
    backgroundColor: E[100]
  }
}), d6 = l(p)(({ theme: e }) => ({
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.standard
  }),
  marginTop: 8,
  borderRadius: 4,
  position: "relative",
  backgroundColor: a[100],
  "& .MuiCollapse-root": {
    padding: "0px 8px",
    "& p:first-of-type": {
      marginTop: 0
    }
  },
  "& .PlaygroundEditorTheme__paragraph": {
    margin: "16px 0px",
    lineHeight: "20px"
  },
  "&.expanded": {
    backgroundColor: g[100],
    "& .MuiCollapse-root": {
      padding: "4px 8px"
    },
    "& .MuiButton-root .MuiTypography-root": {
      fontWeight: 600
    }
  }
})), c6 = l(P)({
  "& .MuiTypography-root": {
    fontSize: 14,
    lineHeight: "24px",
    fontWeight: 400
  },
  textTransform: "none",
  padding: "4px 8px",
  backgroundColor: "transparent",
  color: a[800],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}), s6 = l(
  (e) => /* @__PURE__ */ n(Y0, { disableRipple: !0, ...e })
)(({ theme: e }) => ({
  "& > p": {
    display: "block",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
    maxWidth: "100%"
  },
  textTransform: "none",
  fontSize: 12,
  lineHeight: "20px",
  color: a[400],
  padding: "0 12px",
  minWidth: 120,
  maxWidth: 220,
  minHeight: 40,
  height: 40,
  borderRadius: 10,
  overflow: "hidden",
  [e.breakpoints.up("sm")]: {
    minWidth: 120
  },
  fontWeight: e.typography.fontWeightRegular,
  "&:hover": {
    backgroundColor: g[100],
    color: g[600]
  },
  "&.Mui-selected": {
    color: a[800],
    fontWeight: 700,
    backgroundColor: g[100]
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#fff"
  }
})), C6 = l(p)({
  backgroundColor: "#fff",
  maxWidth: "100%",
  "& .MuiTabs-root": {
    display: "flex",
    alignItems: "center",
    minHeight: 40,
    position: "relative",
    maxWidth: "100%",
    backgroundColor: "#fff",
    borderRadius: 14,
    border: `1px solid ${a[100]}`,
    "& .MuiTabs-indicator": {
      backgroundColor: g[500],
      height: 2,
      borderRadius: 999
    },
    "& .MuiTabs-flexContainer": {
      alignItems: "stretch",
      gap: 8,
      padding: "4px 8px 0"
    },
    "& div.MuiTabs-scrollButtons:first-of-type": {
      position: "absolute",
      backgroundColor: "#fff",
      zIndex: 4,
      height: 40,
      borderRadius: 14
    },
    "& div.MuiTabs-scrollButtons:last-of-type": {
      position: "absolute",
      right: 0,
      backgroundColor: "#fff",
      zIndex: 4,
      height: 40,
      borderRadius: 14
    },
    "& .MuiTabs-scroller": {
      zIndex: 3,
      width: "100%"
    }
  }
}), W0 = l(p)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  backgroundColor: N(g[300], 0.3),
  padding: "6px 24px",
  // Out through the header's own padding, so the row is a band the full width of the card.
  margin: "8px -24px -8px -24px",
  border: `0px solid ${g[300]}`,
  borderWidth: "2px 0px",
  gap: 8,
  overflowX: "auto",
  overflowY: "hidden",
  "& .MuiButton-root": {
    background: "transparent",
    color: g[500],
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "transparent",
      color: g[600]
    },
    textTransform: "none",
    minWidth: "max-content",
    padding: 0,
    textDecoration: "underline",
    fontSize: 12,
    lineHeight: "20px",
    height: 20
  },
  "& .MuiTypography-h3": {
    minWidth: "max-content",
    fontSize: 12,
    lineHeight: "20px",
    color: a[800],
    marginRight: 4
  },
  // The application's message when it could not fetch the links: a strip the width of the row
  // rather than a dialog, since the card itself is fine.
  "&.error-state": {
    flexDirection: "column",
    alignItems: "stretch",
    overflow: "visible"
  },
  "& .MuiAlert-root": {
    padding: "2px 8px",
    minHeight: 0,
    borderRadius: 4,
    alignItems: "center",
    backgroundColor: N(M[100], 0.7),
    color: M[500],
    border: `1px solid ${N(M[300], 0.7)}`,
    "& .MuiAlert-icon": {
      color: M[500],
      padding: "2px 0",
      marginRight: 6,
      fontSize: 16
    },
    "& .MuiAlert-message": {
      padding: "2px 0",
      color: M[500],
      fontSize: 12,
      lineHeight: "20px",
      fontWeight: 600
    }
  }
}), p6 = l(q0)(({ theme: e }) => ({
  transform: "rotate(0deg)",
  marginLeft: "auto",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  "&.expanded": {
    transform: "rotate(180deg)"
  }
}));
function u6({ title: e, content: o }) {
  const [t, r] = w.useState(!1), i = w.useRef(null);
  return /* @__PURE__ */ c(d6, { className: t ? "expanded" : void 0, children: [
    /* @__PURE__ */ c(c6, { onClick: () => {
      r(!t), !t && setTimeout(() => {
        i.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      }, 350);
    }, fullWidth: !0, disableRipple: !0, children: [
      /* @__PURE__ */ n(x, { component: "div", children: e }),
      /* @__PURE__ */ n(p6, { className: t ? "expanded" : void 0 })
    ] }),
    /* @__PURE__ */ n(O0, { in: t, children: /* @__PURE__ */ n("div", { ref: i, children: /* @__PURE__ */ n(a2, { mode: "read", value: o }) }) })
  ] });
}
function g6({
  content: e,
  title: o,
  collapsible: t,
  emptyText: r
}) {
  return t ? /* @__PURE__ */ n(u6, { title: o, content: e }) : (
    // Keyed on the content so a block whose search highlighting changed is remounted: the
    // editor takes its state once, and a new value for the same key would not be read.
    /* @__PURE__ */ n(l6, { children: /* @__PURE__ */ n(a2, { mode: "read", value: e, emptyText: r }) }, e)
  );
}
function h6({
  label: e,
  links: o,
  error: t,
  onOpen: r
}) {
  return t ? /* @__PURE__ */ c(W0, { className: "card-footer error-state", children: [
    /* @__PURE__ */ n(x, { variant: "h3", children: e }),
    t
  ] }) : o.length ? /* @__PURE__ */ c(W0, { className: "card-footer", children: [
    /* @__PURE__ */ n(x, { variant: "h3", children: e }),
    o.map((i) => /* @__PURE__ */ n(
      P,
      {
        disableRipple: !0,
        variant: "text",
        onClick: () => {
          r?.(i.id);
        },
        children: i.title
      },
      i.id
    ))
  ] }) : null;
}
const f6 = {
  moreInfo: "More information",
  emptyTab: "No content to display",
  links: "Associated cards"
};
function m6({ tabs: e, currentIndex: o, onChange: t }) {
  return /* @__PURE__ */ n(C6, { children: /* @__PURE__ */ n(
    Z0,
    {
      value: o,
      onChange: (r, i) => {
        t(i);
      },
      variant: "scrollable",
      scrollButtons: !0,
      allowScrollButtonsMobile: !0,
      children: e.map((r) => /* @__PURE__ */ n(
        s6,
        {
          label: /* @__PURE__ */ n(x, { variant: "inherit", children: r.title }),
          title: r.title
        },
        r.id
      ))
    }
  ) });
}
function l8(e) {
  const {
    title: o,
    tabs: t,
    currentTab: r,
    onTabChange: i,
    highlight: d,
    links: s,
    linksError: C,
    onLinkOpen: u,
    banner: m,
    actions: h,
    aside: b,
    note: k,
    children: f,
    strings: y,
    fontSize: _ = 16,
    className: S
  } = e, T = { ...f6, ...y }, [H, z] = w.useState(0), W = r ?? H, Y = (D) => {
    z(D), i?.(D);
  };
  return /* @__PURE__ */ c(r6, { className: S, children: [
    /* @__PURE__ */ c(i6, { className: "card-header header", children: [
      m,
      /* @__PURE__ */ c(p, { children: [
        /* @__PURE__ */ c("div", { className: "card-header-content", children: [
          /* @__PURE__ */ c(p, { children: [
            /* @__PURE__ */ n(x, { component: "div", variant: "subtitle1", noWrap: !0, children: o }),
            h
          ] }),
          b
        ] }),
        k
      ] }),
      !f && t.length > 1 && /* @__PURE__ */ n(m6, { tabs: t, currentIndex: W, onChange: Y }),
      (s || C) && /* @__PURE__ */ n(
        h6,
        {
          label: T.links,
          links: s ?? [],
          error: C,
          onOpen: u
        }
      )
    ] }),
    f || /* @__PURE__ */ n(a6, { fontSize: _, children: t.map((D, O) => (
      // Every tab is in the DOM and all but one hidden, which is what a tab panel is; the
      // blocks of a hidden one are not rendered, so no editor is built for content
      // nobody is looking at.
      /* @__PURE__ */ n(
        p,
        {
          role: "tabpanel",
          hidden: W !== O,
          className: "cogneed-content",
          children: W === O && D.blocks.map((B) => /* @__PURE__ */ n(
            g6,
            {
              content: S2(B.content, d),
              title: B.title || T.moreInfo,
              collapsible: B.collapsible,
              emptyText: T.emptyTab
            },
            B.id
          ))
        },
        D.id
      )
    )) })
  ] });
}
const b6 = l(p)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  width: "100%",
  "& .count": {
    fontSize: 14,
    lineHeight: 1,
    color: a[400],
    textAlign: "right"
  },
  // The pinned "whole card" row sits outside `.list` on purpose: it must stay put while only
  // the tabs below it scroll.
  "& .row.pinned": {
    marginBottom: 2
  },
  "& .list": {
    maxHeight: 200,
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "4px 0"
  },
  "& .row": {
    // Resets for the native <button> these rows render as -- kept clickable/keyboard-operable
    // for free, rather than reimplementing key handling on a <div>.
    border: "none",
    background: "none",
    width: "100%",
    textAlign: "left",
    fontFamily: "inherit",
    flex: "none",
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "9px 10px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14,
    lineHeight: 1.2,
    color: a[500],
    minWidth: 0,
    "& .row-title": {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    "& .row-hint": {
      fontSize: 14,
      lineHeight: 1,
      color: a[400],
      flexShrink: 0
    },
    "&:hover": {
      background: a[100]
    },
    "&.highlighted": {
      background: a[100]
    },
    "&.pinned": {
      background: g[100],
      "& .row-title": { fontWeight: 600, color: g[700] }
    },
    "&.selected": {
      background: g[500],
      "&:hover, &.highlighted": { background: g[500] },
      "& .row-title": { fontWeight: 600, color: "#fff" },
      "& .row-hint": { color: "#fff" }
    }
  },
  "& .row-ghost": {
    flex: "none",
    height: 12,
    margin: "0 10px",
    borderRadius: 3,
    background: a[100],
    animation: "tabPickerGhostPulse 1.4s ease-in-out infinite"
  },
  "@keyframes tabPickerGhostPulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.45 },
    "100%": { opacity: 1 }
  },
  "@media (prefers-reduced-motion: reduce)": {
    "& .row-ghost": { animation: "none" }
  },
  "& .footer": {
    display: "flex",
    alignItems: "center",
    gap: 8,
    paddingTop: 6,
    borderTop: `1px solid ${a[100]}`,
    "& .help": {
      flex: 1,
      fontSize: 12,
      lineHeight: 1.3,
      color: a[400]
    }
  }
}), K = void 0, x6 = ["62%", "45%", "74%"];
function d8({
  tabs: e,
  value: o,
  onChange: t,
  wholeCardLabel: r,
  wholeCardHint: i,
  countLabel: d,
  helpLabel: s,
  autoFocus: C = !0,
  loading: u
}) {
  const m = w.useMemo(() => [K, ...e.map((f) => f.id)], [e]), [h, b] = w.useState(0), k = w.useRef(null);
  return w.useEffect(() => {
    C && k.current?.focus();
  }, [C]), /* @__PURE__ */ c(
    b6,
    {
      ref: k,
      tabIndex: 0,
      onKeyDown: (f) => {
        f.key === "ArrowDown" ? (f.preventDefault(), b((y) => Math.min(y + 1, m.length - 1))) : f.key === "ArrowUp" ? (f.preventDefault(), b((y) => Math.max(y - 1, 0))) : f.key === "Enter" && (f.preventDefault(), t(m[h]));
      },
      children: [
        !u && /* @__PURE__ */ n("span", { className: "count", children: d(e.length) }),
        /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            className: I("row", "pinned", { selected: o === K, highlighted: h === 0 }),
            onClick: () => t(K),
            children: [
              /* @__PURE__ */ n("span", { className: "row-title", children: r }),
              /* @__PURE__ */ n("span", { className: "row-hint", children: o === K ? "✓" : i })
            ]
          }
        ),
        /* @__PURE__ */ n("div", { className: "list", children: u ? x6.map((f) => /* @__PURE__ */ n("span", { className: "row-ghost", style: { width: f } }, f)) : e.map((f, y) => /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            className: I("row", { selected: o === f.id, highlighted: h === y + 1 }),
            onClick: () => t(f.id),
            title: f.title,
            children: [
              /* @__PURE__ */ n("span", { className: "row-title", children: f.title }),
              o === f.id && /* @__PURE__ */ n("span", { className: "row-hint", children: "✓" })
            ]
          },
          f.id
        )) }),
        /* @__PURE__ */ n("div", { className: "footer", children: /* @__PURE__ */ n("span", { className: "help", children: s }) })
      ]
    }
  );
}
export {
  Ne as $,
  u0 as A,
  Bo as B,
  l8 as C,
  g0 as D,
  Wo as E,
  Re as F,
  e2 as G,
  he as H,
  Co as I,
  so as J,
  qo as K,
  go as L,
  ao as M,
  h0 as N,
  G as O,
  ho as P,
  fo as Q,
  a8 as R,
  S1 as S,
  yo as T,
  $o as U,
  lo as V,
  Ro as W,
  zo as X,
  So as Y,
  T0 as Z,
  Oo as _,
  Vo as a,
  i2 as a0,
  N3 as a1,
  H3 as a2,
  Go as a3,
  Xo as a4,
  Ko as a5,
  r8 as a6,
  i8 as a7,
  Qo as a8,
  o8 as a9,
  G1 as aA,
  V1 as aB,
  O1 as aC,
  e8 as aD,
  P3 as aE,
  R3 as aF,
  Ye as aG,
  Ke as aH,
  t8 as aa,
  Jo as ab,
  n8 as ac,
  mo as ad,
  M1 as ae,
  bo as af,
  Lo as ag,
  Fo as ah,
  xo as ai,
  r2 as aj,
  No as ak,
  d8 as al,
  To as am,
  S0 as an,
  a2 as ao,
  Ze as ap,
  f6 as aq,
  o2 as ar,
  A3 as as,
  T3 as at,
  L3 as au,
  te as av,
  qe as aw,
  B1 as ax,
  J0 as ay,
  ne as az,
  Io as b,
  Do as c,
  ko as d,
  co as e,
  vo as f,
  wo as g,
  Mo as h,
  _o as i,
  Uo as j,
  Eo as k,
  Po as l,
  le as m,
  Ao as n,
  jo as o,
  g1 as p,
  f1 as q,
  J3 as r,
  Zo as s,
  Q3 as t,
  Yo as u,
  po as v,
  uo as w,
  y1 as x,
  Ho as y,
  be as z
};
//# sourceMappingURL=index-8utjttr0.js.map
